/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Operations from './operation';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: string;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
  /** Represents untyped JSON */
  JSON: string | number | boolean | null | object | Array<any>;
  Upload: File;
  /** A valid URL, transported as a string */
  Url: string;
};

/** Autogenerated input type of ActivateOnlinePlusLessonByUserId */
export type ActivateOnlinePlusLessonByUserIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 閲覧権を付与する PlusLesson の ID */
  readonly onlinePlusLessonId: Scalars['ID'];
  /** 閲覧権を付与するユーザーの ID */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of ActivateOnlinePlusLessonByUserId. */
export type ActivateOnlinePlusLessonByUserIdPayload = {
  readonly __typename?: 'ActivateOnlinePlusLessonByUserIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineUserPlusLessonActivation?: Maybe<UserPlusLessonActivation>;
};

/** Autogenerated input type of ActivateOnlinePlusLesson */
export type ActivateOnlinePlusLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly onlinePlusLessonId: Scalars['ID'];
};

/** Autogenerated return type of ActivateOnlinePlusLesson. */
export type ActivateOnlinePlusLessonPayload = {
  readonly __typename?: 'ActivateOnlinePlusLessonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlinePlusLesson?: Maybe<PlusLesson>;
};

/** 決済状況に応じた有効化状態 */
export const ActivationStatus = {
  /** 有効 */
  Active: 'ACTIVE',
  /** 条件により停止 */
  ConditionallyDeactivated: 'CONDITIONALLY_DEACTIVATED',
  /** 無条件で停止 */
  UnconditionallyDeactivated: 'UNCONDITIONALLY_DEACTIVATED'
} as const;

export type ActivationStatus = typeof ActivationStatus[keyof typeof ActivationStatus];
export type Activity = {
  readonly __typename?: 'Activity';
  readonly category: Category;
  readonly id: Scalars['ID'];
  readonly key: ActivityKey;
  readonly name: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly required: Scalars['Boolean'];
  readonly show: Scalars['Boolean'];
  readonly subCategory?: Maybe<SubCategory>;
};

export type ActivityCategorySummary = {
  readonly __typename?: 'ActivityCategorySummary';
  readonly activities: ReadonlyArray<ActivitySummary>;
  readonly completed: Scalars['Boolean'];
  readonly endDate?: Maybe<Scalars['ISO8601Date']>;
  readonly estimation: Scalars['String'];
  readonly estimationNumber: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly key: CategoryKey;
  readonly name: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly regularPlanCompletionCondition: Scalars['Boolean'];
  readonly startDate?: Maybe<Scalars['ISO8601Date']>;
};

export const ActivityKey = {
  BusinessSkillsIntroductionCourseCommunicationCompleted: 'BUSINESS_SKILLS_INTRODUCTION_COURSE_COMMUNICATION_COMPLETED',
  BusinessSkillsIntroductionCoursePresentationCompleted: 'BUSINESS_SKILLS_INTRODUCTION_COURSE_PRESENTATION_COMPLETED',
  BusinessSkillsIntroductionCourseThoughtTrainingCompleted: 'BUSINESS_SKILLS_INTRODUCTION_COURSE_THOUGHT_TRAINING_COMPLETED',
  CareerCounseling_1Attended: 'CAREER_COUNSELING_1_ATTENDED',
  CareerCounseling_2Attended: 'CAREER_COUNSELING_2_ATTENDED',
  CareerCounseling_3Attended: 'CAREER_COUNSELING_3_ATTENDED',
  CareerDesignCourseJobChangeWatched: 'CAREER_DESIGN_COURSE_JOB_CHANGE_WATCHED',
  CareerDesignCourseStartDashWatched: 'CAREER_DESIGN_COURSE_START_DASH_WATCHED',
  CareerDesignCourseWorksheet_1Submitted: 'CAREER_DESIGN_COURSE_WORKSHEET_1_SUBMITTED',
  CareerDesignCourseWorksheet_2Submitted: 'CAREER_DESIGN_COURSE_WORKSHEET_2_SUBMITTED',
  Course_15HoursWatched: 'COURSE_15_HOURS_WATCHED',
  CurrentSalaryDocumentSubmitted: 'CURRENT_SALARY_DOCUMENT_SUBMITTED',
  EmploymentContinuationReportFormSubmitted: 'EMPLOYMENT_CONTINUATION_REPORT_FORM_SUBMITTED',
  EntranceCeremonyAttended: 'ENTRANCE_CEREMONY_ATTENDED',
  IdentityVerificationDocumentsSubmitted: 'IDENTITY_VERIFICATION_DOCUMENTS_SUBMITTED',
  NewJobInformationDocumentSubmitted: 'NEW_JOB_INFORMATION_DOCUMENT_SUBMITTED',
  OrientationTestPassed: 'ORIENTATION_TEST_PASSED',
  OrientationVideoWatched: 'ORIENTATION_VIDEO_WATCHED',
  PersonalSummaryLatestSubmitted: 'PERSONAL_SUMMARY_LATEST_SUBMITTED',
  ProjectManagementCourseCompleted: 'PROJECT_MANAGEMENT_COURSE_COMPLETED',
  RegularPlanSurveySubmitted: 'REGULAR_PLAN_SURVEY_SUBMITTED',
  ResumeLatestSubmitted: 'RESUME_LATEST_SUBMITTED',
  SeoWritingCoursePracticalExamPassed: 'SEO_WRITING_COURSE_PRACTICAL_EXAM_PASSED',
  SeoWritingCourseTaskSubmitted: 'SEO_WRITING_COURSE_TASK_SUBMITTED',
  SnsMarketerTrainingProgramsFinalTaskSubmitted: 'SNS_MARKETER_TRAINING_PROGRAMS_FINAL_TASK_SUBMITTED',
  TwelveMonthsLaterSalaryDocumentSubmitted: 'TWELVE_MONTHS_LATER_SALARY_DOCUMENT_SUBMITTED',
  WebDesinerTrainingProgramsFinalTaskSubmitted: 'WEB_DESINER_TRAINING_PROGRAMS_FINAL_TASK_SUBMITTED'
} as const;

export type ActivityKey = typeof ActivityKey[keyof typeof ActivityKey];
export type ActivitySummary = {
  readonly __typename?: 'ActivitySummary';
  readonly completed: Scalars['Boolean'];
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly key: ActivityKey;
  readonly name: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly required: Scalars['Boolean'];
  readonly show: Scalars['Boolean'];
  readonly subCategory?: Maybe<SubCategory>;
};

/** Autogenerated input type of AddFavorite */
export type AddFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['ID'];
  readonly itemType: FavoriteType;
};

/** Autogenerated return type of AddFavorite. */
export type AddFavoritePayload = {
  readonly __typename?: 'AddFavoritePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** 公的書類提出時のユーザー情報変更リクエスト */
export type AdditionalDocumentProfileRequest = {
  readonly __typename?: 'AdditionalDocumentProfileRequest';
  readonly additionalIdentityDocument: AdditionalIdentityDocument;
  readonly address: Scalars['String'];
  readonly birthday: Scalars['String'];
  readonly building?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly firstNameKana: Scalars['String'];
  readonly fullAddress: Scalars['String'];
  readonly fullname: Scalars['String'];
  readonly fullnameKana: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly lastNameKana: Scalars['String'];
  readonly prefecture: Scalars['String'];
  readonly zipcode: Scalars['String'];
};

export const AdditionalIdentification = {
  DriversLicense: 'DRIVERS_LICENSE',
  IdentityNumber: 'IDENTITY_NUMBER',
  MedicareCardAndResidenceCertificate: 'MEDICARE_CARD_AND_RESIDENCE_CERTIFICATE'
} as const;

export type AdditionalIdentification = typeof AdditionalIdentification[keyof typeof AdditionalIdentification];
export const AdditionalIdentificationDocumentImage = {
  DriversLicense: 'DRIVERS_LICENSE',
  DriversLicenseBack: 'DRIVERS_LICENSE_BACK',
  DriversLicenseFront: 'DRIVERS_LICENSE_FRONT',
  IdentityNumberFront: 'IDENTITY_NUMBER_FRONT',
  MedicareCardBack: 'MEDICARE_CARD_BACK',
  MedicareCardFront: 'MEDICARE_CARD_FRONT',
  ResidenceCertificate: 'RESIDENCE_CERTIFICATE'
} as const;

export type AdditionalIdentificationDocumentImage = typeof AdditionalIdentificationDocumentImage[keyof typeof AdditionalIdentificationDocumentImage];
export type AdditionalIdentityDocument = {
  readonly __typename?: 'AdditionalIdentityDocument';
  readonly additionalDocumentProfileRequest?: Maybe<AdditionalDocumentProfileRequest>;
  readonly additionalIdentityDocumentFiles: ReadonlyArray<AdditionalIdentityDocumentFile>;
  readonly additionalIdentityDocumentReview?: Maybe<AdditionalIdentityDocumentReview>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly identificationType: AdditionalIdentification;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** 公的書類をアップロードしたユーザー */
  readonly user: User;
};

/** The connection type for AdditionalIdentityDocument. */
export type AdditionalIdentityDocumentConnection = {
  readonly __typename?: 'AdditionalIdentityDocumentConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<AdditionalIdentityDocumentEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<AdditionalIdentityDocument>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AdditionalIdentityDocumentEdge = {
  readonly __typename?: 'AdditionalIdentityDocumentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: AdditionalIdentityDocument;
};

export type AdditionalIdentityDocumentFile = {
  readonly __typename?: 'AdditionalIdentityDocumentFile';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly identificationType: AdditionalIdentificationDocumentImage;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type AdditionalIdentityDocumentReview = {
  readonly __typename?: 'AdditionalIdentityDocumentReview';
  readonly approved: Scalars['Boolean'];
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly reviewer: User;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type AdditionalTotalAmount = {
  readonly __typename?: 'AdditionalTotalAmount';
  readonly paymentAmount: Scalars['Int'];
  readonly rewardAmount: Scalars['Int'];
};

export const Affiliate = {
  Affiliate: 'AFFILIATE',
  Dream: 'DREAM'
} as const;

export type Affiliate = typeof Affiliate[keyof typeof Affiliate];
/** Autogenerated input type of AgreeToTerms */
export type AgreeToTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly serviceTypes: ReadonlyArray<TermServiceType>;
};

/** Autogenerated return type of AgreeToTerms. */
export type AgreeToTermsPayload = {
  readonly __typename?: 'AgreeToTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

export type AiChatConversation = {
  readonly __typename?: 'AiChatConversation';
  readonly aiChatRoom: AiChatRoom;
  readonly aiChatRoomId: Scalars['ID'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly message: Scalars['String'];
  readonly responseMetadata: ResponseMetadata;
  readonly sender: ConversationSender;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for AiChatConversation. */
export type AiChatConversationConnection = {
  readonly __typename?: 'AiChatConversationConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<AiChatConversationEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<AiChatConversation>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AiChatConversationEdge = {
  readonly __typename?: 'AiChatConversationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: AiChatConversation;
};

export type AiChatRoom = {
  readonly __typename?: 'AiChatRoom';
  readonly aiChatConversations?: Maybe<AiChatConversationConnection>;
  readonly conversationStatus: ConversationStatus;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly prompt: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user: Scalars['String'];
};


export type AiChatRoomAiChatConversationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for AiChatRoom. */
export type AiChatRoomConnection = {
  readonly __typename?: 'AiChatRoomConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<AiChatRoomEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<AiChatRoom>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AiChatRoomEdge = {
  readonly __typename?: 'AiChatRoomEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: AiChatRoom;
};

/** Autogenerated input type of AppendMoneyTrainingProgramGroupsToUser */
export type AppendMoneyTrainingProgramGroupsToUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly moneyTrainingProgramGroupIds: ReadonlyArray<Scalars['ID']>;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of AppendMoneyTrainingProgramGroupsToUser. */
export type AppendMoneyTrainingProgramGroupsToUserPayload = {
  readonly __typename?: 'AppendMoneyTrainingProgramGroupsToUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly user: User;
};

/** Autogenerated input type of ApplyForGettingOffersProgram */
export type ApplyForGettingOffersProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 初回1on1セッションのID */
  readonly firstSessionId: Scalars['ID'];
  /** 規約に同意したか */
  readonly hasAgreedToTerms: Scalars['Boolean'];
  /** 分割回数（1回/2回） */
  readonly installmentCount: Scalars['Int'];
};

/** Autogenerated return type of ApplyForGettingOffersProgram. */
export type ApplyForGettingOffersProgramPayload = {
  readonly __typename?: 'ApplyForGettingOffersProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  /** エラーメッセージ（任意） */
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  /** 申し込みが成功したかどうか */
  readonly success: Scalars['Boolean'];
};

export type ApplyShemateCertificationAlreadyApplied = {
  readonly __typename?: 'ApplyShemateCertificationAlreadyApplied';
  readonly _?: Maybe<Scalars['Boolean']>;
};

export type ApplyShemateCertificationApplicationClosed = {
  readonly __typename?: 'ApplyShemateCertificationApplicationClosed';
  readonly _?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ApplyShemateCertification */
export type ApplyShemateCertificationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** ShemateCertificationのID（例: 'creator'） */
  readonly shemateCertificationId: Scalars['String'];
};

export type ApplyShemateCertificationPayload = ApplyShemateCertificationAlreadyApplied | ApplyShemateCertificationApplicationClosed | ApplyShemateCertificationSuccess;

export type ApplyShemateCertificationSuccess = {
  readonly __typename?: 'ApplyShemateCertificationSuccess';
  readonly shemateCertificationApplication: ShemateCertificationApplication;
};

/** Autogenerated input type of ApproveOrderCancelRequest */
export type ApproveOrderCancelRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly orderCancelRequestId: Scalars['ID'];
};

/** Autogenerated return type of ApproveOrderCancelRequest. */
export type ApproveOrderCancelRequestPayload = {
  readonly __typename?: 'ApproveOrderCancelRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly orderCancelRequest?: Maybe<OrderCancelRequest>;
};

/** Autogenerated input type of ApproveRewardRequest */
export type ApproveRewardRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly rewardRequestId: Scalars['ID'];
};

/** Autogenerated return type of ApproveRewardRequest. */
export type ApproveRewardRequestPayload = {
  readonly __typename?: 'ApproveRewardRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly rewardRequest?: Maybe<RewardRequest>;
};

export type ApprovedAdditionalIdentityDocument = {
  readonly __typename?: 'ApprovedAdditionalIdentityDocument';
  readonly additionalIdentityDocumentId: Scalars['ID'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly files: ReadonlyArray<ApprovedAdditionalIdentityDocumentFile>;
  readonly id: Scalars['ID'];
  readonly identificationType: AdditionalIdentification;
  readonly profile?: Maybe<ApprovedAdditionalIdentityDocumentProfile>;
  /** 承認者 */
  readonly reviewer?: Maybe<User>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** 書類の所有者 */
  readonly user: User;
};

export type ApprovedAdditionalIdentityDocumentFile = {
  readonly __typename?: 'ApprovedAdditionalIdentityDocumentFile';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly fileUrl?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly identificationType: AdditionalIdentificationDocumentImage;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type ApprovedAdditionalIdentityDocumentProfile = {
  readonly __typename?: 'ApprovedAdditionalIdentityDocumentProfile';
  readonly address?: Maybe<Scalars['String']>;
  readonly birthday?: Maybe<Scalars['ISO8601Date']>;
  readonly building?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly firstName?: Maybe<Scalars['String']>;
  readonly firstNameKana?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName?: Maybe<Scalars['String']>;
  readonly lastNameKana?: Maybe<Scalars['String']>;
  readonly prefecture?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly zipcode?: Maybe<Scalars['String']>;
};

export const Asis = {
  DiscontentWorkEnvironment: 'DISCONTENT_WORK_ENVIRONMENT',
  DissatisfactionWorkHours: 'DISSATISFACTION_WORK_HOURS',
  IncomeDissatisfaction: 'INCOME_DISSATISFACTION',
  NotPassionate: 'NOT_PASSIONATE',
  NoGrowthFeeling: 'NO_GROWTH_FEELING',
  Other: 'OTHER',
  RelationshipIssues: 'RELATIONSHIP_ISSUES'
} as const;

export type Asis = typeof Asis[keyof typeof Asis];
export type Badge = {
  readonly __typename?: 'Badge';
  readonly description: Scalars['String'];
  readonly key: BadgeKey;
  readonly maxLevel: Scalars['Int'];
  readonly position: Scalars['Int'];
  readonly title: Scalars['String'];
};

export type BadgeBackfilledNotification = PopupNotification & {
  readonly __typename?: 'BadgeBackfilledNotification';
  readonly gid: Scalars['ID'];
};

export const BadgeCategory = {
  ChallengeJobs: 'CHALLENGE_JOBS',
  MakeHabit: 'MAKE_HABIT',
  SetUpLearningEnvironment: 'SET_UP_LEARNING_ENVIRONMENT',
  TakeCourses: 'TAKE_COURSES',
  UseShelikes: 'USE_SHELIKES'
} as const;

export type BadgeCategory = typeof BadgeCategory[keyof typeof BadgeCategory];
export type BadgeEarnedNotification = PopupNotification & {
  readonly __typename?: 'BadgeEarnedNotification';
  readonly gid: Scalars['ID'];
  readonly userBadge: UserBadge;
};

export const BadgeKey = {
  DreamMap: 'DREAM_MAP',
  FirstCoaching: 'FIRST_COACHING',
  FirstCommunityEvent: 'FIRST_COMMUNITY_EVENT',
  FirstCourse: 'FIRST_COURSE',
  FirstEvent: 'FIRST_EVENT',
  FirstGoalSetting: 'FIRST_GOAL_SETTING',
  FirstLesson: 'FIRST_LESSON',
  FirstLessonHomework: 'FIRST_LESSON_HOMEWORK',
  FirstMokumoku: 'FIRST_MOKUMOKU',
  FirstSheCompetition: 'FIRST_SHE_COMPETITION',
  HowToUseShelikesServiceEdition: 'HOW_TO_USE_SHELIKES_SERVICE_EDITION',
  IntroductionToMarketing: 'INTRODUCTION_TO_MARKETING',
  IntroductionToWebDesign: 'INTRODUCTION_TO_WEB_DESIGN',
  IntroductionToWriting: 'INTRODUCTION_TO_WRITING',
  JoinedShelikes: 'JOINED_SHELIKES',
  PassPcSkillTest: 'PASS_PC_SKILL_TEST',
  PhotoshopBannerCreateEdition: 'PHOTOSHOP_BANNER_CREATE_EDITION',
  PhotoshopOperationEdition: 'PHOTOSHOP_OPERATION_EDITION',
  ReflectionSetting: 'REFLECTION_SETTING',
  SocialProfile: 'SOCIAL_PROFILE',
  SocialProfileWork: 'SOCIAL_PROFILE_WORK',
  SocialXAccountConnected: 'SOCIAL_X_ACCOUNT_CONNECTED',
  VisitSheStation: 'VISIT_SHE_STATION',
  WeeklyLearning: 'WEEKLY_LEARNING'
} as const;

export type BadgeKey = typeof BadgeKey[keyof typeof BadgeKey];
export type BadgeWithEarnedInfo = {
  readonly badge: Badge;
};

export type BankAccount = {
  readonly __typename?: 'BankAccount';
  readonly accountHolderName: Scalars['String'];
  readonly accountNumber: Scalars['String'];
  readonly accountType: BankAccountType;
  readonly bankAccountReview?: Maybe<BankAccountReview>;
  readonly bankCode: Scalars['String'];
  readonly branchCode: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** 銀行口座情報をアップロードしたユーザー */
  readonly user: User;
};

/** The connection type for BankAccount. */
export type BankAccountConnection = {
  readonly __typename?: 'BankAccountConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<BankAccountEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<BankAccount>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BankAccountEdge = {
  readonly __typename?: 'BankAccountEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: BankAccount;
};

export type BankAccountReview = {
  readonly __typename?: 'BankAccountReview';
  readonly approved: Scalars['Boolean'];
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly reviewer: User;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const BankAccountType = {
  Checking: 'CHECKING',
  Saving: 'SAVING'
} as const;

export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType];
export type Bill = {
  readonly __typename?: 'Bill';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file?: Maybe<BillFile>;
  readonly id: Scalars['ID'];
  readonly status: BillStatus;
};

/** The connection type for Bill. */
export type BillConnection = {
  readonly __typename?: 'BillConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<BillEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Bill>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BillEdge = {
  readonly __typename?: 'BillEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Bill;
};

export type BillFile = {
  readonly __typename?: 'BillFile';
  readonly safeHtml?: Maybe<Scalars['String']>;
  readonly url?: Maybe<Scalars['String']>;
};

export const BillStatus = {
  Billing: 'BILLING',
  Enqueued: 'ENQUEUED',
  Failed: 'FAILED',
  Succeeded: 'SUCCEEDED'
} as const;

export type BillStatus = typeof BillStatus[keyof typeof BillStatus];
export type Block = {
  readonly __typename?: 'Block';
  readonly blockType: BlockType;
  readonly content: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly publishedAndDraftStudyFaqs: ReadonlyArray<StudyFaq>;
  readonly publishedStudyFaqs: ReadonlyArray<StudyFaq>;
  readonly section: Section;
  readonly studyFaqs: ReadonlyArray<StudyFaq>;
  readonly title: Scalars['String'];
  readonly videoDurationSeconds: Scalars['Int'];
};

export const BlockType = {
  Image: 'IMAGE',
  Slideshow: 'SLIDESHOW',
  Video: 'VIDEO'
} as const;

export type BlockType = typeof BlockType[keyof typeof BlockType];
export type CancelPenaltyItem = {
  readonly __typename?: 'CancelPenaltyItem';
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
  readonly price: Scalars['Int'];
};

export type CareerChange = {
  readonly __typename?: 'CareerChange';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly jobChangeOn: Scalars['ISO8601Date'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly userId: Scalars['ID'];
};

export type CareerCounseling = {
  readonly __typename?: 'CareerCounseling';
  readonly allChecked: Scalars['Boolean'];
  readonly counselingKey: CounselingKey;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly memo: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly zoomPasscode: Scalars['String'];
  readonly zoomUrl: Scalars['String'];
};

export type CareerCounselingContent = {
  readonly __typename?: 'CareerCounselingContent';
  readonly counselingKey: CareerCounselingKey;
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
};

export type CareerCounselingEntry = {
  readonly __typename?: 'CareerCounselingEntry';
  readonly careerCounselor: User;
  readonly counselingKey: CareerCounselingKey;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly latestReport?: Maybe<CareerCounselingReport>;
  readonly reports: ReadonlyArray<CareerCounselingReport>;
  readonly reservation: Reservation;
  readonly status: CareerCounselingStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user: User;
};

/** The connection type for CareerCounselingEntry. */
export type CareerCounselingEntryConnection = {
  readonly __typename?: 'CareerCounselingEntryConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<CareerCounselingEntryEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<CareerCounselingEntry>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CareerCounselingEntryEdge = {
  readonly __typename?: 'CareerCounselingEntryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: CareerCounselingEntry;
};

export type CareerCounselingEntryReviewInput = {
  readonly ok: Scalars['Boolean'];
  readonly reviewItemId: Scalars['ID'];
};

export type CareerCounselingFirstReview = {
  readonly __typename?: 'CareerCounselingFirstReview';
  readonly approve: Scalars['Boolean'];
  readonly careerCounselingReport: CareerCounselingReport;
  readonly checks: ReadonlyArray<CareerCounselingFirstReviewCheck>;
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly reviewedAt: Scalars['ISO8601DateTime'];
  readonly reviewer: User;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type CareerCounselingFirstReviewCheck = {
  readonly __typename?: 'CareerCounselingFirstReviewCheck';
  readonly careerCounselingFirstReview: CareerCounselingFirstReview;
  readonly id: Scalars['ID'];
  readonly ok: Scalars['Boolean'];
  readonly reviewItem: CareerCounselingFirstReviewItem;
};

export type CareerCounselingFirstReviewItem = {
  readonly __typename?: 'CareerCounselingFirstReviewItem';
  readonly counselingKey: CareerCounselingKey;
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
};

export type CareerCounselingKey = {
  readonly __typename?: 'CareerCounselingKey';
  readonly contents: ReadonlyArray<CareerCounselingContent>;
  readonly firstReviewItems: ReadonlyArray<CareerCounselingFirstReviewItem>;
  readonly id: Scalars['ID'];
  readonly key: CounselingKey;
  readonly name: Scalars['String'];
  readonly preReviewItems: ReadonlyArray<CareerCounselingPreReviewItem>;
  readonly secondReviewItems: ReadonlyArray<CareerCounselingSecondReviewItem>;
};

export type CareerCounselingPreReview = {
  readonly __typename?: 'CareerCounselingPreReview';
  readonly careerCounselingReport: CareerCounselingReport;
  readonly checks: ReadonlyArray<CareerCounselingPreReviewCheck>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type CareerCounselingPreReviewCheck = {
  readonly __typename?: 'CareerCounselingPreReviewCheck';
  readonly careerCounselingPreReview: CareerCounselingPreReview;
  readonly id: Scalars['ID'];
  readonly ok: Scalars['Boolean'];
  readonly reviewItem: CareerCounselingPreReviewItem;
};

export type CareerCounselingPreReviewItem = {
  readonly __typename?: 'CareerCounselingPreReviewItem';
  readonly counselingKey: CareerCounselingKey;
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
};

export type CareerCounselingReport = {
  readonly __typename?: 'CareerCounselingReport';
  readonly additionalMemo?: Maybe<Scalars['String']>;
  readonly allChecked: Scalars['Boolean'];
  readonly careerCounselingEntry: CareerCounselingEntry;
  readonly content: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly evidenceDocument?: Maybe<SensitiveFile>;
  readonly firstReview?: Maybe<CareerCounselingFirstReview>;
  readonly id: Scalars['ID'];
  readonly internalMemo?: Maybe<Scalars['String']>;
  readonly nextAppointmentCompleted?: Maybe<Scalars['Boolean']>;
  readonly nextAppointmentReason?: Maybe<Scalars['String']>;
  readonly preReview?: Maybe<CareerCounselingPreReview>;
  readonly secondReview?: Maybe<CareerCounselingSecondReview>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly version: Scalars['Int'];
  readonly zoomPasscode: Scalars['String'];
  readonly zoomUrl: Scalars['String'];
};

export type CareerCounselingSecondReview = {
  readonly __typename?: 'CareerCounselingSecondReview';
  readonly approve: Scalars['Boolean'];
  readonly careerCounselingReport: CareerCounselingReport;
  readonly checks: ReadonlyArray<CareerCounselingSecondReviewCheck>;
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly reviewedAt: Scalars['ISO8601DateTime'];
  readonly reviewer: User;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type CareerCounselingSecondReviewCheck = {
  readonly __typename?: 'CareerCounselingSecondReviewCheck';
  readonly careerCounselingSecondReview: CareerCounselingSecondReview;
  readonly id: Scalars['ID'];
  readonly ok: Scalars['Boolean'];
  readonly reviewItem: CareerCounselingSecondReviewItem;
};

export type CareerCounselingSecondReviewItem = {
  readonly __typename?: 'CareerCounselingSecondReviewItem';
  readonly counselingKey: CareerCounselingKey;
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
};

export const CareerCounselingStatus = {
  Completed: 'COMPLETED',
  Error: 'ERROR',
  FirstReviewing: 'FIRST_REVIEWING',
  NotSubmitted: 'NOT_SUBMITTED',
  Rejected: 'REJECTED',
  SecondReviewing: 'SECOND_REVIEWING'
} as const;

export type CareerCounselingStatus = typeof CareerCounselingStatus[keyof typeof CareerCounselingStatus];
export type Category = {
  readonly __typename?: 'Category';
  readonly activities: ReadonlyArray<Activity>;
  readonly estimation: Scalars['String'];
  readonly estimationNumber: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly key: CategoryKey;
  readonly name: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly regularPlanCompletionCondition: Scalars['Boolean'];
  readonly subCategories: ReadonlyArray<SubCategory>;
};

export const CategoryKey = {
  CompleteCareerCounseling_1: 'COMPLETE_CAREER_COUNSELING_1',
  CompleteCareerCounseling_2: 'COMPLETE_CAREER_COUNSELING_2',
  CompleteCareerCounseling_3: 'COMPLETE_CAREER_COUNSELING_3',
  CompleteCourse_15Hours: 'COMPLETE_COURSE_15_HOURS',
  CompleteEmploymentContinuationReportForm: 'COMPLETE_EMPLOYMENT_CONTINUATION_REPORT_FORM',
  CompleteEntranceCeremony: 'COMPLETE_ENTRANCE_CEREMONY',
  CompleteJobChange: 'COMPLETE_JOB_CHANGE',
  CompleteJobChangeCompletedDocument: 'COMPLETE_JOB_CHANGE_COMPLETED_DOCUMENT',
  CompleteRequiredDocumentsSubmitted: 'COMPLETE_REQUIRED_DOCUMENTS_SUBMITTED',
  CompleteTrainingPrograms: 'COMPLETE_TRAINING_PROGRAMS'
} as const;

export type CategoryKey = typeof CategoryKey[keyof typeof CategoryKey];
/** Autogenerated input type of ChangePaymentSchedulePaymentMethod */
export type ChangePaymentSchedulePaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly paymentMethod: PaymentMethod;
  readonly paymentScheduleId: Scalars['ID'];
};

/** Autogenerated return type of ChangePaymentSchedulePaymentMethod. */
export type ChangePaymentSchedulePaymentMethodPayload = {
  readonly __typename?: 'ChangePaymentSchedulePaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly paymentSchedule?: Maybe<PaymentSchedule>;
};

export type Choice = {
  readonly __typename?: 'Choice';
  readonly finishReason: Scalars['String'];
  readonly index: Scalars['Int'];
  readonly logprobs?: Maybe<Scalars['String']>;
  readonly message: Message;
};

/** Autogenerated input type of CloseResumeCoachmark */
export type CloseResumeCoachmarkInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CloseResumeCoachmark. */
export type CloseResumeCoachmarkPayload = {
  readonly __typename?: 'CloseResumeCoachmarkPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

export type Coach = {
  readonly __typename?: 'Coach';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly profile: Scalars['String'];
  readonly profilePhotoUrl: Scalars['String'];
  readonly title: Scalars['String'];
};

export type CoachPosition = {
  readonly __typename?: 'CoachPosition';
  readonly coachPositionSpec: CoachPositionSpec;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly session: Session;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user?: Maybe<User>;
};

export type CoachPositionSpec = {
  readonly __typename?: 'CoachPositionSpec';
  readonly coachSkillType?: Maybe<CoachSkill>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly numberOfPositions?: Maybe<Scalars['Int']>;
  readonly role: Role;
  readonly sessionTemplate: SessionTemplate;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type CoachSkill = {
  readonly __typename?: 'CoachSkill';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type CoachSkillTypeUrls = {
  readonly __typename?: 'CoachSkillTypeUrls';
  readonly coachSkillName: Scalars['String'];
  readonly urls: ReadonlyArray<Scalars['String']>;
};

/** Autogenerated input type of ConfirmAllUnreadNotificationDeliveries */
export type ConfirmAllUnreadNotificationDeliveriesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ConfirmAllUnreadNotificationDeliveries. */
export type ConfirmAllUnreadNotificationDeliveriesPayload = {
  readonly __typename?: 'ConfirmAllUnreadNotificationDeliveriesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of ConfirmPopupNotification */
export type ConfirmPopupNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly gid: Scalars['ID'];
};

/** Autogenerated return type of ConfirmPopupNotification. */
export type ConfirmPopupNotificationPayload = {
  readonly __typename?: 'ConfirmPopupNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly popupNotification?: Maybe<PopupNotification>;
};

export type ContractInfoExport = {
  readonly __typename?: 'ContractInfoExport';
  readonly content: ContractInfoExportContent;
  readonly enrollmentPeriodEndsOn: Scalars['ISO8601Date'];
  readonly enrollmentPeriodStartsOn: Scalars['ISO8601Date'];
  readonly id: Scalars['ID'];
  readonly status: ContractInfoExportStatus;
};

/** The connection type for ContractInfoExport. */
export type ContractInfoExportConnection = {
  readonly __typename?: 'ContractInfoExportConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<ContractInfoExportEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<ContractInfoExport>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

export type ContractInfoExportContent = {
  readonly __typename?: 'ContractInfoExportContent';
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly downloadUrl?: Maybe<Scalars['String']>;
  readonly filename?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type ContractInfoExportEdge = {
  readonly __typename?: 'ContractInfoExportEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: ContractInfoExport;
};

export const ContractInfoExportStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Initial: 'INITIAL',
  Processing: 'PROCESSING'
} as const;

export type ContractInfoExportStatus = typeof ContractInfoExportStatus[keyof typeof ContractInfoExportStatus];
export const ConversationSender = {
  Ai: 'AI',
  User: 'USER'
} as const;

export type ConversationSender = typeof ConversationSender[keyof typeof ConversationSender];
export const ConversationStatus = {
  Error: 'ERROR',
  Success: 'SUCCESS'
} as const;

export type ConversationStatus = typeof ConversationStatus[keyof typeof ConversationStatus];
export const CounselingKey = {
  FirstTime: 'FIRST_TIME',
  SecondTime: 'SECOND_TIME',
  ThirdTime: 'THIRD_TIME'
} as const;

export type CounselingKey = typeof CounselingKey[keyof typeof CounselingKey];
export const CounselingResult = {
  CorporateContract: 'CORPORATE_CONTRACT',
  Entered: 'ENTERED',
  Irregular: 'IRREGULAR',
  Loan: 'LOAN',
  MidwayWithdrawal: 'MIDWAY_WITHDRAWAL',
  NotEntered: 'NOT_ENTERED',
  TrialMembership: 'TRIAL_MEMBERSHIP'
} as const;

export type CounselingResult = typeof CounselingResult[keyof typeof CounselingResult];
export type Coupon = {
  readonly __typename?: 'Coupon';
  readonly code: Scalars['String'];
  readonly couponTemplate?: Maybe<CouponTemplate>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly maxApplications: Scalars['Int'];
  readonly targetEmail?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type CouponDiscount = {
  readonly __typename?: 'CouponDiscount';
  readonly discountAmount: Scalars['Int'];
  readonly discountType: Discount;
  readonly id: Scalars['ID'];
  readonly targetId: Scalars['ID'];
  readonly targetType: PurchasableType;
};

/** The connection type for CouponDiscount. */
export type CouponDiscountConnection = {
  readonly __typename?: 'CouponDiscountConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<CouponDiscountEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<CouponDiscount>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CouponDiscountEdge = {
  readonly __typename?: 'CouponDiscountEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: CouponDiscount;
};

export type CouponTemplate = {
  readonly __typename?: 'CouponTemplate';
  readonly couponDiscounts: CouponDiscountConnection;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};


export type CouponTemplateCouponDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type Course = {
  readonly __typename?: 'Course';
  readonly hasDraft: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isAllLessonsCompletedByCurrentUser: Scalars['Boolean'];
  readonly position: Scalars['Int'];
  readonly publishedRevision: CourseRevision;
};

export type CourseCategory = {
  readonly __typename?: 'CourseCategory';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type CourseCompletionNotification = PopupNotification & {
  readonly __typename?: 'CourseCompletionNotification';
  readonly course: Course;
  readonly gid: Scalars['ID'];
};

/** The connection type for Course. */
export type CourseConnection = {
  readonly __typename?: 'CourseConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<CourseEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Course>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CourseEdge = {
  readonly __typename?: 'CourseEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Course;
};

export type CourseRevision = {
  readonly __typename?: 'CourseRevision';
  readonly categoryName?: Maybe<Scalars['String']>;
  readonly completionCertificate?: Maybe<Scalars['String']>;
  readonly course: Course;
  readonly id: Scalars['ID'];
  readonly thumbnail?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

/** Autogenerated input type of CreateAdditionalIdentityDocumentReview */
export type CreateAdditionalIdentityDocumentReviewInput = {
  readonly additionalIdentityDocumentId: Scalars['ID'];
  readonly approved: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAdditionalIdentityDocumentReview. */
export type CreateAdditionalIdentityDocumentReviewPayload = {
  readonly __typename?: 'CreateAdditionalIdentityDocumentReviewPayload';
  readonly additionalIdentityDocument: AdditionalIdentityDocument;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateAiChatConversation */
export type CreateAiChatConversationInput = {
  readonly aiChatRoomId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly message: Scalars['String'];
};

/** Autogenerated return type of CreateAiChatConversation. */
export type CreateAiChatConversationPayload = {
  readonly __typename?: 'CreateAiChatConversationPayload';
  readonly aiChatConversation?: Maybe<AiChatConversation>;
  readonly aiChatRoom?: Maybe<AiChatRoom>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateAiChatInitialConversation */
export type CreateAiChatInitialConversationInput = {
  readonly aiChatRoomId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly message: Scalars['String'];
};

/** Autogenerated return type of CreateAiChatInitialConversation. */
export type CreateAiChatInitialConversationPayload = {
  readonly __typename?: 'CreateAiChatInitialConversationPayload';
  readonly aiChatConversation?: Maybe<AiChatConversation>;
  readonly aiChatRoom?: Maybe<AiChatRoom>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateAiChatReply */
export type CreateAiChatReplyInput = {
  readonly aiChatRoomId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAiChatReply. */
export type CreateAiChatReplyPayload = {
  readonly __typename?: 'CreateAiChatReplyPayload';
  readonly aiChatConversation?: Maybe<AiChatConversation>;
  readonly aiChatRoom?: Maybe<AiChatRoom>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateAiChatRoom */
export type CreateAiChatRoomInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly message?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAiChatRoom. */
export type CreateAiChatRoomPayload = {
  readonly __typename?: 'CreateAiChatRoomPayload';
  readonly aiChatRoom?: Maybe<AiChatRoom>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateBankAccountReview */
export type CreateBankAccountReviewInput = {
  readonly approved: Scalars['Boolean'];
  readonly bankAccountId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateBankAccountReview. */
export type CreateBankAccountReviewPayload = {
  readonly __typename?: 'CreateBankAccountReviewPayload';
  readonly bankAccount: BankAccount;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateCareerCounselingEntryFirstReview */
export type CreateCareerCounselingEntryFirstReviewInput = {
  readonly approve: Scalars['Boolean'];
  readonly careerCounselingEntryId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly reviewItems: ReadonlyArray<CareerCounselingEntryReviewInput>;
};

/** Autogenerated return type of CreateCareerCounselingEntryFirstReview. */
export type CreateCareerCounselingEntryFirstReviewPayload = {
  readonly __typename?: 'CreateCareerCounselingEntryFirstReviewPayload';
  readonly careerCounselingEntry?: Maybe<CareerCounselingEntry>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateCareerCounselingEntrySecondReview */
export type CreateCareerCounselingEntrySecondReviewInput = {
  readonly approve: Scalars['Boolean'];
  readonly careerCounselingEntryId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly reviewItems: ReadonlyArray<CareerCounselingEntryReviewInput>;
};

/** Autogenerated return type of CreateCareerCounselingEntrySecondReview. */
export type CreateCareerCounselingEntrySecondReviewPayload = {
  readonly __typename?: 'CreateCareerCounselingEntrySecondReviewPayload';
  readonly careerCounselingEntry?: Maybe<CareerCounselingEntry>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateCareerCounselingReport */
export type CreateCareerCounselingReportInput = {
  readonly additionalMemo?: InputMaybe<Scalars['String']>;
  readonly allChecked: Scalars['Boolean'];
  readonly careerCounselingEntryId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly content: Scalars['String'];
  readonly evidenceDocumentBase64?: InputMaybe<Scalars['String']>;
  readonly evidenceDocumentFilename?: InputMaybe<Scalars['String']>;
  readonly internalMemo?: InputMaybe<Scalars['String']>;
  readonly nextAppointmentCompleted?: InputMaybe<Scalars['Boolean']>;
  readonly nextAppointmentReason?: InputMaybe<Scalars['String']>;
  readonly reviewItems: ReadonlyArray<CareerCounselingEntryReviewInput>;
  readonly zoomPasscode: Scalars['String'];
  readonly zoomUrl: Scalars['String'];
};

/** Autogenerated return type of CreateCareerCounselingReport. */
export type CreateCareerCounselingReportPayload = {
  readonly __typename?: 'CreateCareerCounselingReportPayload';
  readonly careerCounselingEntry?: Maybe<CareerCounselingEntry>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateContractInfoExport */
export type CreateContractInfoExportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly enrollmentPeriodEndsOn: Scalars['ISO8601Date'];
  readonly enrollmentPeriodStartsOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of CreateContractInfoExport. */
export type CreateContractInfoExportPayload = {
  readonly __typename?: 'CreateContractInfoExportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateEntranceFeeItem */
export type CreateEntranceFeeItemInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly creditCardInstallmentPaymentPlanId: Scalars['ID'];
  readonly installmentPaymentPlanId: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly membershipPlanGroupId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlanId: Scalars['ID'];
  readonly price: Scalars['Int'];
};

/** Autogenerated return type of CreateEntranceFeeItem. */
export type CreateEntranceFeeItemPayload = {
  readonly __typename?: 'CreateEntranceFeeItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly entranceFeeItem?: Maybe<EntranceFeeItem>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateEvent */
export type CreateEventInput = {
  readonly capacity: Scalars['Int'];
  readonly chargeScope?: InputMaybe<EventChargeScope>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly coachIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly coverPhotoBase64: Scalars['String'];
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly full: Scalars['Boolean'];
  readonly highlight: Scalars['String'];
  readonly introduction: Scalars['String'];
  readonly keyColor: Scalars['String'];
  readonly locationId?: InputMaybe<Scalars['ID']>;
  readonly meetingTimeNote?: InputMaybe<Scalars['String']>;
  readonly membershipPlanGroupIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly moneyTrainingProgramGroupId?: InputMaybe<Scalars['ID']>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly pageTitle?: InputMaybe<Scalars['String']>;
  readonly price: Scalars['Int'];
  readonly publishedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  readonly requiredItems: Scalars['String'];
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly subTitle: Scalars['String'];
  readonly tagList?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly targetDescription: Scalars['String'];
  readonly targetType?: InputMaybe<EventTarget>;
  readonly thumbnailPhotoBase64: Scalars['String'];
  readonly ticketCount: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly visibility: EventVisibility;
  readonly zoomUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateEvent. */
export type CreateEventPayload = {
  readonly __typename?: 'CreateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly event?: Maybe<Event>;
};

/** Autogenerated input type of CreateIdentityDocumentReview */
export type CreateIdentityDocumentReviewInput = {
  readonly approved: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly identityDocumentId: Scalars['ID'];
};

/** Autogenerated return type of CreateIdentityDocumentReview. */
export type CreateIdentityDocumentReviewPayload = {
  readonly __typename?: 'CreateIdentityDocumentReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly identityDocument: IdentityDocument;
};

/** Autogenerated input type of CreateMembershipItem */
export type CreateMembershipItemInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly creditCardInstallmentPaymentPlanId: Scalars['ID'];
  readonly durationMonth: Scalars['Int'];
  readonly installmentPaymentPlanId: Scalars['ID'];
  readonly membershipPlanId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlanId: Scalars['ID'];
  readonly price: Scalars['Int'];
};

/** Autogenerated return type of CreateMembershipItem. */
export type CreateMembershipItemPayload = {
  readonly __typename?: 'CreateMembershipItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly membershipItem?: Maybe<MembershipItem>;
};

/** Autogenerated input type of CreateMoneyTrainingProgramGroup */
export type CreateMoneyTrainingProgramGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
};

/** Autogenerated return type of CreateMoneyTrainingProgramGroup. */
export type CreateMoneyTrainingProgramGroupPayload = {
  readonly __typename?: 'CreateMoneyTrainingProgramGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly moneyTrainingProgramGroup?: Maybe<MoneyTrainingProgramGroup>;
};

/** Autogenerated input type of CreateOnlinePlusLesson */
export type CreateOnlinePlusLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly coachIds: ReadonlyArray<Scalars['ID']>;
  readonly courseCategoryId: Scalars['ID'];
  readonly description: Scalars['String'];
  readonly durationInMinutes: Scalars['Int'];
  readonly heldAt: Scalars['ISO8601Date'];
  readonly introductionVideoUrl: Scalars['String'];
  readonly mainVideoUrl: Scalars['String'];
  readonly membershipPlanGroupIds: ReadonlyArray<Scalars['ID']>;
  readonly recommendedFor: Scalars['String'];
  readonly requiredTokenAmount: Scalars['Int'];
  readonly reskilling?: InputMaybe<Scalars['Boolean']>;
  readonly status: PlusLessonStatus;
  readonly thumbnailUrl: Scalars['String'];
  readonly timeline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly videoNotes: Scalars['String'];
};

/** Autogenerated return type of CreateOnlinePlusLesson. */
export type CreateOnlinePlusLessonPayload = {
  readonly __typename?: 'CreateOnlinePlusLessonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlinePlusLesson?: Maybe<PlusLesson>;
};

/** Autogenerated input type of CreateOnlineStudyFaq */
export type CreateOnlineStudyFaqInput = {
  readonly answer: Scalars['String'];
  readonly blockId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly question: Scalars['String'];
  readonly status: StudyFaqStatus;
};

/** Autogenerated return type of CreateOnlineStudyFaq. */
export type CreateOnlineStudyFaqPayload = {
  readonly __typename?: 'CreateOnlineStudyFaqPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineStudyFaq?: Maybe<StudyFaq>;
};

/** Autogenerated input type of CreateOrUpdateUserZoomAccountByUserId */
export type CreateOrUpdateUserZoomAccountByUserIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** zoom ミーティングの URL */
  readonly meetingUrl: Scalars['Url'];
  /** UserZoomAccount を更新するユーザーの id */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of CreateOrUpdateUserZoomAccountByUserId. */
export type CreateOrUpdateUserZoomAccountByUserIdPayload = {
  readonly __typename?: 'CreateOrUpdateUserZoomAccountByUserIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateOrderCancelRequest */
export type CreateOrderCancelRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly hasCharge: Scalars['Boolean'];
  readonly hasWithdrawal: Scalars['Boolean'];
  readonly note?: InputMaybe<Scalars['String']>;
  readonly orderId: Scalars['ID'];
  readonly reason: Scalars['String'];
  readonly requestUserId: Scalars['ID'];
  readonly shouldStopSubscription: Scalars['Boolean'];
};

/** Autogenerated return type of CreateOrderCancelRequest. */
export type CreateOrderCancelRequestPayload = {
  readonly __typename?: 'CreateOrderCancelRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly orderCancelRequest?: Maybe<OrderCancelRequest>;
};

/** Autogenerated input type of CreatePlannerMeta */
export type CreatePlannerMetaInput = {
  readonly careerPath: PlannerMetaCareerPath;
  readonly chargeCvUserId?: InputMaybe<Scalars['ID']>;
  readonly chargeGlUserId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly effectiveAt: Scalars['ISO8601DateTime'];
  readonly generation?: InputMaybe<Scalars['String']>;
  readonly scheduledComebackOn?: InputMaybe<Scalars['ISO8601Date']>;
  readonly status: PlannerMetaStatus;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of CreatePlannerMeta. */
export type CreatePlannerMetaPayload = {
  readonly __typename?: 'CreatePlannerMetaPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly plannerMeta: PlannerMeta;
};

/** Autogenerated input type of CreateRegularPlanRecruitmentApplication */
export type CreateRegularPlanRecruitmentApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly regularPlanRecruitmentId: Scalars['ID'];
};

/** Autogenerated return type of CreateRegularPlanRecruitmentApplication. */
export type CreateRegularPlanRecruitmentApplicationPayload = {
  readonly __typename?: 'CreateRegularPlanRecruitmentApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly regularPlanRecruitmentApplication?: Maybe<RegularPlanRecruitmentApplication>;
};

/** Autogenerated input type of CreateRegularPlanRecruitment */
export type CreateRegularPlanRecruitmentInput = {
  readonly capacity: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly lotteryDate: Scalars['ISO8601Date'];
  readonly planChangeEndsAt: Scalars['ISO8601DateTime'];
  readonly planChangeStartsAt: Scalars['ISO8601DateTime'];
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly title: Scalars['String'];
};

/** Autogenerated return type of CreateRegularPlanRecruitment. */
export type CreateRegularPlanRecruitmentPayload = {
  readonly __typename?: 'CreateRegularPlanRecruitmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly regularPlanRecruitment?: Maybe<RegularPlanRecruitment>;
};

/** Autogenerated input type of CreateRole */
export type CreateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly coachSkillTypeId: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
};

/** Autogenerated return type of CreateRole. */
export type CreateRolePayload = {
  readonly __typename?: 'CreateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly role?: Maybe<Role>;
};

/** Autogenerated input type of CreateSalaryReview */
export type CreateSalaryReviewInput = {
  readonly approved: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly memo?: InputMaybe<Scalars['String']>;
  readonly salaryId: Scalars['ID'];
};

/** Autogenerated return type of CreateSalaryReview. */
export type CreateSalaryReviewPayload = {
  readonly __typename?: 'CreateSalaryReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly salary: SalaryDocument;
};

/** Autogenerated input type of CreateSessionTemplateKey */
export type CreateSessionTemplateKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly key: Scalars['String'];
};

/** Autogenerated return type of CreateSessionTemplateKey. */
export type CreateSessionTemplateKeyPayload = {
  readonly __typename?: 'CreateSessionTemplateKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateStudyGroups */
export type CreateStudyGroupsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly studyGroups: ReadonlyArray<StudyGroupInput>;
};

/** Autogenerated return type of CreateStudyGroups. */
export type CreateStudyGroupsPayload = {
  readonly __typename?: 'CreateStudyGroupsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly studyGroups?: Maybe<ReadonlyArray<StudyGroup>>;
};

/** Autogenerated input type of CreateTrainingProgramSessionReservations */
export type CreateTrainingProgramSessionReservationsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly trainingProgramPackageId: Scalars['ID'];
};

/** Autogenerated return type of CreateTrainingProgramSessionReservations. */
export type CreateTrainingProgramSessionReservationsPayload = {
  readonly __typename?: 'CreateTrainingProgramSessionReservationsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateTrialLessonOnlineVariable */
export type CreateTrialLessonOnlineVariableInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly estimatedParticipationRate: Scalars['Float'];
  readonly loungeRate: Scalars['Float'];
  readonly membershipPlanGroupKey: Scalars['String'];
  readonly oneOnOneRate: Scalars['Float'];
  readonly oneOnTwoRate: Scalars['Float'];
  readonly startsOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of CreateTrialLessonOnlineVariable. */
export type CreateTrialLessonOnlineVariablePayload = {
  readonly __typename?: 'CreateTrialLessonOnlineVariablePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateUserAppNotificationToken */
export type CreateUserAppNotificationTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

/** Autogenerated return type of CreateUserAppNotificationToken. */
export type CreateUserAppNotificationTokenPayload = {
  readonly __typename?: 'CreateUserAppNotificationTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly userAppNotificationToken?: Maybe<UserAppNotificationToken>;
};

/** Autogenerated input type of CreateUserBadge */
export type CreateUserBadgeInput = {
  readonly badgeKey: BadgeKey;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly userId: Scalars['ID'];
};

export type CreateUserBadgePayload = CreateUserBadgeSuccess | UserBadgeAlreadyCreated;

export type CreateUserBadgeSuccess = {
  readonly __typename?: 'CreateUserBadgeSuccess';
  readonly createdBadge: UserBadge;
};

/** Autogenerated input type of CreateUserZoomAccountByZoomEmail */
export type CreateUserZoomAccountByZoomEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** UserZoomAccount を更新するユーザーの id */
  readonly userId: Scalars['ID'];
  /** zoom アカウントのメールアドレス */
  readonly zoomEmail: Scalars['String'];
};

/** Autogenerated return type of CreateUserZoomAccountByZoomEmail. */
export type CreateUserZoomAccountByZoomEmailPayload = {
  readonly __typename?: 'CreateUserZoomAccountByZoomEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of CreateVisionAndMap */
export type CreateVisionAndMapInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly idealStudyPeriod: UserVisionStudyPeriod;
  readonly interestedSkills: ReadonlyArray<StudyMapSkillType>;
};

/** Autogenerated return type of CreateVisionAndMap. */
export type CreateVisionAndMapPayload = {
  readonly __typename?: 'CreateVisionAndMapPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateZoomAlternativeHost */
export type CreateZoomAlternativeHostInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 代替ホストに設定するユーザー ID */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of CreateZoomAlternativeHost. */
export type CreateZoomAlternativeHostPayload = {
  readonly __typename?: 'CreateZoomAlternativeHostPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly zoomAlternativeHost?: Maybe<ZoomAlternativeHost>;
};

export type CreditCard = {
  readonly __typename?: 'CreditCard';
  readonly brand: Scalars['String'];
  readonly expMonth: Scalars['Int'];
  readonly expYear: Scalars['Int'];
  readonly last4: Scalars['String'];
};

export const CreditSplitStatus = {
  BankEntered: 'BANK_ENTERED',
  CreditSplit: 'CREDIT_SPLIT',
  CreditSplitErrorBank: 'CREDIT_SPLIT_ERROR_BANK',
  CreditSplitErrorDirectDebit: 'CREDIT_SPLIT_ERROR_DIRECT_DEBIT',
  CreditSplitErrorIrregular: 'CREDIT_SPLIT_ERROR_IRREGULAR',
  CreditSplitErrorLoan: 'CREDIT_SPLIT_ERROR_LOAN',
  CreditSplitErrorNotEntered: 'CREDIT_SPLIT_ERROR_NOT_ENTERED',
  CreditSplitErrorShe: 'CREDIT_SPLIT_ERROR_SHE',
  DirectDebitEntered: 'DIRECT_DEBIT_ENTERED',
  IrregularEntered: 'IRREGULAR_ENTERED',
  LoanEntered: 'LOAN_ENTERED',
  NotEnteredBefore: 'NOT_ENTERED_BEFORE'
} as const;

export type CreditSplitStatus = typeof CreditSplitStatus[keyof typeof CreditSplitStatus];
export const CurrentIntentionLevel = {
  Level_0: 'LEVEL_0',
  Level_1: 'LEVEL_1',
  Level_2: 'LEVEL_2',
  Level_3: 'LEVEL_3',
  Level_4: 'LEVEL_4',
  Level_5: 'LEVEL_5',
  Level_6: 'LEVEL_6',
  Level_7: 'LEVEL_7',
  Level_8: 'LEVEL_8',
  Level_9: 'LEVEL_9',
  Level_10: 'LEVEL_10',
  LevelDidNotAsk: 'LEVEL_DID_NOT_ASK'
} as const;

export type CurrentIntentionLevel = typeof CurrentIntentionLevel[keyof typeof CurrentIntentionLevel];
export type CurrentUser = {
  readonly __typename?: 'CurrentUser';
  readonly activationStatus: ActivationStatus;
  readonly additionalIdentityDocument?: Maybe<AdditionalIdentityDocument>;
  readonly bankAccount?: Maybe<BankAccount>;
  readonly birthday?: Maybe<Scalars['ISO8601Date']>;
  /** 卒業生プランに再入会できるかどうか */
  readonly canApplyGraduatePlan: Scalars['Boolean'];
  readonly careerDesignCourseWorkSheets: ReadonlyArray<WorkSheet>;
  readonly courseFavorites: ReadonlyArray<UserItem>;
  readonly creditCard?: Maybe<CreditCard>;
  readonly entranceCeremonyWorkbook?: Maybe<EntranceCeremonyWorkbook>;
  readonly favorites: ReadonlyArray<UserItem>;
  readonly firstName: Scalars['String'];
  readonly firstNameKana: Scalars['String'];
  readonly fullname: Scalars['String'];
  readonly furigana: Scalars['String'];
  readonly hasXAccount: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly identityDocument?: Maybe<IdentityDocument>;
  readonly isTrialMembership: Scalars['Boolean'];
  readonly isTrialMembershipPermitted: Scalars['Boolean'];
  readonly itemPackageEffectivePeriods: ReadonlyArray<UserItemPackageEffectivePeriod>;
  readonly lastName: Scalars['String'];
  readonly lastNameKana: Scalars['String'];
  readonly lessonHistories: ReadonlyArray<UserItem>;
  readonly longTermGoal?: Maybe<LongTermGoal>;
  readonly membershipPlanKeys: ReadonlyArray<Scalars['String']>;
  readonly multiCreatorPlanJoinDate?: Maybe<Scalars['ISO8601Date']>;
  readonly myVision?: Maybe<UserVision>;
  readonly name: Scalars['String'];
  readonly orders: ReadonlyArray<Order>;
  readonly personalSummary?: Maybe<PersonalSummary>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly plusLessonFavorites: ReadonlyArray<UserItem>;
  readonly recentWeekReservations: ReadonlyArray<ReservationUnion>;
  readonly recommends: ReadonlyArray<UserItem>;
  readonly regularPlanCompletion?: Maybe<UserRegularPlanCompletion>;
  readonly regularPlanJoinDate?: Maybe<Scalars['ISO8601Date']>;
  readonly regularPlanTotalVideoSeconds: Scalars['Int'];
  readonly resume?: Maybe<Resume>;
  readonly robotPaymentActiveCustomer?: Maybe<RobotPaymentsCustomer>;
  readonly robotPaymentPendingRegistrationCustomer?: Maybe<RobotPaymentsCustomer>;
  readonly salaries: ReadonlyArray<SalaryDocument>;
  /** 認定シーメイトのレコードを取得する */
  readonly shemateCertification?: Maybe<ShemateCertification>;
  /** 認定シーメイト一覧を取得する */
  readonly shemateCertifications: ReadonlyArray<ShemateCertification>;
  readonly showLikesWithdrawalLink: Scalars['Boolean'];
  readonly studyMaps?: Maybe<ReadonlyArray<StudyMap>>;
  readonly subsidySummary: UserSubsidySummary;
  readonly userActivityCompletionLogs: ReadonlyArray<UserActivity>;
  readonly userActivityCompletionLogsSummary: UserActivitySummary;
  readonly userAddress?: Maybe<UserAddress>;
};


export type CurrentUserShemateCertificationArgs = {
  id: Scalars['ID'];
};

export const CustomerAttitude = {
  CanTalkWithVideoOn: 'CAN_TALK_WITH_VIDEO_ON',
  NotASituationForConversation: 'NOT_A_SITUATION_FOR_CONVERSATION',
  UnreasonableRequest: 'UNREASONABLE_REQUEST',
  VideoOffAndOnlyChatPossible: 'VIDEO_OFF_AND_ONLY_CHAT_POSSIBLE',
  VideoOffButCanTalk: 'VIDEO_OFF_BUT_CAN_TALK',
  VideoOnButOnlyChatPossible: 'VIDEO_ON_BUT_ONLY_CHAT_POSSIBLE',
  Withdrawal: 'WITHDRAWAL'
} as const;

export type CustomerAttitude = typeof CustomerAttitude[keyof typeof CustomerAttitude];
/** Autogenerated input type of DeactivateOnlinePlusLessonByUserId */
export type DeactivateOnlinePlusLessonByUserIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 閲覧権を喪失させる PlusLesson の ID */
  readonly onlinePlusLessonId: Scalars['ID'];
  /** 閲覧権を喪失させるユーザーの ID */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of DeactivateOnlinePlusLessonByUserId. */
export type DeactivateOnlinePlusLessonByUserIdPayload = {
  readonly __typename?: 'DeactivateOnlinePlusLessonByUserIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineUserPlusLessonActivation?: Maybe<UserPlusLessonActivation>;
};

/** Autogenerated input type of DeactivateRobotPaymentsAccount */
export type DeactivateRobotPaymentsAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 対象ユーザーのID */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of DeactivateRobotPaymentsAccount. */
export type DeactivateRobotPaymentsAccountPayload = {
  readonly __typename?: 'DeactivateRobotPaymentsAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteAllEventReservationMatching */
export type DeleteAllEventReservationMatchingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly trialLessonId: Scalars['ID'];
};

/** Autogenerated return type of DeleteAllEventReservationMatching. */
export type DeleteAllEventReservationMatchingPayload = {
  readonly __typename?: 'DeleteAllEventReservationMatchingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteCareerChange */
export type DeleteCareerChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteCareerChange. */
export type DeleteCareerChangePayload = {
  readonly __typename?: 'DeleteCareerChangePayload';
  readonly careerChange?: Maybe<CareerChange>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of DeleteIdentityDocumentReview */
export type DeleteIdentityDocumentReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly identityDocumentReviewId: Scalars['ID'];
};

/** Autogenerated return type of DeleteIdentityDocumentReview. */
export type DeleteIdentityDocumentReviewPayload = {
  readonly __typename?: 'DeleteIdentityDocumentReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly identityDocumentReview?: Maybe<IdentityDocumentReview>;
};

/** Autogenerated input type of DeleteIrregularCouponTemplateSetting */
export type DeleteIrregularCouponTemplateSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly irregularCouponTemplateSettingId: Scalars['ID'];
};

/** Autogenerated return type of DeleteIrregularCouponTemplateSetting. */
export type DeleteIrregularCouponTemplateSettingPayload = {
  readonly __typename?: 'DeleteIrregularCouponTemplateSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly irregularCouponTemplateSetting?: Maybe<IrregularCouponTemplateSetting>;
};

/** Autogenerated input type of DeleteOnlinePlusLesson */
export type DeleteOnlinePlusLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly plusLessonId: Scalars['ID'];
};

/** Autogenerated return type of DeleteOnlinePlusLesson. */
export type DeleteOnlinePlusLessonPayload = {
  readonly __typename?: 'DeleteOnlinePlusLessonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlinePlusLesson?: Maybe<PlusLesson>;
};

/** Autogenerated input type of DeleteOnlineRecommendLearningLesson */
export type DeleteOnlineRecommendLearningLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
};

/** Autogenerated return type of DeleteOnlineRecommendLearningLesson. */
export type DeleteOnlineRecommendLearningLessonPayload = {
  readonly __typename?: 'DeleteOnlineRecommendLearningLessonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of DeleteOnlineStudyFaq */
export type DeleteOnlineStudyFaqInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly studyFaqId: Scalars['ID'];
};

/** Autogenerated return type of DeleteOnlineStudyFaq. */
export type DeleteOnlineStudyFaqPayload = {
  readonly __typename?: 'DeleteOnlineStudyFaqPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineStudyFaq?: Maybe<StudyFaq>;
};

/** Autogenerated input type of DeletePlannerMeta */
export type DeletePlannerMetaInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly plannerMetaId: Scalars['ID'];
};

/** Autogenerated return type of DeletePlannerMeta. */
export type DeletePlannerMetaPayload = {
  readonly __typename?: 'DeletePlannerMetaPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly plannerMeta?: Maybe<PlannerMeta>;
};

/** Autogenerated input type of DeleteRegularPlanRecruitment */
export type DeleteRegularPlanRecruitmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly regularPlanRecruitmentId: Scalars['ID'];
};

/** Autogenerated return type of DeleteRegularPlanRecruitment. */
export type DeleteRegularPlanRecruitmentPayload = {
  readonly __typename?: 'DeleteRegularPlanRecruitmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of DeleteRejectedCareerCounselingEntrySecondReview */
export type DeleteRejectedCareerCounselingEntrySecondReviewInput = {
  readonly careerCounselingEntryId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteRejectedCareerCounselingEntrySecondReview. */
export type DeleteRejectedCareerCounselingEntrySecondReviewPayload = {
  readonly __typename?: 'DeleteRejectedCareerCounselingEntrySecondReviewPayload';
  readonly careerCounselingEntry?: Maybe<CareerCounselingEntry>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of DeleteRobotPaymentsCustomerForDuplicate */
export type DeleteRobotPaymentsCustomerForDuplicateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 削除対象のロボペイ顧客ID */
  readonly robotPaymentsCustomerId: Scalars['String'];
};

/** Autogenerated return type of DeleteRobotPaymentsCustomerForDuplicate. */
export type DeleteRobotPaymentsCustomerForDuplicatePayload = {
  readonly __typename?: 'DeleteRobotPaymentsCustomerForDuplicatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteStudyGroup */
export type DeleteStudyGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly studyGroupId: Scalars['ID'];
};

/** Autogenerated return type of DeleteStudyGroup. */
export type DeleteStudyGroupPayload = {
  readonly __typename?: 'DeleteStudyGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly studyGroup: StudyGroup;
};

/** Autogenerated input type of DeleteTrialLessonOnlineVariable */
export type DeleteTrialLessonOnlineVariableInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly trialLessonOnlineVariableId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of DeleteTrialLessonOnlineVariable. */
export type DeleteTrialLessonOnlineVariablePayload = {
  readonly __typename?: 'DeleteTrialLessonOnlineVariablePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of DeleteUserCardPaymentInfo */
export type DeleteUserCardPaymentInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 削除する PaymentInfo ID */
  readonly paymentInfoId: Scalars['ID'];
  /** PaymentInfo を持つ User ID */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteUserCardPaymentInfo. */
export type DeleteUserCardPaymentInfoPayload = {
  readonly __typename?: 'DeleteUserCardPaymentInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  /** 削除されたペイジェントの顧客ID */
  readonly paygentCustomerId?: Maybe<Scalars['String']>;
  /** 削除されたPAYJPの顧客ID */
  readonly payjpCustomerId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteUserZoomAccountByUserId */
export type DeleteUserZoomAccountByUserIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** UserZoomAccount を削除するユーザーの id */
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteUserZoomAccountByUserId. */
export type DeleteUserZoomAccountByUserIdPayload = {
  readonly __typename?: 'DeleteUserZoomAccountByUserIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of DeleteZoomAlternativeHost */
export type DeleteZoomAlternativeHostInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 削除する ZoomAlternativeHost の ID */
  readonly id: Scalars['ID'];
};

/** Autogenerated return type of DeleteZoomAlternativeHost. */
export type DeleteZoomAlternativeHostPayload = {
  readonly __typename?: 'DeleteZoomAlternativeHostPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly deletedZoomAlternativeHostId?: Maybe<Scalars['ID']>;
  readonly errors: ReadonlyArray<Error>;
};

export type DirectlyEarnBadgeAlreadyEarned = {
  readonly __typename?: 'DirectlyEarnBadgeAlreadyEarned';
  readonly _?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DirectlyEarnBadge */
export type DirectlyEarnBadgeInput = {
  readonly badgeKey: DirectlyEarnableBadgeKey;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DirectlyEarnBadgePayload = DirectlyEarnBadgeAlreadyEarned | DirectlyEarnBadgeSuccess;

export type DirectlyEarnBadgeSuccess = {
  readonly __typename?: 'DirectlyEarnBadgeSuccess';
  readonly earnedBadge: UserBadge;
};

export const DirectlyEarnableBadgeKey = {
  VisitSheStation: 'VISIT_SHE_STATION'
} as const;

export type DirectlyEarnableBadgeKey = typeof DirectlyEarnableBadgeKey[keyof typeof DirectlyEarnableBadgeKey];
export const Discount = {
  Absolute: 'ABSOLUTE',
  Percentage: 'PERCENTAGE'
} as const;

export type Discount = typeof Discount[keyof typeof Discount];
/** 本人確認書類提出時のユーザー情報変更リクエスト */
export type DocumentProfileRequest = {
  readonly __typename?: 'DocumentProfileRequest';
  readonly address: Scalars['String'];
  readonly birthday: Scalars['String'];
  readonly building?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly firstNameKana: Scalars['String'];
  readonly fullAddress: Scalars['String'];
  readonly fullname: Scalars['String'];
  readonly fullnameKana: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly identityDocument: IdentityDocument;
  readonly lastName: Scalars['String'];
  readonly lastNameKana: Scalars['String'];
  readonly prefecture: Scalars['String'];
  readonly zipcode: Scalars['String'];
};

export type EarnedBadge = BadgeWithEarnedInfo & {
  readonly __typename?: 'EarnedBadge';
  readonly badge: Badge;
  readonly userBadge: UserBadge;
};

/** Autogenerated input type of EndLineNurturing */
export type EndLineNurturingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 終了メモ */
  readonly closeNote?: InputMaybe<Scalars['String']>;
  /** 終了理由ID */
  readonly closeReasonId: Scalars['ID'];
  /** 終了日時 */
  readonly endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 追客ID */
  readonly nurturingId: Scalars['ID'];
};

/** Autogenerated return type of EndLineNurturing. */
export type EndLineNurturingPayload = {
  readonly __typename?: 'EndLineNurturingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly nurturing?: Maybe<LineNurturing>;
};

export type EntranceCeremonyWorkbook = {
  readonly __typename?: 'EntranceCeremonyWorkbook';
  readonly id: Scalars['ID'];
  readonly sheetUrl?: Maybe<Scalars['String']>;
};

export type EntranceFeeItem = {
  readonly __typename?: 'EntranceFeeItem';
  readonly creditCardInstallmentPaymentPlan: InstallmentPaymentPlan;
  readonly id: Scalars['ID'];
  readonly installmentPaymentPlan: InstallmentPaymentPlan;
  readonly key: Scalars['String'];
  readonly membershipPlanGroup: MembershipPlanGroup;
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlan: InstallmentPaymentPlan;
  readonly price: Scalars['Int'];
  readonly taxAmount: Scalars['Int'];
};

export type EntranceStatus = {
  readonly __typename?: 'EntranceStatus';
  readonly effectiveAt?: Maybe<Scalars['ISO8601Date']>;
  readonly entranceType: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly membershipPlanGroup?: Maybe<MembershipPlanGroup>;
  readonly order: Order;
  readonly status: UserEntranceStatus;
  readonly user: User;
};

export type Error = {
  readonly __typename?: 'Error';
  readonly message: Scalars['String'];
  readonly path?: Maybe<ReadonlyArray<Scalars['String']>>;
};

export type Event = {
  readonly __typename?: 'Event';
  readonly capacity: Scalars['Int'];
  readonly chargeScope: EventChargeScope;
  readonly coaches: ReadonlyArray<Coach>;
  readonly coverPhotoUrl?: Maybe<Scalars['String']>;
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly full: Scalars['Boolean'];
  readonly highlight: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly introduction: Scalars['String'];
  readonly keyColor: Scalars['String'];
  readonly location?: Maybe<Location>;
  readonly meetingTimeNote?: Maybe<Scalars['String']>;
  readonly membershipPlanGroups: ReadonlyArray<MembershipPlanGroup>;
  readonly moneyTrainingProgram?: Maybe<MoneyTrainingProgram>;
  readonly note?: Maybe<Scalars['String']>;
  readonly pageTitle?: Maybe<Scalars['String']>;
  readonly price: Scalars['Int'];
  readonly publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly requiredItems: Scalars['String'];
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly subTitle: Scalars['String'];
  readonly tags: ReadonlyArray<Scalars['String']>;
  readonly targetDescription: Scalars['String'];
  readonly targetType: EventTarget;
  readonly thumbnailPhotoUrl?: Maybe<Scalars['String']>;
  readonly ticketCount: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly videoProvider: Scalars['String'];
  readonly visibility: EventVisibility;
  readonly zoomUrl?: Maybe<Scalars['String']>;
};

export const EventChargeScope = {
  AllUsers: 'ALL_USERS',
  NonMembers: 'NON_MEMBERS'
} as const;

export type EventChargeScope = typeof EventChargeScope[keyof typeof EventChargeScope];
export type EventReservation = {
  readonly __typename?: 'EventReservation';
  readonly counselingSheet?: Maybe<SurveySubmission>;
  readonly event?: Maybe<Event>;
  readonly eventReservationMeta?: Maybe<EventReservationMeta>;
  readonly eventReservationPlannerMatching?: Maybe<EventReservationPlannerMatching>;
  readonly eventReservationProDesignCounseling?: Maybe<EventReservationProDesignCounseling>;
  readonly id: Scalars['ID'];
  readonly reserver?: Maybe<User>;
  readonly status?: Maybe<Scalars['String']>;
};

export type EventReservationConversionHistory = {
  readonly __typename?: 'EventReservationConversionHistory';
  readonly eventReservation: EventReservation;
  readonly id: Scalars['ID'];
  readonly order: Order;
};

export type EventReservationCounseling = {
  readonly __typename?: 'EventReservationCounseling';
  readonly eventReservationPlannerMatching: EventReservationPlannerMatching;
  readonly followUpMessage?: Maybe<Scalars['String']>;
  readonly followUpStatusAfter3Days?: Maybe<EventReservationCounselingFollowUpStatusAfterThreeDays>;
  readonly followUpStatusToday?: Maybe<EventReservationCounselingFollowUpStatus>;
  readonly id: Scalars['ID'];
  readonly memo?: Maybe<Scalars['String']>;
  readonly style?: Maybe<EventReservationCounselingStyle>;
  readonly subsidyEligibilityStatus?: Maybe<EventReservationCounselingSubsidyEligibilityStatus>;
  readonly subsidyEligibilityStatusMemo?: Maybe<Scalars['String']>;
};

export const EventReservationCounselingFollowUpStatus = {
  BankTransfer: 'BANK_TRANSFER',
  CustomerSupport: 'CUSTOMER_SUPPORT',
  DirectDebit: 'DIRECT_DEBIT',
  Duplicate: 'DUPLICATE',
  ExitBeforeCounseling: 'EXIT_BEFORE_COUNSELING',
  IrregularCard: 'IRREGULAR_CARD',
  IrregularCardSeventyThousandOff: 'IRREGULAR_CARD_SEVENTY_THOUSAND_OFF',
  IrregularCustomerSettler: 'IRREGULAR_CUSTOMER_SETTLER',
  IrregularFamily: 'IRREGULAR_FAMILY',
  IrregularFamilySeventyThousandOff: 'IRREGULAR_FAMILY_SEVENTY_THOUSAND_OFF',
  IrregularMarcy: 'IRREGULAR_MARCY',
  IrregularNewCard: 'IRREGULAR_NEW_CARD',
  IrregularOtherCompany: 'IRREGULAR_OTHER_COMPANY',
  Join: 'JOIN',
  JoinScheduled: 'JOIN_SCHEDULED',
  JoinTrialMembership: 'JOIN_TRIAL_MEMBERSHIP',
  Loan: 'LOAN',
  Media: 'MEDIA',
  NotJoin: 'NOT_JOIN',
  NotJoinRegularConsideration: 'NOT_JOIN_REGULAR_CONSIDERATION'
} as const;

export type EventReservationCounselingFollowUpStatus = typeof EventReservationCounselingFollowUpStatus[keyof typeof EventReservationCounselingFollowUpStatus];
export const EventReservationCounselingFollowUpStatusAfterThreeDays = {
  NoFollowUpAfterThreeDays: 'NO_FOLLOW_UP_AFTER_THREE_DAYS',
  ReasonNotInTheOptions: 'REASON_NOT_IN_THE_OPTIONS',
  WantsToCheckTimeAvailability: 'WANTS_TO_CHECK_TIME_AVAILABILITY',
  WantsToCompareWithOtherCompanies: 'WANTS_TO_COMPARE_WITH_OTHER_COMPANIES',
  WantsToConsiderMoneyDeployment: 'WANTS_TO_CONSIDER_MONEY_DEPLOYMENT',
  WantsToConsiderStartingNow: 'WANTS_TO_CONSIDER_STARTING_NOW'
} as const;

export type EventReservationCounselingFollowUpStatusAfterThreeDays = typeof EventReservationCounselingFollowUpStatusAfterThreeDays[keyof typeof EventReservationCounselingFollowUpStatusAfterThreeDays];
export type EventReservationCounselingInput = {
  readonly eventReservationPlannerMatchingId?: InputMaybe<Scalars['ID']>;
  readonly followUpMessage?: InputMaybe<Scalars['String']>;
  readonly followUpStatusAfter3Days?: InputMaybe<EventReservationCounselingFollowUpStatusAfterThreeDays>;
  readonly followUpStatusToday?: InputMaybe<EventReservationCounselingFollowUpStatus>;
  readonly memo?: InputMaybe<Scalars['String']>;
  readonly style?: InputMaybe<EventReservationCounselingStyle>;
  readonly subsidyEligibilityStatus?: InputMaybe<EventReservationCounselingSubsidyEligibilityStatus>;
  readonly subsidyEligibilityStatusMemo?: InputMaybe<Scalars['String']>;
};

export type EventReservationCounselingReview = {
  readonly __typename?: 'EventReservationCounselingReview';
  readonly approachDetail?: Maybe<Scalars['String']>;
  readonly asis: Asis;
  readonly asisDetail?: Maybe<Scalars['String']>;
  readonly comparisonSchool: Scalars['JSON'];
  readonly counselingResult?: Maybe<CounselingResult>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly creditSplitErrorReaction?: Maybe<Scalars['String']>;
  readonly creditSplitStatus?: Maybe<CreditSplitStatus>;
  readonly customerAttitude: CustomerAttitude;
  readonly customerNextAction?: Maybe<Scalars['String']>;
  readonly customerSituationDetail?: Maybe<Scalars['String']>;
  readonly enrollmentReasonDetail?: Maybe<Scalars['String']>;
  readonly eventReservationPlannerMatchingId: Scalars['Int'];
  readonly firstKeyComparison: KeyComparison;
  readonly firstKeyComparisonDetail?: Maybe<Scalars['String']>;
  readonly freeComment?: Maybe<Scalars['String']>;
  readonly hasConductedCoolingOffTalk: Scalars['Boolean'];
  readonly hasHeardCustomerSituation: Scalars['Boolean'];
  readonly hasSuggested24InstallmentCount: Scalars['Boolean'];
  readonly hasSuggestedCampaign: Scalars['Boolean'];
  readonly hasSuggestedLoan: Scalars['Boolean'];
  readonly hasSuggestedOtherSchoolCp: Scalars['Boolean'];
  readonly hasSuggestedTrialMembership: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly intendedPeriod: IntendedPeriod;
  readonly intendedPeriodDetail?: Maybe<Scalars['String']>;
  readonly intendedPeriodReason: Scalars['String'];
  readonly lastIntentionLevel?: Maybe<LastIntentionLevel>;
  readonly lotteryResult: Scalars['String'];
  readonly nonEnrollmentReason: Scalars['String'];
  readonly nonEnrollmentReasonDetail?: Maybe<Scalars['String']>;
  readonly otherComparisonSchool?: Maybe<Scalars['String']>;
  readonly secondKeyComparison: KeyComparison;
  readonly secondKeyComparisonDetail?: Maybe<Scalars['String']>;
  readonly thirdKeyComparison: KeyComparison;
  readonly thirdKeyComparisonDetail?: Maybe<Scalars['String']>;
  readonly tobe: Tobe;
  readonly tobeDetail?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const EventReservationCounselingStyle = {
  DropOut: 'DROP_OUT',
  Gc: 'GC',
  Lounge: 'LOUNGE',
  OneOnOne: 'ONE_ON_ONE',
  OneOnThree: 'ONE_ON_THREE',
  OneOnTwo: 'ONE_ON_TWO'
} as const;

export type EventReservationCounselingStyle = typeof EventReservationCounselingStyle[keyof typeof EventReservationCounselingStyle];
export const EventReservationCounselingSubsidyEligibilityStatus = {
  Eligible: 'ELIGIBLE',
  Ineligible: 'INELIGIBLE',
  Unknown: 'UNKNOWN'
} as const;

export type EventReservationCounselingSubsidyEligibilityStatus = typeof EventReservationCounselingSubsidyEligibilityStatus[keyof typeof EventReservationCounselingSubsidyEligibilityStatus];
export type EventReservationMeta = {
  readonly __typename?: 'EventReservationMeta';
  readonly affiliateType?: Maybe<Affiliate>;
  readonly annualIncome?: Maybe<Scalars['String']>;
  readonly birthday?: Maybe<Scalars['String']>;
  readonly eventReservation?: Maybe<EventReservation>;
  readonly id?: Maybe<Scalars['ID']>;
  readonly intentionLevel?: Maybe<Scalars['String']>;
  readonly job?: Maybe<Scalars['String']>;
  readonly prefecture?: Maybe<Scalars['String']>;
  readonly source?: Maybe<Scalars['String']>;
  readonly virtualCvRank?: Maybe<Scalars['String']>;
};

export type EventReservationPlannerMatching = {
  readonly __typename?: 'EventReservationPlannerMatching';
  readonly assistantPlannerUser?: Maybe<User>;
  readonly eventReservation: EventReservation;
  readonly eventReservationCounseling?: Maybe<EventReservationCounseling>;
  readonly eventReservationCounselingReview?: Maybe<EventReservationCounselingReview>;
  readonly id: Scalars['ID'];
  readonly leadPlannerUser?: Maybe<User>;
  readonly newEventReservationCounselingReview?: Maybe<NewEventReservationCounselingReview>;
  readonly surveySubmission?: Maybe<SurveySubmission>;
};

export type EventReservationPlannerMatchingInput = {
  readonly assistantPlannerUserId?: InputMaybe<Scalars['ID']>;
  readonly eventReservationCounseling?: InputMaybe<EventReservationCounselingInput>;
  readonly eventReservationId: Scalars['ID'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly leadPlannerUserId?: InputMaybe<Scalars['ID']>;
};

export type EventReservationProDesignCounseling = {
  readonly __typename?: 'EventReservationProDesignCounseling';
  readonly followUpStatusToday?: Maybe<EventReservationProDesignCounselingFollowUpStatusToday>;
  readonly id: Scalars['ID'];
  readonly memo?: Maybe<Scalars['String']>;
  readonly subsidyEligibilityStatus?: Maybe<EventReservationProDesignCounselingSubsidyEligibilityStatus>;
};

export const EventReservationProDesignCounselingFollowUpStatusToday = {
  BankTransfer: 'BANK_TRANSFER',
  IrregularFamily: 'IRREGULAR_FAMILY',
  Join: 'JOIN',
  NotJoin: 'NOT_JOIN'
} as const;

export type EventReservationProDesignCounselingFollowUpStatusToday = typeof EventReservationProDesignCounselingFollowUpStatusToday[keyof typeof EventReservationProDesignCounselingFollowUpStatusToday];
export const EventReservationProDesignCounselingSubsidyEligibilityStatus = {
  Eligible: 'ELIGIBLE',
  Ineligible: 'INELIGIBLE',
  Unknown: 'UNKNOWN'
} as const;

export type EventReservationProDesignCounselingSubsidyEligibilityStatus = typeof EventReservationProDesignCounselingSubsidyEligibilityStatus[keyof typeof EventReservationProDesignCounselingSubsidyEligibilityStatus];
export const EventTarget = {
  All: 'ALL',
  MemberOnly: 'MEMBER_ONLY'
} as const;

export type EventTarget = typeof EventTarget[keyof typeof EventTarget];
export const EventVisibility = {
  Active: 'ACTIVE',
  Hidden: 'HIDDEN',
  LinkOnly: 'LINK_ONLY'
} as const;

export type EventVisibility = typeof EventVisibility[keyof typeof EventVisibility];
export const FavoriteType = {
  Course: 'COURSE',
  PlusLesson: 'PLUS_LESSON'
} as const;

export type FavoriteType = typeof FavoriteType[keyof typeof FavoriteType];
/** Autogenerated input type of FindOrCreateRobotPaymentsCustomer */
export type FindOrCreateRobotPaymentsCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of FindOrCreateRobotPaymentsCustomer. */
export type FindOrCreateRobotPaymentsCustomerPayload = {
  readonly __typename?: 'FindOrCreateRobotPaymentsCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly robotPaymentsCustomerId?: Maybe<Scalars['String']>;
};

export type GroupedByCategoryBadges = {
  readonly __typename?: 'GroupedByCategoryBadges';
  readonly badges: ReadonlyArray<BadgeWithEarnedInfo>;
  readonly category: BadgeCategory;
};

export const IdealTimeline = {
  Immediately: 'IMMEDIATELY',
  WithinFewMonths: 'WITHIN_FEW_MONTHS',
  WithinFiveYears: 'WITHIN_FIVE_YEARS',
  WithinHalfYear: 'WITHIN_HALF_YEAR',
  WithinOneYear: 'WITHIN_ONE_YEAR',
  WithinThreeYears: 'WITHIN_THREE_YEARS'
} as const;

export type IdealTimeline = typeof IdealTimeline[keyof typeof IdealTimeline];
export type IdentityDocument = {
  readonly __typename?: 'IdentityDocument';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly documentProfileRequest?: Maybe<DocumentProfileRequest>;
  readonly id: Scalars['ID'];
  readonly identityDocumentFiles: ReadonlyArray<IdentityDocumentFile>;
  readonly identityDocumentReview?: Maybe<IdentityDocumentReview>;
  readonly identityDocumentSetType: IdentityDocumentSet;
  readonly nexwayApplicant?: Maybe<NexwayApplicant>;
  readonly status: IdentityDocumentStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** 本人確認書類をアップロードしたユーザー */
  readonly user: User;
};

/** The connection type for IdentityDocument. */
export type IdentityDocumentConnection = {
  readonly __typename?: 'IdentityDocumentConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<IdentityDocumentEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<IdentityDocument>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IdentityDocumentEdge = {
  readonly __typename?: 'IdentityDocumentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: IdentityDocument;
};

export type IdentityDocumentFile = {
  readonly __typename?: 'IdentityDocumentFile';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly identityDocumentImageType: IdentityDocumentImage;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const IdentityDocumentImage = {
  DriversLicenseBack: 'DRIVERS_LICENSE_BACK',
  DriversLicenseFront: 'DRIVERS_LICENSE_FRONT',
  IdentityNumberFront: 'IDENTITY_NUMBER_FRONT',
  MedicareCardBack: 'MEDICARE_CARD_BACK',
  MedicareCardFront: 'MEDICARE_CARD_FRONT',
  ResidenceCertificate: 'RESIDENCE_CERTIFICATE'
} as const;

export type IdentityDocumentImage = typeof IdentityDocumentImage[keyof typeof IdentityDocumentImage];
export type IdentityDocumentReview = {
  readonly __typename?: 'IdentityDocumentReview';
  readonly approved: Scalars['Boolean'];
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly reviewer: User;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const IdentityDocumentSet = {
  DriversLicense: 'DRIVERS_LICENSE',
  IdentityNumber: 'IDENTITY_NUMBER',
  MedicareCardAndResidenceCertificate: 'MEDICARE_CARD_AND_RESIDENCE_CERTIFICATE'
} as const;

export type IdentityDocumentSet = typeof IdentityDocumentSet[keyof typeof IdentityDocumentSet];
/** 審査のステータス */
export const IdentityDocumentStatus = {
  Error: 'ERROR',
  NexwayAccepted: 'NEXWAY_ACCEPTED',
  NexwayApplicantError: 'NEXWAY_APPLICANT_ERROR',
  NexwayFailed: 'NEXWAY_FAILED',
  NexwayProcessing: 'NEXWAY_PROCESSING',
  NexwayRejected: 'NEXWAY_REJECTED',
  Resubmitted: 'RESUBMITTED',
  SheReviewing: 'SHE_REVIEWING',
  Submitted: 'SUBMITTED'
} as const;

export type IdentityDocumentStatus = typeof IdentityDocumentStatus[keyof typeof IdentityDocumentStatus];
/** Autogenerated input type of ImportOnlineStudyFaqs */
export type ImportOnlineStudyFaqsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fileBase64: Scalars['String'];
};

/** Autogenerated return type of ImportOnlineStudyFaqs. */
export type ImportOnlineStudyFaqsPayload = {
  readonly __typename?: 'ImportOnlineStudyFaqsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of ImportRewardRequest */
export type ImportRewardRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fileBase64: Scalars['String'];
};

/** Autogenerated return type of ImportRewardRequest. */
export type ImportRewardRequestPayload = {
  readonly __typename?: 'ImportRewardRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly rewardRequest?: Maybe<RewardRequest>;
};

export type InstallmentPaymentOption = {
  readonly __typename?: 'InstallmentPaymentOption';
  readonly id: Scalars['ID'];
  readonly installmentCount: Scalars['Int'];
  readonly installmentFeeRate: Scalars['Float'];
};

/** The connection type for InstallmentPaymentOption. */
export type InstallmentPaymentOptionConnection = {
  readonly __typename?: 'InstallmentPaymentOptionConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<InstallmentPaymentOptionEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<InstallmentPaymentOption>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InstallmentPaymentOptionEdge = {
  readonly __typename?: 'InstallmentPaymentOptionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: InstallmentPaymentOption;
};

export type InstallmentPaymentPlan = {
  readonly __typename?: 'InstallmentPaymentPlan';
  readonly id: Scalars['ID'];
  readonly installmentPaymentOptions: InstallmentPaymentOptionConnection;
  readonly name: Scalars['String'];
};


export type InstallmentPaymentPlanInstallmentPaymentOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for InstallmentPaymentPlan. */
export type InstallmentPaymentPlanConnection = {
  readonly __typename?: 'InstallmentPaymentPlanConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<InstallmentPaymentPlanEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<InstallmentPaymentPlan>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InstallmentPaymentPlanEdge = {
  readonly __typename?: 'InstallmentPaymentPlanEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: InstallmentPaymentPlan;
};

export const IntendedPeriod = {
  Immediate: 'IMMEDIATE',
  InHalfAYearToOneYear: 'IN_HALF_A_YEAR_TO_ONE_YEAR',
  InTwoThreeMonths: 'IN_TWO_THREE_MONTHS',
  NotNeeded: 'NOT_NEEDED',
  Other: 'OTHER'
} as const;

export type IntendedPeriod = typeof IntendedPeriod[keyof typeof IntendedPeriod];
export type IrregularCouponTemplateSetting = {
  readonly __typename?: 'IrregularCouponTemplateSetting';
  readonly couponTemplate: CouponTemplate;
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly isValid: Scalars['Boolean'];
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly survey: Survey;
};

/** The connection type for IrregularCouponTemplateSetting. */
export type IrregularCouponTemplateSettingConnection = {
  readonly __typename?: 'IrregularCouponTemplateSettingConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<IrregularCouponTemplateSettingEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<IrregularCouponTemplateSetting>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IrregularCouponTemplateSettingEdge = {
  readonly __typename?: 'IrregularCouponTemplateSettingEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: IrregularCouponTemplateSetting;
};

export const Item = {
  Course: 'COURSE',
  PlusLesson: 'PLUS_LESSON'
} as const;

export type Item = typeof Item[keyof typeof Item];
export type ItemPackage = {
  readonly __typename?: 'ItemPackage';
  readonly creditCardInstallmentPaymentPlan: InstallmentPaymentPlan;
  readonly durationMonths?: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly installmentPaymentPlan: InstallmentPaymentPlan;
  readonly key?: Maybe<ItemPackageKey>;
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlan: InstallmentPaymentPlan;
};

export const ItemPackageKey = {
  GettingOffersProgram: 'GETTING_OFFERS_PROGRAM'
} as const;

export type ItemPackageKey = typeof ItemPackageKey[keyof typeof ItemPackageKey];
/** Trial lesson summary information for jisui_info posting */
export type JisuiInfo = {
  readonly __typename?: 'JisuiInfo';
  /** 平均年齢 */
  readonly averageAge: Scalars['String'];
  /** 銀行振込入会数 */
  readonly bankTransferCount: Scalars['Int'];
  /** イレギュラー入会と銀行振込を含んだ入会率 */
  readonly bankTransferRate: Scalars['Float'];
  /** その場成約数 */
  readonly contractsCount: Scalars['Int'];
  /** その場成約率 */
  readonly contractsRate: Scalars['Float'];
  /** カウンセリング参加者数 */
  readonly counselingAttendanceCount: Scalars['Int'];
  /** カウンセリングアンケート未回答成約率 */
  readonly counselingSurveyUnansweredContractsCount: Scalars['Float'];
  /** カウンセリングアンケート未回答入会率 */
  readonly counselingSurveyUnansweredContractsRate: Scalars['Float'];
  /** カウンセリングアンケート未回答イレギュラー/銀行振込/口座振替入会数 */
  readonly counselingSurveyUnansweredIrregularBankTransferCount: Scalars['Int'];
  /** カウンセリングアンケート未回答イレギュラー/銀行振込/口座振替入会率 */
  readonly counselingSurveyUnansweredIrregularBankTransferRate: Scalars['Float'];
  /** カウンセリングアンケート未回答参加者数 */
  readonly counselingSurveyUnansweredParticipantsCount: Scalars['Int'];
  /** カウンセリングアンケート未回答お試し入会数 */
  readonly counselingSurveyUnansweredTrialMembershipCount: Scalars['Int'];
  /** カウンセリングアンケート未回答お試し入会率 */
  readonly counselingSurveyUnansweredTrialMembershipRate: Scalars['Float'];
  /** CS接続数 */
  readonly csConnectionCount: Scalars['Int'];
  /** 成約難易度1その場入会数 */
  readonly difficulty1ContractsCount: Scalars['Float'];
  /** 成約難易度1入会率 */
  readonly difficulty1ContractsRate: Scalars['Float'];
  /** 成約難易度1イレギュラー/銀行振込/口座振替入会数 */
  readonly difficulty1IrregularBankTransferCount: Scalars['Int'];
  /** 成約難易度1イレギュラー/銀行振込/口座振替入会率 */
  readonly difficulty1IrregularBankTransferRate: Scalars['Float'];
  /** 成約難易度1参加者数 */
  readonly difficulty1ParticipantsCount: Scalars['Int'];
  /** 成約難易度1お試し入会数 */
  readonly difficulty1TrialMembershipCount: Scalars['Int'];
  /** 成約難易度1お試し入会率 */
  readonly difficulty1TrialMembershipRate: Scalars['Float'];
  /** 成約難易度2その場入会数 */
  readonly difficulty2ContractsCount: Scalars['Float'];
  /** 成約難易度2入会率 */
  readonly difficulty2ContractsRate: Scalars['Float'];
  /** 成約難易度2イレギュラー/銀行振込/口座振替入会数 */
  readonly difficulty2IrregularBankTransferCount: Scalars['Int'];
  /** 成約難易度2イレギュラー/銀行振込/口座振替入会率 */
  readonly difficulty2IrregularBankTransferRate: Scalars['Float'];
  /** 成約難易度2参加者数 */
  readonly difficulty2ParticipantsCount: Scalars['Int'];
  /** 成約難易度2お試し入会数 */
  readonly difficulty2TrialMembershipCount: Scalars['Int'];
  /** 成約難易度2お試し入会率 */
  readonly difficulty2TrialMembershipRate: Scalars['Float'];
  /** 成約難易度3その場入会数 */
  readonly difficulty3ContractsCount: Scalars['Float'];
  /** 成約難易度3入会率 */
  readonly difficulty3ContractsRate: Scalars['Float'];
  /** 成約難易度3イレギュラー/銀行振込/口座振替入会数 */
  readonly difficulty3IrregularBankTransferCount: Scalars['Int'];
  /** 成約難易度3イレギュラー/銀行振込/口座振替入会率 */
  readonly difficulty3IrregularBankTransferRate: Scalars['Float'];
  /** 成約難易度3参加者数 */
  readonly difficulty3ParticipantsCount: Scalars['Int'];
  /** 成約難易度3お試し入会数 */
  readonly difficulty3TrialMembershipCount: Scalars['Int'];
  /** 成約難易度3お試し入会率 */
  readonly difficulty3TrialMembershipRate: Scalars['Float'];
  /** 成約難易度4その場入会数 */
  readonly difficulty4ContractsCount: Scalars['Float'];
  /** 成約難易度4入会率 */
  readonly difficulty4ContractsRate: Scalars['Float'];
  /** 成約難易度4イレギュラー/銀行振込/口座振替入会数 */
  readonly difficulty4IrregularBankTransferCount: Scalars['Int'];
  /** 成約難易度4イレギュラー/銀行振込/口座振替入会率 */
  readonly difficulty4IrregularBankTransferRate: Scalars['Float'];
  /** 成約難易度4参加者数 */
  readonly difficulty4ParticipantsCount: Scalars['Int'];
  /** 成約難易度4お試し入会数 */
  readonly difficulty4TrialMembershipCount: Scalars['Int'];
  /** 成約難易度4お試し入会率 */
  readonly difficulty4TrialMembershipRate: Scalars['Float'];
  /** 成約難易度5その場入会数 */
  readonly difficulty5ContractsCount: Scalars['Float'];
  /** 成約難易度5入会率 */
  readonly difficulty5ContractsRate: Scalars['Float'];
  /** 成約難易度5イレギュラー/銀行振込/口座振替入会数 */
  readonly difficulty5IrregularBankTransferCount: Scalars['Int'];
  /** 成約難易度5イレギュラー/銀行振込/口座振替入会率 */
  readonly difficulty5IrregularBankTransferRate: Scalars['Float'];
  /** 成約難易度5参加者数 */
  readonly difficulty5ParticipantsCount: Scalars['Int'];
  /** 成約難易度5お試し入会数 */
  readonly difficulty5TrialMembershipCount: Scalars['Int'];
  /** 成約難易度5お試し入会率 */
  readonly difficulty5TrialMembershipRate: Scalars['Float'];
  /** 成約難易度6その場入会数 */
  readonly difficulty6ContractsCount: Scalars['Float'];
  /** 成約難易度6入会率 */
  readonly difficulty6ContractsRate: Scalars['Float'];
  /** 成約難易度6イレギュラー/銀行振込/口座振替入会数 */
  readonly difficulty6IrregularBankTransferCount: Scalars['Int'];
  /** 成約難易度6イレギュラー/銀行振込/口座振替入会率 */
  readonly difficulty6IrregularBankTransferRate: Scalars['Float'];
  /** 成約難易度6参加者数 */
  readonly difficulty6ParticipantsCount: Scalars['Int'];
  /** 成約難易度6お試し入会数 */
  readonly difficulty6TrialMembershipCount: Scalars['Int'];
  /** 成約難易度6お試し入会率 */
  readonly difficulty6TrialMembershipRate: Scalars['Float'];
  /** 口座振替入会数 */
  readonly directDebitCount: Scalars['Int'];
  /** イレギュラー入会と銀行振込と口座振替を含んだ入会率 */
  readonly directDebitRate: Scalars['Float'];
  /** 離脱数 */
  readonly dropoutCount: Scalars['Int'];
  /** その場入会を除いた補助金対象人数 */
  readonly excludeMemberSubsidyEligibleAttendedCount: Scalars['Int'];
  /** その場入会を除いた補助金非対象人数 */
  readonly excludeMemberSubsidyIneligibleAttendedCount: Scalars['Int'];
  /** イレギュラー入会数 */
  readonly irregularCount: Scalars['Int'];
  /** イレギュラー入会を含んだ入会率 */
  readonly irregularRate: Scalars['Float'];
  /** ローン契約入会数 */
  readonly loanContractCount: Scalars['Int'];
  /** ラウンジカウンセリング比率 */
  readonly loungeCounselingRate: Scalars['Float'];
  /** 半年〜1年後必要割合 */
  readonly needTimingHalfYearToOneYearRate: Scalars['Float'];
  /** 今すぐ必要割合 */
  readonly needTimingImmediateRate: Scalars['Float'];
  /** 必要ない割合 */
  readonly needTimingNotNeededRate: Scalars['Float'];
  /** 2-3ヶ月後必要割合 */
  readonly needTimingTwoToThreeMonthsRate: Scalars['Float'];
  /** 1on1カウンセリング比率 */
  readonly oneOnOneCounselingRate: Scalars['Float'];
  /** 補助金対象アフィドリ人数 */
  readonly subsidyEligibleAffiliateDreamCount: Scalars['Int'];
  /** 補助金対象人数 */
  readonly subsidyEligibleCount: Scalars['Int'];
  /** 補助金対象率 */
  readonly subsidyEligibleRate: Scalars['Float'];
  /** 補助金対象レギュラープラン成約数 */
  readonly subsidyEligibleRegularPlanContractsCount: Scalars['Int'];
  /** 補助金対象スタライプラン成約数 */
  readonly subsidyEligibleStandardLightPlanContractsCount: Scalars['Int'];
  /** 補助金対象お試し入会数 */
  readonly subsidyEligibleTrialMembershipCount: Scalars['Int'];
  /** 補助金対象お試し提案率 */
  readonly subsidyEligibleTrialMembershipProposalRate: Scalars['Float'];
  /** 補助金対象お試し提案数 */
  readonly subsidyEligibleTrialMembershipProposalsCount: Scalars['Int'];
  /** 補助金対象お試し入会率 */
  readonly subsidyEligibleTrialMembershipRate: Scalars['Float'];
  /** 補助金非対象アフィドリ人数 */
  readonly subsidyIneligibleAffiliateDreamCount: Scalars['Int'];
  /** 補助金非対象人数 */
  readonly subsidyIneligibleCount: Scalars['Int'];
  /** 補助金非対象人率 */
  readonly subsidyIneligibleRate: Scalars['Float'];
  /** 補助金非対象スタライプラン成約数 */
  readonly subsidyIneligibleStandardLightPlanContractsCount: Scalars['Int'];
  /** 補助金非対象お試し入会数 */
  readonly subsidyIneligibleTrialMembershipCount: Scalars['Int'];
  /** 補助金非対象お試し提案率 */
  readonly subsidyIneligibleTrialMembershipProposalRate: Scalars['Float'];
  /** 補助金非対象お試し提案数 */
  readonly subsidyIneligibleTrialMembershipProposalsCount: Scalars['Int'];
  /** 補助金非対象お試し入会率 */
  readonly subsidyIneligibleTrialMembershipRate: Scalars['Float'];
  /** レッスン参加者数 */
  readonly trialLessonAttendanceCount: Scalars['Int'];
  /** レッスン参加率 */
  readonly trialLessonAttendanceRate: Scalars['Float'];
  /** レッスン予約者数 */
  readonly trialLessonReservationCount: Scalars['Int'];
};

export const KeyComparison = {
  AbilityToAskTeacher: 'ABILITY_TO_ASK_TEACHER',
  CommunityExistence: 'COMMUNITY_EXISTENCE',
  CourseContent: 'COURSE_CONTENT',
  DidNotAsk: 'DID_NOT_ASK',
  JobAcquisition: 'JOB_ACQUISITION',
  OnlineStudyStyle: 'ONLINE_STUDY_STYLE',
  Other: 'OTHER',
  PaymentMethod: 'PAYMENT_METHOD',
  Price: 'PRICE',
  SupportContent: 'SUPPORT_CONTENT'
} as const;

export type KeyComparison = typeof KeyComparison[keyof typeof KeyComparison];
export const LastIntentionLevel = {
  Level_0: 'LEVEL_0',
  Level_20: 'LEVEL_20',
  Level_40: 'LEVEL_40',
  Level_60: 'LEVEL_60',
  Level_80: 'LEVEL_80',
  Level_100: 'LEVEL_100',
  LevelDidNotAsk: 'LEVEL_DID_NOT_ASK'
} as const;

export type LastIntentionLevel = typeof LastIntentionLevel[keyof typeof LastIntentionLevel];
export type Lesson = {
  readonly __typename?: 'Lesson';
  readonly activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly activeCourseRevision: CourseRevision;
  readonly courseRevision: CourseRevision;
  readonly hasDraft: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isActivatedByCurrentUser: Scalars['Boolean'];
  readonly position: Scalars['Int'];
  readonly publishedRevision: LessonRevision;
};

export type LessonHomework = {
  readonly __typename?: 'LessonHomework';
  readonly id: Scalars['ID'];
  readonly submissionPlaceUrl: Scalars['String'];
  readonly title: Scalars['String'];
};

export type LessonRevision = {
  readonly __typename?: 'LessonRevision';
  readonly id: Scalars['ID'];
  readonly lesson: Lesson;
  readonly sections: ReadonlyArray<Section>;
  readonly title: Scalars['String'];
};

/** LINEキャンペーン */
export type LineCampaign = {
  readonly __typename?: 'LineCampaign';
  /** 終了理由一覧 */
  readonly closeReasons: ReadonlyArray<LineCampaignCloseReason>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
  /** 追客ステータス一覧 */
  readonly nurturingStatuses: ReadonlyArray<LineCampaignNurturingStatus>;
  /** キャンペーン毎の担当者一覧 */
  readonly operators: ReadonlyArray<LineCampaignOperator>;
  readonly position: Scalars['Int'];
  /** キャンペーンタスク一覧 */
  readonly tasks: ReadonlyArray<LineCampaignTask>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** LINEキャンペーン終了理由 */
export type LineCampaignCloseReason = {
  readonly __typename?: 'LineCampaignCloseReason';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly key?: Maybe<Scalars['String']>;
  readonly position?: Maybe<Scalars['Int']>;
  readonly reason?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** LINEキャンペーン追客ステータス */
export type LineCampaignNurturingStatus = {
  readonly __typename?: 'LineCampaignNurturingStatus';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly visible: Scalars['Boolean'];
};

/** LINEキャンペーン担当者 */
export type LineCampaignOperator = {
  readonly __typename?: 'LineCampaignOperator';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

/** LINEキャンペーンタスク */
export type LineCampaignTask = {
  readonly __typename?: 'LineCampaignTask';
  readonly actor: LineCampaignTaskActor;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
  /** 完了時に遷移する追客ステータス */
  readonly onCompletedNurturingStatus?: Maybe<LineCampaignNurturingStatus>;
  readonly position: Scalars['Int'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** LINEキャンペーンタスクのアクター */
export const LineCampaignTaskActor = {
  /** オペレーター */
  Operator: 'OPERATOR',
  /** システム */
  System: 'SYSTEM',
  /** ユーザー */
  User: 'USER'
} as const;

export type LineCampaignTaskActor = typeof LineCampaignTaskActor[keyof typeof LineCampaignTaskActor];
/** LINEチャネル */
export type LineChannel = {
  readonly __typename?: 'LineChannel';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly destination: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly lineType: LineChannelLine;
  readonly name: Scalars['String'];
  readonly profileUrl?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** LINEチャネルの種別 */
export const LineChannelLine = {
  /** 通常のLINE公式アカウント */
  Line: 'LINE',
  /** 無料会員向けアカウント */
  LineFreeMembership: 'LINE_FREE_MEMBERSHIP',
  /** LINE Pay / マネー連携アカウント */
  LineMoney: 'LINE_MONEY'
} as const;

export type LineChannelLine = typeof LineChannelLine[keyof typeof LineChannelLine];
/** LINE連携情報 */
export type LineConnectionStatus = {
  readonly __typename?: 'LineConnectionStatus';
  readonly conversation?: Maybe<LineConversation>;
  readonly isConnected: Scalars['Boolean'];
  readonly userId: Scalars['ID'];
};

/** LINE会話 */
export type LineConversation = {
  readonly __typename?: 'LineConversation';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly lastMessage?: Maybe<LineMessage>;
  readonly lastMessageSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** 会話内のメッセージ一覧 */
  readonly messages: ReadonlyArray<LineMessage>;
  /** プロバイダーユーザー */
  readonly providerUser: LineProviderUser;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** LINEメッセージ */
export type LineMessage = {
  readonly __typename?: 'LineMessage';
  readonly channel: LineChannel;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly direction: LineMessageDirection;
  readonly file?: Maybe<LineMessageAttachmentFile>;
  readonly id: Scalars['ID'];
  readonly message: Scalars['String'];
  readonly messageType: Scalars['String'];
  readonly sender: LineSender;
  readonly sentAt: Scalars['ISO8601DateTime'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type LineMessageAttachmentFile = {
  readonly __typename?: 'LineMessageAttachmentFile';
  readonly contentType: Scalars['String'];
  readonly filename: Scalars['String'];
  /** original画像のURL（大きいサイズ） */
  readonly originalUrl: Scalars['String'];
  /** preview画像のURL（小さいサイズ） */
  readonly url: Scalars['String'];
};

/** LINEメッセージの方向 */
export const LineMessageDirection = {
  /** 受信 */
  Inbound: 'INBOUND',
  /** 送信 */
  Outbound: 'OUTBOUND'
} as const;

export type LineMessageDirection = typeof LineMessageDirection[keyof typeof LineMessageDirection];
/** LINE追客 */
export type LineNurturing = {
  readonly __typename?: 'LineNurturing';
  /** キャンペーン */
  readonly campaign: LineCampaign;
  /** 終了メモ */
  readonly closeNote?: Maybe<Scalars['String']>;
  /** 終了理由 */
  readonly closeReason?: Maybe<LineCampaignCloseReason>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  /** 終了リクエスト担当者 */
  readonly endRequestOperator?: Maybe<User>;
  /** 終了日時 */
  readonly endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  /** 追客ステータス */
  readonly nurturingStatus: LineCampaignNurturingStatus;
  /** 追客タスク一覧 */
  readonly nurturingTasks: ReadonlyArray<LineNurturingTask>;
  /** 担当者メモ */
  readonly operationNote?: Maybe<Scalars['String']>;
  /** 操作ステータス */
  readonly operationStatus: LineNurturingOperationStatus;
  /** 担当者 */
  readonly ownerOperator?: Maybe<User>;
  /** プロバイダーユーザー */
  readonly providerUser: LineProviderUser;
  /** 開始日時 */
  readonly startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ステータス */
  readonly status: LineNurturingStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** LINE追客の操作ステータス */
export const LineNurturingOperationStatus = {
  /** 対応済み */
  CompleteOperation: 'COMPLETE_OPERATION',
  /** 対応必要 */
  NeedOperation: 'NEED_OPERATION'
} as const;

export type LineNurturingOperationStatus = typeof LineNurturingOperationStatus[keyof typeof LineNurturingOperationStatus];
/** LINE追客のステータス */
export const LineNurturingStatus = {
  /** 追客中で表示可 */
  Active: 'ACTIVE',
  /** 追客終了 */
  Ended: 'ENDED',
  /** 追客終了リクエスト済み */
  EndRequested: 'END_REQUESTED',
  /** 追客中 */
  Nurturing: 'NURTURING'
} as const;

export type LineNurturingStatus = typeof LineNurturingStatus[keyof typeof LineNurturingStatus];
/** 追客ステータスごとの対応必要件数 */
export type LineNurturingStatusCount = {
  readonly __typename?: 'LineNurturingStatusCount';
  /** 対応済みの件数 */
  readonly completeOperationCount: Scalars['Int'];
  /** 対応必要の件数 */
  readonly needOperationCount: Scalars['Int'];
  /** 追客ステータスID */
  readonly nurturingStatusId: Scalars['ID'];
};

/** LINE追客タスク */
export type LineNurturingTask = {
  readonly __typename?: 'LineNurturingTask';
  /** 完了日時 */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id?: Maybe<Scalars['ID']>;
  /** 完了済みかどうか */
  readonly isCompleted: Scalars['Boolean'];
  /** キャンペーンタスク */
  readonly task: LineCampaignTask;
  readonly updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** LINE会話の担当者フィルタ */
export const LineOwnerOperatorFilter = {
  /** すべて */
  All: 'ALL',
  /** 担当者あり */
  Assigned: 'ASSIGNED',
  /** 担当未設定 */
  Unassigned: 'UNASSIGNED'
} as const;

export type LineOwnerOperatorFilter = typeof LineOwnerOperatorFilter[keyof typeof LineOwnerOperatorFilter];
/** LINEプロバイダーユーザー */
export type LineProviderUser = {
  readonly __typename?: 'LineProviderUser';
  /** 現在進行中で表示可能な追客 */
  readonly activeNurturing?: Maybe<LineNurturing>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  /** 現在の追客（追客ステータスを含む） */
  readonly currentNurturing?: Maybe<LineNurturing>;
  readonly displayName?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lineUserId: Scalars['String'];
  readonly profileUrl?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** 紐付いているユーザー */
  readonly user?: Maybe<User>;
  /** 紐付いているユーザーID */
  readonly userId?: Maybe<Scalars['ID']>;
};

/** LINE送信者 */
export type LineSender = {
  readonly __typename?: 'LineSender';
  readonly id: Scalars['ID'];
  readonly lineSenderName?: Maybe<Scalars['String']>;
  readonly lineSenderProfileUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of LineSync */
export type LineSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lineUserId: Scalars['String'];
  readonly sessionToken?: InputMaybe<Scalars['String']>;
  readonly target?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LineSync. */
export type LineSyncPayload = {
  readonly __typename?: 'LineSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<NoNeedToLogInError>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of LinkXAccount */
export type LinkXAccountInput = {
  readonly accessToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expiresIn: Scalars['Int'];
  readonly refreshToken: Scalars['String'];
  readonly scope: Scalars['String'];
  readonly xAccountId: Scalars['String'];
  readonly xDisplayName: Scalars['String'];
  readonly xUserName: Scalars['String'];
};

/** Autogenerated return type of LinkXAccount. */
export type LinkXAccountPayload = {
  readonly __typename?: 'LinkXAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
};

export type Location = {
  readonly __typename?: 'Location';
  readonly address: Scalars['String'];
  readonly googleMapUrl?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly locationType: LocationType;
  readonly name: Scalars['String'];
  readonly requiresPaperContract: Scalars['Boolean'];
  readonly shortName?: Maybe<Scalars['String']>;
  readonly status: LocationStatus;
  readonly zipcode: Scalars['String'];
};

export const LocationStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Hidden: 'HIDDEN'
} as const;

export type LocationStatus = typeof LocationStatus[keyof typeof LocationStatus];
export const LocationType = {
  OfficialBase: 'OFFICIAL_BASE',
  Temporary: 'TEMPORARY'
} as const;

export type LocationType = typeof LocationType[keyof typeof LocationType];
export type LongTermGoal = {
  readonly __typename?: 'LongTermGoal';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly goalDeadline?: Maybe<LongTermGoalGoalDeadline>;
  readonly goalDeadlineName?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly idealCareerContentType?: Maybe<Scalars['String']>;
  readonly idealCareerFileName?: Maybe<Scalars['String']>;
  readonly idealCareerFileSize?: Maybe<Scalars['Int']>;
  readonly idealCareerUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly idealCareerUrl?: Maybe<Scalars['String']>;
  readonly occupation?: Maybe<LongTermGoalOccupation>;
  readonly occupationName?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user?: Maybe<User>;
  readonly workGoal?: Maybe<LongTermGoalWorkGoal>;
  readonly workGoalName?: Maybe<Scalars['String']>;
  readonly yearlyGoalContentType?: Maybe<Scalars['String']>;
  readonly yearlyGoalFileName?: Maybe<Scalars['String']>;
  readonly yearlyGoalFileSize?: Maybe<Scalars['Int']>;
  readonly yearlyGoalUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly yearlyGoalUrl?: Maybe<Scalars['String']>;
};

export const LongTermGoalGoalDeadline = {
  /** 1年以上先 */
  Beyond_1Year: 'BEYOND_1_YEAR',
  /** 1年以内 */
  Within_1Year: 'WITHIN_1_YEAR',
  /** 3ヶ月以内 */
  Within_3Months: 'WITHIN_3_MONTHS',
  /** 6ヶ月以内 */
  Within_6Months: 'WITHIN_6_MONTHS'
} as const;

export type LongTermGoalGoalDeadline = typeof LongTermGoalGoalDeadline[keyof typeof LongTermGoalGoalDeadline];
export const LongTermGoalOccupation = {
  /** 経理 */
  Accounting: 'ACCOUNTING',
  /** バックエンドエンジニア */
  BackendEngineer: 'BACKEND_ENGINEER',
  /** キャリアアドバイザー */
  CareerAdvisor: 'CAREER_ADVISOR',
  /** コミュニティマネージャー */
  CommunityManager: 'COMMUNITY_MANAGER',
  /** コンテンツマーケター */
  ContentMarketer: 'CONTENT_MARKETER',
  /** コピーライター */
  Copywriter: 'COPYWRITER',
  /** カスタマーサクセス */
  CustomerSuccess: 'CUSTOMER_SUCCESS',
  /** カスタマーサポート */
  CustomerSupport: 'CUSTOMER_SUPPORT',
  /** データサイエンティスト */
  DataAnalyst: 'DATA_ANALYST',
  /** 編集者 */
  Editor: 'EDITOR',
  /** インタビューライター */
  EditorialWriter: 'EDITORIAL_WRITER',
  /** 起業家 */
  Entrepreneur: 'ENTREPRENEUR',
  /** エッセイ・コラムライター */
  EssayColumnWriter: 'ESSAY_COLUMN_WRITER',
  /** フィールドセールス */
  FieldSales: 'FIELD_SALES',
  /** フロントエンジニア */
  FrontendEngineer: 'FRONTEND_ENGINEER',
  /** 総務 */
  GeneralAffairs: 'GENERAL_AFFAIRS',
  /** グラフィックデザイナー */
  GraphicDesigner: 'GRAPHIC_DESIGNER',
  /** 人事（採用） */
  HumanResources: 'HUMAN_RESOURCES',
  /** イラストレーター */
  Illustrator: 'ILLUSTRATOR',
  /** インサイドセールス */
  InsideSales: 'INSIDE_SALES',
  /** 労務 */
  Labor: 'LABOR',
  /** 法務 */
  Legal: 'LEGAL',
  /** ライフコーチ */
  LifeCoach: 'LIFE_COACH',
  /** ロゴデザイナー */
  LogoDesigner: 'LOGO_DESIGNER',
  /** モーショングラフィッカー */
  MotionGraphicsArtist: 'MOTION_GRAPHICS_ARTIST',
  /** 事務 */
  OfficeClerk: 'OFFICE_CLERK',
  /** 人事（組織人材開発） */
  OrganizationalDevelopment: 'ORGANIZATIONAL_DEVELOPMENT',
  /** その他 */
  Other: 'OTHER',
  /** フォトグラファー */
  Photographer: 'PHOTOGRAPHER',
  /** プロダクトマネージャー */
  ProductManager: 'PRODUCT_MANAGER',
  /** プロジェクトマネージャー */
  ProjectManager: 'PROJECT_MANAGER',
  /** 広告（PR）ライター */
  PrWriter: 'PR_WRITER',
  /** 広報・PR */
  PublicRelations: 'PUBLIC_RELATIONS',
  /** SEOライター */
  SeoWriter: 'SEO_WRITER',
  /** SNSマーケター（SNS運用） */
  SnsMarketer: 'SNS_MARKETER',
  /** システムエンジニア */
  SystemEngineer: 'SYSTEM_ENGINEER',
  /** UI/UXデザイナー */
  UiUxDesigner: 'UI_UX_DESIGNER',
  /** 動画制作 */
  VideoEditor: 'VIDEO_EDITOR',
  /** Webデザイナー */
  WebDesigner: 'WEB_DESIGNER',
  /** Webディレクター */
  WebDirector: 'WEB_DIRECTOR',
  /** Webマーケター */
  WebMarketer: 'WEB_MARKETER'
} as const;

export type LongTermGoalOccupation = typeof LongTermGoalOccupation[keyof typeof LongTermGoalOccupation];
export const LongTermGoalWorkGoal = {
  /** 起業 */
  BusinessFounding: 'BUSINESS_FOUNDING',
  /** キャリアアップ（部署異動） */
  CareerGrowth: 'CAREER_GROWTH',
  /** フリーランスで活動 */
  Freelance: 'FREELANCE',
  /** 転職・就職 */
  JobChange: 'JOB_CHANGE',
  /** 副業 */
  SideJob: 'SIDE_JOB'
} as const;

export type LongTermGoalWorkGoal = typeof LongTermGoalWorkGoal[keyof typeof LongTermGoalWorkGoal];
export type Membership = {
  readonly __typename?: 'Membership';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly membershipPlanGroup: MembershipPlanGroup;
  readonly operations: ReadonlyArray<MembershipsOperation>;
  readonly status: MembershipStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type MembershipItem = {
  readonly __typename?: 'MembershipItem';
  readonly creditCardInstallmentPaymentPlan: InstallmentPaymentPlan;
  readonly durationMonth: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly installmentPaymentPlan: InstallmentPaymentPlan;
  readonly membershipPlan: MembershipPlan;
  readonly mySubscription?: Maybe<Subscription>;
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlan: InstallmentPaymentPlan;
  readonly price: Scalars['Int'];
  readonly taxAmount: Scalars['Int'];
};

/** The connection type for MembershipItem. */
export type MembershipItemConnection = {
  readonly __typename?: 'MembershipItemConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<MembershipItemEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<MembershipItem>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipItemEdge = {
  readonly __typename?: 'MembershipItemEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: MembershipItem;
};

export type MembershipPlan = {
  readonly __typename?: 'MembershipPlan';
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly name: Scalars['String'];
};

/** The connection type for MembershipPlan. */
export type MembershipPlanConnection = {
  readonly __typename?: 'MembershipPlanConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<MembershipPlanEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<MembershipPlan>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipPlanEdge = {
  readonly __typename?: 'MembershipPlanEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: MembershipPlan;
};

export type MembershipPlanGroup = {
  readonly __typename?: 'MembershipPlanGroup';
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
};

/** The connection type for MembershipPlanGroup. */
export type MembershipPlanGroupConnection = {
  readonly __typename?: 'MembershipPlanGroupConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<MembershipPlanGroupEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<MembershipPlanGroup>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipPlanGroupEdge = {
  readonly __typename?: 'MembershipPlanGroupEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: MembershipPlanGroup;
};

export const MembershipPlanGroupKey = {
  Likes: 'LIKES',
  Money: 'MONEY',
  Multicreator: 'MULTICREATOR'
} as const;

export type MembershipPlanGroupKey = typeof MembershipPlanGroupKey[keyof typeof MembershipPlanGroupKey];
export const MembershipStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Planned: 'PLANNED',
  Suspended: 'SUSPENDED'
} as const;

export type MembershipStatus = typeof MembershipStatus[keyof typeof MembershipStatus];
export type MembershipToken = {
  readonly __typename?: 'MembershipToken';
  readonly effectiveAt: Scalars['ISO8601DateTime'];
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly membershipItem: MembershipItem;
  readonly order: Order;
};

/** The connection type for MembershipToken. */
export type MembershipTokenConnection = {
  readonly __typename?: 'MembershipTokenConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<MembershipTokenEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<MembershipToken>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipTokenEdge = {
  readonly __typename?: 'MembershipTokenEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: MembershipToken;
};

export type MembershipsOperation = {
  readonly __typename?: 'MembershipsOperation';
  /** 操作の開始日（schedulesから計算） */
  readonly beginAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  /** 操作の終了日（schedulesから計算） */
  readonly endAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly operationType: MembershipsOperationType;
  readonly schedules: ReadonlyArray<MembershipsOperationSchedule>;
  readonly status: MembershipsOperationStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type MembershipsOperationSchedule = {
  readonly __typename?: 'MembershipsOperationSchedule';
  readonly cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly eventType: MembershipsScheduleEventType;
  readonly executedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly plannedAt: Scalars['ISO8601DateTime'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const MembershipsOperationStatus = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  Executed: 'EXECUTED',
  Planned: 'PLANNED'
} as const;

export type MembershipsOperationStatus = typeof MembershipsOperationStatus[keyof typeof MembershipsOperationStatus];
export const MembershipsOperationType = {
  CourseEnrollment: 'COURSE_ENROLLMENT',
  Expiration: 'EXPIRATION',
  MembershipEnrollment: 'MEMBERSHIP_ENROLLMENT',
  Suspension: 'SUSPENSION',
  Withdrawal: 'WITHDRAWAL'
} as const;

export type MembershipsOperationType = typeof MembershipsOperationType[keyof typeof MembershipsOperationType];
export const MembershipsScheduleEventType = {
  Beginning: 'BEGINNING',
  Ending: 'ENDING',
  Expiring: 'EXPIRING',
  MembershipEnrolling: 'MEMBERSHIP_ENROLLING',
  Withdrawing: 'WITHDRAWING'
} as const;

export type MembershipsScheduleEventType = typeof MembershipsScheduleEventType[keyof typeof MembershipsScheduleEventType];
export type Message = {
  readonly __typename?: 'Message';
  readonly content: Scalars['String'];
  readonly role: MessageRole;
};

export const MessageRole = {
  Assistant: 'ASSISTANT',
  System: 'SYSTEM',
  User: 'USER'
} as const;

export type MessageRole = typeof MessageRole[keyof typeof MessageRole];
export type MoneyTrainingProgram = {
  readonly __typename?: 'MoneyTrainingProgram';
  readonly event: Event;
  readonly id: Scalars['ID'];
  readonly moneyTrainingProgramGroup: MoneyTrainingProgramGroup;
};

export type MoneyTrainingProgramGroup = {
  readonly __typename?: 'MoneyTrainingProgramGroup';
  readonly id: Scalars['ID'];
  readonly moneyTrainingPrograms: ReadonlyArray<MoneyTrainingProgram>;
  readonly name: Scalars['String'];
};

/** The connection type for MoneyTrainingProgramGroup. */
export type MoneyTrainingProgramGroupConnection = {
  readonly __typename?: 'MoneyTrainingProgramGroupConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<MoneyTrainingProgramGroupEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<MoneyTrainingProgramGroup>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MoneyTrainingProgramGroupEdge = {
  readonly __typename?: 'MoneyTrainingProgramGroupEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: MoneyTrainingProgramGroup;
};

export type MonthlyActivityReport = {
  readonly __typename?: 'MonthlyActivityReport';
  readonly month: Scalars['Int'];
  readonly numberOfCompletedCourses: Scalars['Int'];
  readonly numberOfCompletedLessons: Scalars['Int'];
  readonly numberOfLearningDates: Scalars['Int'];
  readonly numberOfStartedCourses: Scalars['Int'];
  readonly user: User;
  readonly year: Scalars['Int'];
};

export type MonthlyGoal = {
  readonly __typename?: 'MonthlyGoal';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly goal?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly month?: Maybe<Scalars['Int']>;
  readonly nextActions?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly progress?: Maybe<Scalars['Int']>;
  readonly reflection?: Maybe<Scalars['String']>;
  readonly reviews?: Maybe<Scalars['String']>;
  readonly todos?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user?: Maybe<User>;
  readonly year?: Maybe<Scalars['Int']>;
};

export const MotivationCheck = {
  Level_0: 'LEVEL_0',
  Level_10: 'LEVEL_10',
  Level_20: 'LEVEL_20',
  Level_30: 'LEVEL_30',
  Level_40: 'LEVEL_40',
  Level_50: 'LEVEL_50',
  Level_60: 'LEVEL_60',
  Level_70: 'LEVEL_70',
  Level_80: 'LEVEL_80',
  Level_90: 'LEVEL_90',
  Level_100: 'LEVEL_100',
  LevelDidNotAsk: 'LEVEL_DID_NOT_ASK'
} as const;

export type MotivationCheck = typeof MotivationCheck[keyof typeof MotivationCheck];
export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly activateOnlinePlusLesson?: Maybe<ActivateOnlinePlusLessonPayload>;
  readonly activateOnlinePlusLessonByUserId?: Maybe<ActivateOnlinePlusLessonByUserIdPayload>;
  /** お気に入りのコースまたはプラスレッスンを追加する */
  readonly addFavorite?: Maybe<AddFavoritePayload>;
  /** 利用規約に同意した履歴を作成する */
  readonly agreeToTerms?: Maybe<AgreeToTermsPayload>;
  readonly appendMoneyTrainingProgramGroupsToUser?: Maybe<AppendMoneyTrainingProgramGroupsToUserPayload>;
  /** 1on1 内定獲得プログラムに申し込む */
  readonly applyForGettingOffersProgram?: Maybe<ApplyForGettingOffersProgramPayload>;
  /** 認定シーメイトに応募する */
  readonly applyShemateCertification: ApplyShemateCertificationPayload;
  readonly approveOrderCancelRequest?: Maybe<ApproveOrderCancelRequestPayload>;
  readonly approveRewardRequest?: Maybe<ApproveRewardRequestPayload>;
  readonly changePaymentSchedulePaymentMethod?: Maybe<ChangePaymentSchedulePaymentMethodPayload>;
  /** 職務経歴書のコーチマークを閉じる */
  readonly closeResumeCoachmark?: Maybe<CloseResumeCoachmarkPayload>;
  readonly confirmAllUnreadNotificationDeliveries?: Maybe<ConfirmAllUnreadNotificationDeliveriesPayload>;
  readonly confirmPopupNotification?: Maybe<ConfirmPopupNotificationPayload>;
  readonly createAdditionalIdentityDocumentReview?: Maybe<CreateAdditionalIdentityDocumentReviewPayload>;
  readonly createAiChatConversation?: Maybe<CreateAiChatConversationPayload>;
  readonly createAiChatInitialConversation?: Maybe<CreateAiChatInitialConversationPayload>;
  readonly createAiChatReply?: Maybe<CreateAiChatReplyPayload>;
  readonly createAiChatRoom?: Maybe<CreateAiChatRoomPayload>;
  readonly createBankAccountReview?: Maybe<CreateBankAccountReviewPayload>;
  /** キャリアカウンセリングの一次審査を作成する */
  readonly createCareerCounselingEntryFirstReview?: Maybe<CreateCareerCounselingEntryFirstReviewPayload>;
  /** キャリアカウンセリングの二次審査を作成する */
  readonly createCareerCounselingEntrySecondReview?: Maybe<CreateCareerCounselingEntrySecondReviewPayload>;
  /** キャリアカウンセリングレポートを作成する */
  readonly createCareerCounselingReport?: Maybe<CreateCareerCounselingReportPayload>;
  /** 契約書郵送に必要な情報を出力したCSVを生成する */
  readonly createContractInfoExport?: Maybe<CreateContractInfoExportPayload>;
  readonly createEntranceFeeItem?: Maybe<CreateEntranceFeeItemPayload>;
  readonly createEvent?: Maybe<CreateEventPayload>;
  readonly createIdentityDocumentReview?: Maybe<CreateIdentityDocumentReviewPayload>;
  readonly createMembershipItem?: Maybe<CreateMembershipItemPayload>;
  readonly createMoneyTrainingProgramGroup?: Maybe<CreateMoneyTrainingProgramGroupPayload>;
  readonly createOnlinePlusLesson?: Maybe<CreateOnlinePlusLessonPayload>;
  readonly createOnlineStudyFaq?: Maybe<CreateOnlineStudyFaqPayload>;
  /** user_id に対応する UserZoomAccount を更新（存在しない場合は作成）する */
  readonly createOrUpdateUserZoomAccountByUserId?: Maybe<CreateOrUpdateUserZoomAccountByUserIdPayload>;
  readonly createOrderCancelRequest?: Maybe<CreateOrderCancelRequestPayload>;
  readonly createPlannerMeta?: Maybe<CreatePlannerMetaPayload>;
  readonly createRegularPlanRecruitment?: Maybe<CreateRegularPlanRecruitmentPayload>;
  readonly createRegularPlanRecruitmentApplication?: Maybe<CreateRegularPlanRecruitmentApplicationPayload>;
  readonly createRole?: Maybe<CreateRolePayload>;
  readonly createSalaryReview?: Maybe<CreateSalaryReviewPayload>;
  readonly createSessionTemplateKey?: Maybe<CreateSessionTemplateKeyPayload>;
  readonly createStudyGroups?: Maybe<CreateStudyGroupsPayload>;
  /** レギュラープラン向けに開催されるクリエイティブ編トレーニングプログラムとなるセッションを一括で予約する */
  readonly createTrainingProgramSessionReservations?: Maybe<CreateTrainingProgramSessionReservationsPayload>;
  readonly createTrialLessonOnlineVariable?: Maybe<CreateTrialLessonOnlineVariablePayload>;
  readonly createUserAppNotificationToken?: Maybe<CreateUserAppNotificationTokenPayload>;
  readonly createUserBadge: CreateUserBadgePayload;
  /** user_id に対応する UserZoomAccount を作成する */
  readonly createUserZoomAccountByZoomEmail?: Maybe<CreateUserZoomAccountByZoomEmailPayload>;
  readonly createVisionAndMap?: Maybe<CreateVisionAndMapPayload>;
  /** Zoom ミーティングの代替ホストを登録する */
  readonly createZoomAlternativeHost?: Maybe<CreateZoomAlternativeHostPayload>;
  readonly deactivateOnlinePlusLessonByUserId?: Maybe<DeactivateOnlinePlusLessonByUserIdPayload>;
  /** ロボペイのアカウントを停止する（admin用） */
  readonly deactivateRobotPaymentsAccount?: Maybe<DeactivateRobotPaymentsAccountPayload>;
  readonly deleteAllEventReservationMatching?: Maybe<DeleteAllEventReservationMatchingPayload>;
  /** 転職日を削除する */
  readonly deleteCareerChange?: Maybe<DeleteCareerChangePayload>;
  readonly deleteIdentityDocumentReview?: Maybe<DeleteIdentityDocumentReviewPayload>;
  /** イレギュラークーポンテンプレート設定を削除する */
  readonly deleteIrregularCouponTemplateSetting?: Maybe<DeleteIrregularCouponTemplateSettingPayload>;
  readonly deleteOnlinePlusLesson?: Maybe<DeleteOnlinePlusLessonPayload>;
  /** お勧めコース・プラスレッスンを削除する */
  readonly deleteOnlineRecommendLearningLesson?: Maybe<DeleteOnlineRecommendLearningLessonPayload>;
  readonly deleteOnlineStudyFaq?: Maybe<DeleteOnlineStudyFaqPayload>;
  /** プランナー詳細情報のレコードを削除する */
  readonly deletePlannerMeta?: Maybe<DeletePlannerMetaPayload>;
  readonly deleteRegularPlanRecruitment?: Maybe<DeleteRegularPlanRecruitmentPayload>;
  /** 却下されたキャリアカウンセリングの二次審査を削除する */
  readonly deleteRejectedCareerCounselingEntrySecondReview?: Maybe<DeleteRejectedCareerCounselingEntrySecondReviewPayload>;
  /** ロボペイの顧客重複削除処理を実行する */
  readonly deleteRobotPaymentsCustomerForDuplicate?: Maybe<DeleteRobotPaymentsCustomerForDuplicatePayload>;
  readonly deleteStudyGroup?: Maybe<DeleteStudyGroupPayload>;
  readonly deleteTrialLessonOnlineVariable?: Maybe<DeleteTrialLessonOnlineVariablePayload>;
  /** ユーザーのカード決済情報を削除する */
  readonly deleteUserCardPaymentInfo?: Maybe<DeleteUserCardPaymentInfoPayload>;
  /** user_id に対応する UserZoomAccount を削除する */
  readonly deleteUserZoomAccountByUserId?: Maybe<DeleteUserZoomAccountByUserIdPayload>;
  /** Zoom ミーティングの代替ホストを削除する */
  readonly deleteZoomAlternativeHost?: Maybe<DeleteZoomAlternativeHostPayload>;
  readonly directlyEarnBadge: DirectlyEarnBadgePayload;
  /** LINE追客を終了 */
  readonly endLineNurturing?: Maybe<EndLineNurturingPayload>;
  /** current_userに紐づくRobotPayments::Customerを取得または作成する。customer_idを返す */
  readonly findOrCreateRobotPaymentsCustomer?: Maybe<FindOrCreateRobotPaymentsCustomerPayload>;
  readonly importOnlineStudyFaqs?: Maybe<ImportOnlineStudyFaqsPayload>;
  readonly importRewardRequest?: Maybe<ImportRewardRequestPayload>;
  readonly lineSync?: Maybe<LineSyncPayload>;
  readonly linkXAccount?: Maybe<LinkXAccountPayload>;
  readonly permitTrialMembership?: Maybe<PermitTrialMembershipPayload>;
  readonly rejectOrderCancelRequest?: Maybe<RejectOrderCancelRequestPayload>;
  readonly rejectRewardRequest?: Maybe<RejectRewardRequestPayload>;
  /** お気に入りのコース・プラスレッスンを削除する */
  readonly removeFavorite?: Maybe<RemoveFavoritePayload>;
  /** セッションの予約をリスケする */
  readonly rescheduleSessionReservation?: Maybe<RescheduleSessionReservationPayload>;
  readonly revokeTrialMembershipPermission?: Maybe<RevokeTrialMembershipPermissionPayload>;
  readonly selfAssignTrialLessonPosition?: Maybe<SelfAssignTrialLessonPositionPayload>;
  /** LINEメッセージを送信 */
  readonly sendLineMessage?: Maybe<SendLineMessagePayload>;
  /** current_userに紐づくRobotPayments::Customerの銀行口座情報を同期する */
  readonly syncRobotPaymentsAccount?: Maybe<SyncRobotPaymentsAccountPayload>;
  readonly trackLearning?: Maybe<TrackLearningPayload>;
  readonly trackOnlineBlockVideoProgress?: Maybe<TrackOnlineBlockVideoProgressPayload>;
  readonly trackOnlinePlusLessonVideoProgress?: Maybe<TrackOnlinePlusLessonVideoProgressPayload>;
  readonly unLinkXAccount?: Maybe<UnLinkXAccountPayload>;
  /** ユーザーアクティビティの完了状態を更新する */
  readonly updateActivityCompletionStatus?: Maybe<UpdateActivityCompletionStatusPayload>;
  /** 公的書類のアップロード */
  readonly updateAdditionalIdentityDocument?: Maybe<UpdateAdditionalIdentityDocumentPayload>;
  /** 銀行口座情報の更新 */
  readonly updateBankAccount?: Maybe<UpdateBankAccountPayload>;
  /** キャリアカウンセリングの更新 */
  readonly updateCareerCounselingDocument?: Maybe<UpdateCareerCounselingDocumentPayload>;
  /** キャリアカウンセリングレポートを更新する */
  readonly updateCareerCounselingReport?: Maybe<UpdateCareerCounselingReportPayload>;
  /** キャリアデザインコースのワークシートを更新する */
  readonly updateCareerDesignCourseWorkSheet?: Maybe<UpdateCareerDesignCourseWorkSheetPayload>;
  readonly updateCreditCard?: Maybe<UpdateCreditCardPayload>;
  readonly updateCurrentUser?: Maybe<UpdateCurrentUserPayload>;
  readonly updateDefaultStudyMap?: Maybe<UpdateDefaultStudyMapPayload>;
  readonly updateEntranceCeremonyWorkbook?: Maybe<UpdateEntranceCeremonyWorkbookPayload>;
  readonly updateEntranceFeeItem?: Maybe<UpdateEntranceFeeItemPayload>;
  readonly updateEvent?: Maybe<UpdateEventPayload>;
  readonly updateEventReservationCounseling?: Maybe<UpdateEventReservationCounselingPayload>;
  readonly updateEventReservationMatching?: Maybe<UpdateEventReservationMatchingPayload>;
  readonly updateEventReservationProDesignCounseling?: Maybe<UpdateEventReservationProDesignCounselingPayload>;
  /** 長期目標の理想のキャリアを更新する */
  readonly updateIdealCareer?: Maybe<UpdateIdealCareerPayload>;
  /** 本人確認書類のアップロード */
  readonly updateIdentityDocument?: Maybe<UpdateIdentityDocumentPayload>;
  /** LINE追客の対応メモを更新 */
  readonly updateLineNurturingOperationNote?: Maybe<UpdateLineNurturingOperationNotePayload>;
  /** LINE追客の対応ステータスを更新 */
  readonly updateLineNurturingOperationStatus?: Maybe<UpdateLineNurturingOperationStatusPayload>;
  /** LINE追客の担当者を更新 */
  readonly updateLineNurturingOwnerOperator?: Maybe<UpdateLineNurturingOwnerOperatorPayload>;
  /** LINE追客の追客ステータスを更新 */
  readonly updateLineNurturingStatus?: Maybe<UpdateLineNurturingStatusPayload>;
  /** LINE追客タスクの完了状態を更新 */
  readonly updateLineNurturingTask?: Maybe<UpdateLineNurturingTaskPayload>;
  /** なりたい職種と目標を設定する */
  readonly updateLongTermWorkGoal?: Maybe<UpdateLongTermWorkGoalPayload>;
  readonly updateMembershipItem?: Maybe<UpdateMembershipItemPayload>;
  readonly updateMoneyTrainingProgramGroup?: Maybe<UpdateMoneyTrainingProgramGroupPayload>;
  readonly updateOnlineBlock?: Maybe<UpdateOnlineBlockPayload>;
  readonly updateOnlinePlusLesson?: Maybe<UpdateOnlinePlusLessonPayload>;
  /** お勧めコース・プラスレッスンの順番を一括更新する */
  readonly updateOnlineRecommendLearningLessonPositions?: Maybe<UpdateOnlineRecommendLearningLessonPositionsPayload>;
  readonly updateOnlineStudyFaq?: Maybe<UpdateOnlineStudyFaqPayload>;
  readonly updateOrderByCoupon?: Maybe<UpdateOrderByCouponPayload>;
  /** 履歴書を更新する */
  readonly updatePersonalSummary?: Maybe<UpdatePersonalSummaryPayload>;
  readonly updatePositionOfOnlinePlusLessons?: Maybe<UpdatePositionOfOnlinePlusLessonsPayload>;
  readonly updatePositionOfStudyFaqs?: Maybe<UpdatePositionOfStudyFaqsPayload>;
  readonly updateRefundSchedule?: Maybe<UpdateRefundSchedulePayload>;
  readonly updateRegularPlanRecruitment?: Maybe<UpdateRegularPlanRecruitmentPayload>;
  /** 職務経歴書を更新する */
  readonly updateResume?: Maybe<UpdateResumePayload>;
  readonly updateRole?: Maybe<UpdateRolePayload>;
  /** 給与明細を更新する */
  readonly updateSalary?: Maybe<UpdateSalaryPayload>;
  readonly updateStudyGroup?: Maybe<UpdateStudyGroupPayload>;
  readonly updateSubsidyToNoneByUserId?: Maybe<UpdateSubsidyToNoneByUserIdPayload>;
  /** Update token */
  readonly updateToken?: Maybe<UpdateTokenPayload>;
  readonly updateTrainingProgramPackage?: Maybe<UpdateTrainingProgramPackagePayload>;
  /** Update Trial Lesson Matching */
  readonly updateTrialLessonMatching?: Maybe<UpdateTrialLessonMatchingPayload>;
  readonly updateTrialLessonOnlineVariable?: Maybe<UpdateTrialLessonOnlineVariablePayload>;
  readonly updateTrialLessonPositions?: Maybe<UpdateTrialLessonPositionsPayload>;
  readonly updateUser?: Maybe<UpdateUserPayload>;
  readonly updateUserRegularPlanCompletionAddress?: Maybe<UpdateUserRegularPlanCompletionAddressPayload>;
  readonly uploadMultipleFiles?: Maybe<UploadMultipleFilesPayload>;
  /** 転職日を作成・更新する */
  readonly upsertCareerChange?: Maybe<UpsertCareerChangePayload>;
  /** カウンセリング振り返りを作成・更新する */
  readonly upsertEventReservationCounselingReview?: Maybe<UpsertEventReservationCounselingReviewPayload>;
  /** イレギュラークーポンテンプレート設定を作成・更新する */
  readonly upsertIrregularCouponTemplateSetting?: Maybe<UpsertIrregularCouponTemplateSettingPayload>;
  /** 月間目標を作成・更新する */
  readonly upsertMonthlyGoal?: Maybe<UpsertMonthlyGoalPayload>;
  /** 月間目標の達成度や振り返りを作成・更新する */
  readonly upsertMonthlyGoalReflection?: Maybe<UpsertMonthlyGoalReflectionPayload>;
  /** 月間目標の目標やTodoを作成・更新する */
  readonly upsertMonthlyGoalSetting?: Maybe<UpsertMonthlyGoalSettingPayload>;
  /** 新規カウンセリング振り返りを作成・更新する */
  readonly upsertNewEventReservationCounselingReview?: Maybe<UpsertNewEventReservationCounselingReviewPayload>;
  /** お勧めコース・プラスレッスンを作成・更新する */
  readonly upsertOnlineRecommendLearningLesson?: Maybe<UpsertOnlineRecommendLearningLessonPayload>;
  /** 本人確認書類・公的書類の共通メモを作成・更新する */
  readonly upsertSensitiveDocumentMemo?: Maybe<UpsertSensitiveDocumentMemoPayload>;
};


export type MutationActivateOnlinePlusLessonArgs = {
  input: ActivateOnlinePlusLessonInput;
};


export type MutationActivateOnlinePlusLessonByUserIdArgs = {
  input: ActivateOnlinePlusLessonByUserIdInput;
};


export type MutationAddFavoriteArgs = {
  input: AddFavoriteInput;
};


export type MutationAgreeToTermsArgs = {
  input: AgreeToTermsInput;
};


export type MutationAppendMoneyTrainingProgramGroupsToUserArgs = {
  input: AppendMoneyTrainingProgramGroupsToUserInput;
};


export type MutationApplyForGettingOffersProgramArgs = {
  input: ApplyForGettingOffersProgramInput;
};


export type MutationApplyShemateCertificationArgs = {
  input: ApplyShemateCertificationInput;
};


export type MutationApproveOrderCancelRequestArgs = {
  input: ApproveOrderCancelRequestInput;
};


export type MutationApproveRewardRequestArgs = {
  input: ApproveRewardRequestInput;
};


export type MutationChangePaymentSchedulePaymentMethodArgs = {
  input: ChangePaymentSchedulePaymentMethodInput;
};


export type MutationCloseResumeCoachmarkArgs = {
  input: CloseResumeCoachmarkInput;
};


export type MutationConfirmAllUnreadNotificationDeliveriesArgs = {
  input: ConfirmAllUnreadNotificationDeliveriesInput;
};


export type MutationConfirmPopupNotificationArgs = {
  input: ConfirmPopupNotificationInput;
};


export type MutationCreateAdditionalIdentityDocumentReviewArgs = {
  input: CreateAdditionalIdentityDocumentReviewInput;
};


export type MutationCreateAiChatConversationArgs = {
  input: CreateAiChatConversationInput;
};


export type MutationCreateAiChatInitialConversationArgs = {
  input: CreateAiChatInitialConversationInput;
};


export type MutationCreateAiChatReplyArgs = {
  input: CreateAiChatReplyInput;
};


export type MutationCreateAiChatRoomArgs = {
  input: CreateAiChatRoomInput;
};


export type MutationCreateBankAccountReviewArgs = {
  input: CreateBankAccountReviewInput;
};


export type MutationCreateCareerCounselingEntryFirstReviewArgs = {
  input: CreateCareerCounselingEntryFirstReviewInput;
};


export type MutationCreateCareerCounselingEntrySecondReviewArgs = {
  input: CreateCareerCounselingEntrySecondReviewInput;
};


export type MutationCreateCareerCounselingReportArgs = {
  input: CreateCareerCounselingReportInput;
};


export type MutationCreateContractInfoExportArgs = {
  input: CreateContractInfoExportInput;
};


export type MutationCreateEntranceFeeItemArgs = {
  input: CreateEntranceFeeItemInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateIdentityDocumentReviewArgs = {
  input: CreateIdentityDocumentReviewInput;
};


export type MutationCreateMembershipItemArgs = {
  input: CreateMembershipItemInput;
};


export type MutationCreateMoneyTrainingProgramGroupArgs = {
  input: CreateMoneyTrainingProgramGroupInput;
};


export type MutationCreateOnlinePlusLessonArgs = {
  input: CreateOnlinePlusLessonInput;
};


export type MutationCreateOnlineStudyFaqArgs = {
  input: CreateOnlineStudyFaqInput;
};


export type MutationCreateOrUpdateUserZoomAccountByUserIdArgs = {
  input: CreateOrUpdateUserZoomAccountByUserIdInput;
};


export type MutationCreateOrderCancelRequestArgs = {
  input: CreateOrderCancelRequestInput;
};


export type MutationCreatePlannerMetaArgs = {
  input: CreatePlannerMetaInput;
};


export type MutationCreateRegularPlanRecruitmentArgs = {
  input: CreateRegularPlanRecruitmentInput;
};


export type MutationCreateRegularPlanRecruitmentApplicationArgs = {
  input: CreateRegularPlanRecruitmentApplicationInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSalaryReviewArgs = {
  input: CreateSalaryReviewInput;
};


export type MutationCreateSessionTemplateKeyArgs = {
  input: CreateSessionTemplateKeyInput;
};


export type MutationCreateStudyGroupsArgs = {
  input: CreateStudyGroupsInput;
};


export type MutationCreateTrainingProgramSessionReservationsArgs = {
  input: CreateTrainingProgramSessionReservationsInput;
};


export type MutationCreateTrialLessonOnlineVariableArgs = {
  input: CreateTrialLessonOnlineVariableInput;
};


export type MutationCreateUserAppNotificationTokenArgs = {
  input: CreateUserAppNotificationTokenInput;
};


export type MutationCreateUserBadgeArgs = {
  input: CreateUserBadgeInput;
};


export type MutationCreateUserZoomAccountByZoomEmailArgs = {
  input: CreateUserZoomAccountByZoomEmailInput;
};


export type MutationCreateVisionAndMapArgs = {
  input: CreateVisionAndMapInput;
};


export type MutationCreateZoomAlternativeHostArgs = {
  input: CreateZoomAlternativeHostInput;
};


export type MutationDeactivateOnlinePlusLessonByUserIdArgs = {
  input: DeactivateOnlinePlusLessonByUserIdInput;
};


export type MutationDeactivateRobotPaymentsAccountArgs = {
  input: DeactivateRobotPaymentsAccountInput;
};


export type MutationDeleteAllEventReservationMatchingArgs = {
  input: DeleteAllEventReservationMatchingInput;
};


export type MutationDeleteCareerChangeArgs = {
  input: DeleteCareerChangeInput;
};


export type MutationDeleteIdentityDocumentReviewArgs = {
  input: DeleteIdentityDocumentReviewInput;
};


export type MutationDeleteIrregularCouponTemplateSettingArgs = {
  input: DeleteIrregularCouponTemplateSettingInput;
};


export type MutationDeleteOnlinePlusLessonArgs = {
  input: DeleteOnlinePlusLessonInput;
};


export type MutationDeleteOnlineRecommendLearningLessonArgs = {
  input: DeleteOnlineRecommendLearningLessonInput;
};


export type MutationDeleteOnlineStudyFaqArgs = {
  input: DeleteOnlineStudyFaqInput;
};


export type MutationDeletePlannerMetaArgs = {
  input: DeletePlannerMetaInput;
};


export type MutationDeleteRegularPlanRecruitmentArgs = {
  input: DeleteRegularPlanRecruitmentInput;
};


export type MutationDeleteRejectedCareerCounselingEntrySecondReviewArgs = {
  input: DeleteRejectedCareerCounselingEntrySecondReviewInput;
};


export type MutationDeleteRobotPaymentsCustomerForDuplicateArgs = {
  input: DeleteRobotPaymentsCustomerForDuplicateInput;
};


export type MutationDeleteStudyGroupArgs = {
  input: DeleteStudyGroupInput;
};


export type MutationDeleteTrialLessonOnlineVariableArgs = {
  input: DeleteTrialLessonOnlineVariableInput;
};


export type MutationDeleteUserCardPaymentInfoArgs = {
  input: DeleteUserCardPaymentInfoInput;
};


export type MutationDeleteUserZoomAccountByUserIdArgs = {
  input: DeleteUserZoomAccountByUserIdInput;
};


export type MutationDeleteZoomAlternativeHostArgs = {
  input: DeleteZoomAlternativeHostInput;
};


export type MutationDirectlyEarnBadgeArgs = {
  input: DirectlyEarnBadgeInput;
};


export type MutationEndLineNurturingArgs = {
  input: EndLineNurturingInput;
};


export type MutationFindOrCreateRobotPaymentsCustomerArgs = {
  input: FindOrCreateRobotPaymentsCustomerInput;
};


export type MutationImportOnlineStudyFaqsArgs = {
  input: ImportOnlineStudyFaqsInput;
};


export type MutationImportRewardRequestArgs = {
  input: ImportRewardRequestInput;
};


export type MutationLineSyncArgs = {
  input: LineSyncInput;
};


export type MutationLinkXAccountArgs = {
  input: LinkXAccountInput;
};


export type MutationPermitTrialMembershipArgs = {
  input: PermitTrialMembershipInput;
};


export type MutationRejectOrderCancelRequestArgs = {
  input: RejectOrderCancelRequestInput;
};


export type MutationRejectRewardRequestArgs = {
  input: RejectRewardRequestInput;
};


export type MutationRemoveFavoriteArgs = {
  input: RemoveFavoriteInput;
};


export type MutationRescheduleSessionReservationArgs = {
  input: RescheduleSessionReservationInput;
};


export type MutationRevokeTrialMembershipPermissionArgs = {
  input: RevokeTrialMembershipPermissionInput;
};


export type MutationSelfAssignTrialLessonPositionArgs = {
  input: SelfAssignTrialLessonPositionInput;
};


export type MutationSendLineMessageArgs = {
  input: SendLineMessageInput;
};


export type MutationSyncRobotPaymentsAccountArgs = {
  input: SyncRobotPaymentsAccountInput;
};


export type MutationTrackLearningArgs = {
  input: TrackLearningInput;
};


export type MutationTrackOnlineBlockVideoProgressArgs = {
  input: TrackOnlineBlockVideoProgressInput;
};


export type MutationTrackOnlinePlusLessonVideoProgressArgs = {
  input: TrackOnlinePlusLessonVideoProgressInput;
};


export type MutationUnLinkXAccountArgs = {
  input: UnLinkXAccountInput;
};


export type MutationUpdateActivityCompletionStatusArgs = {
  input: UpdateActivityCompletionStatusInput;
};


export type MutationUpdateAdditionalIdentityDocumentArgs = {
  input: UpdateAdditionalIdentityDocumentInput;
};


export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};


export type MutationUpdateCareerCounselingDocumentArgs = {
  input: UpdateCareerCounselingDocumentInput;
};


export type MutationUpdateCareerCounselingReportArgs = {
  input: UpdateCareerCounselingReportInput;
};


export type MutationUpdateCareerDesignCourseWorkSheetArgs = {
  input: UpdateCareerDesignCourseWorkSheetInput;
};


export type MutationUpdateCreditCardArgs = {
  input: UpdateCreditCardInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUserInput;
};


export type MutationUpdateDefaultStudyMapArgs = {
  input: UpdateDefaultStudyMapInput;
};


export type MutationUpdateEntranceCeremonyWorkbookArgs = {
  input: UpdateEntranceCeremonyWorkbookInput;
};


export type MutationUpdateEntranceFeeItemArgs = {
  input: UpdateEntranceFeeItemInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateEventReservationCounselingArgs = {
  input: UpdateEventReservationCounselingInput;
};


export type MutationUpdateEventReservationMatchingArgs = {
  input: UpdateEventReservationMatchingInput;
};


export type MutationUpdateEventReservationProDesignCounselingArgs = {
  input: UpdateEventReservationProDesignCounselingInput;
};


export type MutationUpdateIdealCareerArgs = {
  input: UpdateIdealCareerInput;
};


export type MutationUpdateIdentityDocumentArgs = {
  input: UpdateIdentityDocumentInput;
};


export type MutationUpdateLineNurturingOperationNoteArgs = {
  input: UpdateLineNurturingOperationNoteInput;
};


export type MutationUpdateLineNurturingOperationStatusArgs = {
  input: UpdateLineNurturingOperationStatusInput;
};


export type MutationUpdateLineNurturingOwnerOperatorArgs = {
  input: UpdateLineNurturingOwnerOperatorInput;
};


export type MutationUpdateLineNurturingStatusArgs = {
  input: UpdateLineNurturingStatusInput;
};


export type MutationUpdateLineNurturingTaskArgs = {
  input: UpdateLineNurturingTaskInput;
};


export type MutationUpdateLongTermWorkGoalArgs = {
  input: UpdateLongTermWorkGoalInput;
};


export type MutationUpdateMembershipItemArgs = {
  input: UpdateMembershipItemInput;
};


export type MutationUpdateMoneyTrainingProgramGroupArgs = {
  input: UpdateMoneyTrainingProgramGroupInput;
};


export type MutationUpdateOnlineBlockArgs = {
  input: UpdateOnlineBlockInput;
};


export type MutationUpdateOnlinePlusLessonArgs = {
  input: UpdateOnlinePlusLessonInput;
};


export type MutationUpdateOnlineRecommendLearningLessonPositionsArgs = {
  input: UpdateOnlineRecommendLearningLessonPositionsInput;
};


export type MutationUpdateOnlineStudyFaqArgs = {
  input: UpdateOnlineStudyFaqInput;
};


export type MutationUpdateOrderByCouponArgs = {
  input: UpdateOrderByCouponInput;
};


export type MutationUpdatePersonalSummaryArgs = {
  input: UpdatePersonalSummaryInput;
};


export type MutationUpdatePositionOfOnlinePlusLessonsArgs = {
  input: UpdatePositionOfOnlinePlusLessonsInput;
};


export type MutationUpdatePositionOfStudyFaqsArgs = {
  input: UpdatePositionOfStudyFaqsInput;
};


export type MutationUpdateRefundScheduleArgs = {
  input: UpdateRefundScheduleInput;
};


export type MutationUpdateRegularPlanRecruitmentArgs = {
  input: UpdateRegularPlanRecruitmentInput;
};


export type MutationUpdateResumeArgs = {
  input: UpdateResumeInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSalaryArgs = {
  input: UpdateSalaryInput;
};


export type MutationUpdateStudyGroupArgs = {
  input: UpdateStudyGroupInput;
};


export type MutationUpdateSubsidyToNoneByUserIdArgs = {
  input: UpdateSubsidyToNoneByUserIdInput;
};


export type MutationUpdateTokenArgs = {
  input: UpdateTokenInput;
};


export type MutationUpdateTrainingProgramPackageArgs = {
  input: UpdateTrainingProgramPackageInput;
};


export type MutationUpdateTrialLessonMatchingArgs = {
  input: UpdateTrialLessonMatchingInput;
};


export type MutationUpdateTrialLessonOnlineVariableArgs = {
  input: UpdateTrialLessonOnlineVariableInput;
};


export type MutationUpdateTrialLessonPositionsArgs = {
  input: UpdateTrialLessonPositionsInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserRegularPlanCompletionAddressArgs = {
  input: UpdateUserRegularPlanCompletionAddressInput;
};


export type MutationUploadMultipleFilesArgs = {
  input: UploadMultipleFilesInput;
};


export type MutationUpsertCareerChangeArgs = {
  input: UpsertCareerChangeInput;
};


export type MutationUpsertEventReservationCounselingReviewArgs = {
  input: UpsertEventReservationCounselingReviewInput;
};


export type MutationUpsertIrregularCouponTemplateSettingArgs = {
  input: UpsertIrregularCouponTemplateSettingInput;
};


export type MutationUpsertMonthlyGoalArgs = {
  input: UpsertMonthlyGoalInput;
};


export type MutationUpsertMonthlyGoalReflectionArgs = {
  input: UpsertMonthlyGoalReflectionInput;
};


export type MutationUpsertMonthlyGoalSettingArgs = {
  input: UpsertMonthlyGoalSettingInput;
};


export type MutationUpsertNewEventReservationCounselingReviewArgs = {
  input: UpsertNewEventReservationCounselingReviewInput;
};


export type MutationUpsertOnlineRecommendLearningLessonArgs = {
  input: UpsertOnlineRecommendLearningLessonInput;
};


export type MutationUpsertSensitiveDocumentMemoArgs = {
  input: UpsertSensitiveDocumentMemoInput;
};

export type NewEventReservationCounselingReview = {
  readonly __typename?: 'NewEventReservationCounselingReview';
  readonly comparisonSchool: Scalars['JSON'];
  readonly concernDetail?: Maybe<Scalars['String']>;
  readonly counselingResult?: Maybe<CounselingResult>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly creditSplitErrorReaction?: Maybe<Scalars['String']>;
  readonly creditSplitStatus?: Maybe<CreditSplitStatus>;
  readonly currentConcerns?: Maybe<Scalars['String']>;
  readonly currentIntentionLevel: CurrentIntentionLevel;
  readonly currentJob?: Maybe<Scalars['String']>;
  readonly customerAttitude?: Maybe<CustomerAttitude>;
  readonly decisionRequirements?: Maybe<Scalars['String']>;
  readonly educationApproach?: Maybe<Scalars['String']>;
  readonly eventReservationPlannerMatchingId?: Maybe<Scalars['Int']>;
  readonly futureScenarioAnalysis?: Maybe<Scalars['String']>;
  readonly hasConductedCoolingOffTalk: Scalars['Boolean'];
  readonly hasSuggested24InstallmentCount: Scalars['Boolean'];
  readonly hasSuggestedCampaign: Scalars['Boolean'];
  readonly hasSuggestedLoan: Scalars['Boolean'];
  readonly hasSuggestedNothing: Scalars['Boolean'];
  readonly hasSuggestedOtherSchoolCampaign: Scalars['Boolean'];
  readonly hasSuggestedTrialMembership: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly idealAchievementChallenges?: Maybe<Scalars['String']>;
  readonly idealSituation?: Maybe<Scalars['String']>;
  readonly idealSituationDetail?: Maybe<Scalars['String']>;
  readonly idealTimeline?: Maybe<IdealTimeline>;
  readonly introductionApproach?: Maybe<Scalars['String']>;
  readonly lastIntentionLevel: NewLastIntentionLevel;
  readonly motivationCheck: MotivationCheck;
  readonly nextCounselingStrategy?: Maybe<Scalars['String']>;
  readonly nonEnrollmentReason?: Maybe<Scalars['String']>;
  readonly notSuggestedReason?: Maybe<Scalars['String']>;
  readonly otherComparisonSchool?: Maybe<Scalars['String']>;
  readonly painPoints?: Maybe<Scalars['String']>;
  readonly participationReason?: Maybe<Scalars['String']>;
  readonly problemIdentification?: Maybe<Scalars['String']>;
  readonly recordingUrl?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** 最終意向度（新規カウンセリング振り返り用） */
export const NewLastIntentionLevel = {
  Level_0: 'LEVEL_0',
  Level_10: 'LEVEL_10',
  Level_20: 'LEVEL_20',
  Level_30: 'LEVEL_30',
  Level_40: 'LEVEL_40',
  Level_50: 'LEVEL_50',
  Level_60: 'LEVEL_60',
  Level_70: 'LEVEL_70',
  Level_80: 'LEVEL_80',
  Level_90: 'LEVEL_90',
  Level_100: 'LEVEL_100',
  LevelDidNotAsk: 'LEVEL_DID_NOT_ASK'
} as const;

export type NewLastIntentionLevel = typeof NewLastIntentionLevel[keyof typeof NewLastIntentionLevel];
export type NexwayApplicant = {
  readonly __typename?: 'NexwayApplicant';
  readonly acceptedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly applicantId?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly nexwayError?: Maybe<NexwayError>;
  readonly nexwayReview?: Maybe<NexwayReview>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type NexwayError = {
  readonly __typename?: 'NexwayError';
  readonly details: ReadonlyArray<Scalars['String']>;
  readonly errorCode: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type NexwayReview = {
  readonly __typename?: 'NexwayReview';
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly nexwayError?: Maybe<Scalars['JSON']>;
  readonly status: NexwayReviewStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly vertificationErrors?: Maybe<Scalars['JSON']>;
};

/** 審査結果のステータス */
export const NexwayReviewStatus = {
  Accepted: 'ACCEPTED',
  Failed: 'FAILED',
  Processing: 'PROCESSING',
  Rejected: 'REJECTED'
} as const;

export type NexwayReviewStatus = typeof NexwayReviewStatus[keyof typeof NexwayReviewStatus];
export type NoNeedToLogInError = {
  readonly __typename?: 'NoNeedToLogInError';
  readonly message: Scalars['String'];
  readonly path?: Maybe<ReadonlyArray<Scalars['String']>>;
};

export type NoNeedToLogInSession = {
  readonly __typename?: 'NoNeedToLogInSession';
  readonly activeReservationCount: Scalars['Int'];
  readonly capacity: Scalars['Int'];
  readonly endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly location?: Maybe<Location>;
  readonly sessionTemplate: NoNeedToLogInSessionTemplate;
  readonly startsAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type NoNeedToLogInSessionTemplate = {
  readonly __typename?: 'NoNeedToLogInSessionTemplate';
  readonly id: Scalars['ID'];
  readonly name?: Maybe<Scalars['String']>;
  readonly online?: Maybe<Scalars['Boolean']>;
};

export type NotEarnedBadge = BadgeWithEarnedInfo & {
  readonly __typename?: 'NotEarnedBadge';
  readonly badge: Badge;
};

export type Order = {
  readonly __typename?: 'Order';
  readonly bills: BillConnection;
  readonly cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly comprehensiveStatus: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly effectiveAt?: Maybe<Scalars['ISO8601Date']>;
  readonly expiresAt?: Maybe<Scalars['ISO8601Date']>;
  readonly hasPendingRefundSchedules: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isAllPaid: Scalars['Boolean'];
  readonly itemName?: Maybe<Scalars['String']>;
  readonly latestBill?: Maybe<Bill>;
  readonly membershipTokens: MembershipTokenConnection;
  readonly paymentSchedules: PaymentScheduleConnection;
  readonly status: OrderStatus;
  readonly subsidyType: OrderSubsidy;
  readonly title: Scalars['String'];
  readonly totalPaymentAmount: Scalars['Int'];
  readonly user: User;
};


export type OrderBillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderHasPendingRefundSchedulesArgs = {
  refundMethod?: InputMaybe<PaymentMethod>;
};


export type OrderIsAllPaidArgs = {
  paymentMethod?: InputMaybe<PaymentMethod>;
};


export type OrderMembershipTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderPaymentSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OrderCancelRequest = {
  readonly __typename?: 'OrderCancelRequest';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly hasCharge: Scalars['Boolean'];
  readonly hasWithdrawal: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly note?: Maybe<Scalars['String']>;
  readonly order: Order;
  readonly paymentMethods: ReadonlyArray<Maybe<PaymentMethod>>;
  readonly penaltyOrder?: Maybe<Order>;
  readonly reason: Scalars['String'];
  readonly rejectedComment?: Maybe<Scalars['String']>;
  readonly requestUser: User;
  readonly reviewUser?: Maybe<User>;
  readonly reviewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly shouldStopSubscription: Scalars['Boolean'];
  readonly status: OrderCancelRequestStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for OrderCancelRequest. */
export type OrderCancelRequestConnection = {
  readonly __typename?: 'OrderCancelRequestConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrderCancelRequestEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<OrderCancelRequest>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrderCancelRequestEdge = {
  readonly __typename?: 'OrderCancelRequestEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: OrderCancelRequest;
};

export const OrderCancelRequestStatus = {
  Approved: 'APPROVED',
  Rejected: 'REJECTED',
  Waiting: 'WAITING'
} as const;

export type OrderCancelRequestStatus = typeof OrderCancelRequestStatus[keyof typeof OrderCancelRequestStatus];
/** The connection type for Order. */
export type OrderConnection = {
  readonly __typename?: 'OrderConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrderEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Order>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrderEdge = {
  readonly __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Order;
};

export const OrderStatus = {
  Active: 'ACTIVE',
  Canceled: 'CANCELED'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];
export const OrderSubsidy = {
  Immediate: 'IMMEDIATE',
  Later: 'LATER',
  None: 'NONE'
} as const;

export type OrderSubsidy = typeof OrderSubsidy[keyof typeof OrderSubsidy];
/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']>;
};

export const PaymentMethod = {
  CreditCard: 'CREDIT_CARD',
  DirectDebit: 'DIRECT_DEBIT',
  Subsidy: 'SUBSIDY',
  Transfer: 'TRANSFER'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];
export type PaymentSchedule = {
  readonly __typename?: 'PaymentSchedule';
  readonly amount: Scalars['Int'];
  readonly code: Scalars['ID'];
  readonly collectionOrder?: Maybe<RobotPaymentsCollectionOrder>;
  readonly dueDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly installmentCount: Scalars['Int'];
  readonly order: Order;
  readonly originalAmount: Scalars['Int'];
  /** @deprecated paidAt の代わりに paidOn や dueDate を使用することを検討してください */
  readonly paidAt: Scalars['ISO8601DateTime'];
  readonly paidOn?: Maybe<Scalars['ISO8601Date']>;
  readonly paymentMethod: PaymentMethod;
  readonly status: PaymentScheduleStatus;
  readonly userRewardHistory?: Maybe<UserRewardHistory>;
};

/** The connection type for PaymentSchedule. */
export type PaymentScheduleConnection = {
  readonly __typename?: 'PaymentScheduleConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<PaymentScheduleEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<PaymentSchedule>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PaymentScheduleEdge = {
  readonly __typename?: 'PaymentScheduleEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: PaymentSchedule;
};

export const PaymentScheduleStatus = {
  Canceled: 'CANCELED',
  Error: 'ERROR',
  Paid: 'PAID',
  Refunded: 'REFUNDED',
  Unpaid: 'UNPAID'
} as const;

export type PaymentScheduleStatus = typeof PaymentScheduleStatus[keyof typeof PaymentScheduleStatus];
export type Permission = {
  readonly __typename?: 'Permission';
  readonly type: PermissionType;
};

export const PermissionType = {
  ApplyOrderCancelRequest: 'APPLY_ORDER_CANCEL_REQUEST',
  ApplyRewardRequest: 'APPLY_REWARD_REQUEST',
  CancelSessions: 'CANCEL_SESSIONS',
  CancelSessionsAsAdmin: 'CANCEL_SESSIONS_AS_ADMIN',
  CreateCareerCounselingEntryFirstReview: 'CREATE_CAREER_COUNSELING_ENTRY_FIRST_REVIEW',
  CreateCareerCounselingEntrySecondReview: 'CREATE_CAREER_COUNSELING_ENTRY_SECOND_REVIEW',
  CreateCareerCounselingReport: 'CREATE_CAREER_COUNSELING_REPORT',
  CreateCoachSkills: 'CREATE_COACH_SKILLS',
  CreateCoachSkillTypes: 'CREATE_COACH_SKILL_TYPES',
  CreateOrder: 'CREATE_ORDER',
  CreateUsers: 'CREATE_USERS',
  CreateUserBadge: 'CREATE_USER_BADGE',
  DeleteAllEventReservationMatching: 'DELETE_ALL_EVENT_RESERVATION_MATCHING',
  DeleteCareerCounselingEntrySecondReview: 'DELETE_CAREER_COUNSELING_ENTRY_SECOND_REVIEW',
  DeleteCoachSkillCertifications: 'DELETE_COACH_SKILL_CERTIFICATIONS',
  DeleteSubscriptions: 'DELETE_SUBSCRIPTIONS',
  DeleteUsers: 'DELETE_USERS',
  DeleteUserCardPaymentInfo: 'DELETE_USER_CARD_PAYMENT_INFO',
  DeleteUserHomeLocations: 'DELETE_USER_HOME_LOCATIONS',
  DeleteUserIdentityDocumentReviews: 'DELETE_USER_IDENTITY_DOCUMENT_REVIEWS',
  ReactiveAdminReservationStatus: 'REACTIVE_ADMIN_RESERVATION_STATUS',
  ReadAdminCoverage: 'READ_ADMIN_COVERAGE',
  ReadAdminLikesCoachesCoachidPage: 'READ_ADMIN_LIKES_COACHES_COACHID_PAGE',
  ReadAdminLikesCoachesPage: 'READ_ADMIN_LIKES_COACHES_PAGE',
  ReadAdminLikesCreateCoachPage: 'READ_ADMIN_LIKES_CREATE_COACH_PAGE',
  ReadAdminLikesCreateFaqCategoryPage: 'READ_ADMIN_LIKES_CREATE_FAQ_CATEGORY_PAGE',
  ReadAdminLikesCreateFaqPage: 'READ_ADMIN_LIKES_CREATE_FAQ_PAGE',
  ReadAdminLikesFaqsFaqidPage: 'READ_ADMIN_LIKES_FAQS_FAQID_PAGE',
  ReadAdminLikesFaqsPage: 'READ_ADMIN_LIKES_FAQS_PAGE',
  ReadAdminLikesFaqCategoriesFaqcategoryidPage: 'READ_ADMIN_LIKES_FAQ_CATEGORIES_FAQCATEGORYID_PAGE',
  ReadAdminLikesFaqCategoriesPage: 'READ_ADMIN_LIKES_FAQ_CATEGORIES_PAGE',
  ReadAdminLikesLocationsLocationidPage: 'READ_ADMIN_LIKES_LOCATIONS_LOCATIONID_PAGE',
  ReadAdminLikesLocationsPage: 'READ_ADMIN_LIKES_LOCATIONS_PAGE',
  ReadAdminLikesRegularPlanRecruitmentsPage: 'READ_ADMIN_LIKES_REGULAR_PLAN_RECRUITMENTS_PAGE',
  ReadAdminLikesUsersIdRegularPlanDocumentsPage: 'READ_ADMIN_LIKES_USERS_ID_REGULAR_PLAN_DOCUMENTS_PAGE',
  ReadAdminLikesV2DiagnosisAnswersAnsweridPage: 'READ_ADMIN_LIKES_V2_DIAGNOSIS_ANSWERS_ANSWERID_PAGE',
  ReadAdminLikesV2DiagnosisAnswersPage: 'READ_ADMIN_LIKES_V2_DIAGNOSIS_ANSWERS_PAGE',
  ReadAdminLikesV2EventsIdPage: 'READ_ADMIN_LIKES_V2_EVENTS_ID_PAGE',
  ReadAdminLikesV2EventsNewPage: 'READ_ADMIN_LIKES_V2_EVENTS_NEW_PAGE',
  ReadAdminLikesV3ApplicationPagesIdPage: 'READ_ADMIN_LIKES_V3_APPLICATION_PAGES_ID_PAGE',
  ReadAdminLikesV3ApplicationPagesNewPage: 'READ_ADMIN_LIKES_V3_APPLICATION_PAGES_NEW_PAGE',
  ReadAdminLikesV3ApplicationPagesPage: 'READ_ADMIN_LIKES_V3_APPLICATION_PAGES_PAGE',
  ReadAdminLikesV3BlocksBlockidPage: 'READ_ADMIN_LIKES_V3_BLOCKS_BLOCKID_PAGE',
  ReadAdminLikesV3CoachSkillTypesIdPage: 'READ_ADMIN_LIKES_V3_COACH_SKILL_TYPES_ID_PAGE',
  ReadAdminLikesV3CoachSkillTypesNewPage: 'READ_ADMIN_LIKES_V3_COACH_SKILL_TYPES_NEW_PAGE',
  ReadAdminLikesV3CoachSkillTypesPage: 'READ_ADMIN_LIKES_V3_COACH_SKILL_TYPES_PAGE',
  ReadAdminLikesV3ContractShippingDatasetsPage: 'READ_ADMIN_LIKES_V3_CONTRACT_SHIPPING_DATASETS_PAGE',
  ReadAdminLikesV3CouponTemplatesIdPage: 'READ_ADMIN_LIKES_V3_COUPON_TEMPLATES_ID_PAGE',
  ReadAdminLikesV3CouponTemplatesPage: 'READ_ADMIN_LIKES_V3_COUPON_TEMPLATES_PAGE',
  ReadAdminLikesV3CoursesIdPage: 'READ_ADMIN_LIKES_V3_COURSES_ID_PAGE',
  ReadAdminLikesV3CoursesPage: 'READ_ADMIN_LIKES_V3_COURSES_PAGE',
  ReadAdminLikesV3CourseExamsExamidPage: 'READ_ADMIN_LIKES_V3_COURSE_EXAMS_EXAMID_PAGE',
  ReadAdminLikesV3DocumentReviewsPage: 'READ_ADMIN_LIKES_V3_DOCUMENT_REVIEWS_PAGE',
  ReadAdminLikesV3ExamPracticalSectionsSectionidPage: 'READ_ADMIN_LIKES_V3_EXAM_PRACTICAL_SECTIONS_SECTIONID_PAGE',
  ReadAdminLikesV3ExamWritingSectionsSectionidPage: 'READ_ADMIN_LIKES_V3_EXAM_WRITING_SECTIONS_SECTIONID_PAGE',
  ReadAdminLikesV3ItemsEntranceFeeItemsIdPage: 'READ_ADMIN_LIKES_V3_ITEMS_ENTRANCE_FEE_ITEMS_ID_PAGE',
  ReadAdminLikesV3ItemsEntranceFeeItemsNewPage: 'READ_ADMIN_LIKES_V3_ITEMS_ENTRANCE_FEE_ITEMS_NEW_PAGE',
  ReadAdminLikesV3ItemsEntranceFeeItemsPage: 'READ_ADMIN_LIKES_V3_ITEMS_ENTRANCE_FEE_ITEMS_PAGE',
  ReadAdminLikesV3ItemsItemPackagesIdPage: 'READ_ADMIN_LIKES_V3_ITEMS_ITEM_PACKAGES_ID_PAGE',
  ReadAdminLikesV3ItemsItemPackagesNewPage: 'READ_ADMIN_LIKES_V3_ITEMS_ITEM_PACKAGES_NEW_PAGE',
  ReadAdminLikesV3ItemsItemPackagesPage: 'READ_ADMIN_LIKES_V3_ITEMS_ITEM_PACKAGES_PAGE',
  ReadAdminLikesV3ItemsMembershipItemsIdPage: 'READ_ADMIN_LIKES_V3_ITEMS_MEMBERSHIP_ITEMS_ID_PAGE',
  ReadAdminLikesV3ItemsMembershipItemsNewPage: 'READ_ADMIN_LIKES_V3_ITEMS_MEMBERSHIP_ITEMS_NEW_PAGE',
  ReadAdminLikesV3ItemsMembershipItemsPage: 'READ_ADMIN_LIKES_V3_ITEMS_MEMBERSHIP_ITEMS_PAGE',
  ReadAdminLikesV3ItemsPage: 'READ_ADMIN_LIKES_V3_ITEMS_PAGE',
  ReadAdminLikesV3LessonsLessonidPage: 'READ_ADMIN_LIKES_V3_LESSONS_LESSONID_PAGE',
  ReadAdminLikesV3MembershipPlansIdPage: 'READ_ADMIN_LIKES_V3_MEMBERSHIP_PLANS_ID_PAGE',
  ReadAdminLikesV3MembershipPlansNewPage: 'READ_ADMIN_LIKES_V3_MEMBERSHIP_PLANS_NEW_PAGE',
  ReadAdminLikesV3MembershipPlansPage: 'READ_ADMIN_LIKES_V3_MEMBERSHIP_PLANS_PAGE',
  ReadAdminLikesV3MulticreatorPackagesIdPage: 'READ_ADMIN_LIKES_V3_MULTICREATOR_PACKAGES_ID_PAGE',
  ReadAdminLikesV3MulticreatorPackagesNewPage: 'READ_ADMIN_LIKES_V3_MULTICREATOR_PACKAGES_NEW_PAGE',
  ReadAdminLikesV3MulticreatorPackagesPage: 'READ_ADMIN_LIKES_V3_MULTICREATOR_PACKAGES_PAGE',
  ReadAdminLikesV3MulticreatorPackagePlansIdPage: 'READ_ADMIN_LIKES_V3_MULTICREATOR_PACKAGE_PLANS_ID_PAGE',
  ReadAdminLikesV3MulticreatorPackagePlansNewPage: 'READ_ADMIN_LIKES_V3_MULTICREATOR_PACKAGE_PLANS_NEW_PAGE',
  ReadAdminLikesV3MulticreatorPackagePlansPage: 'READ_ADMIN_LIKES_V3_MULTICREATOR_PACKAGE_PLANS_PAGE',
  ReadAdminLikesV3NotificationsIdPage: 'READ_ADMIN_LIKES_V3_NOTIFICATIONS_ID_PAGE',
  ReadAdminLikesV3NotificationsNewPage: 'READ_ADMIN_LIKES_V3_NOTIFICATIONS_NEW_PAGE',
  ReadAdminLikesV3NotificationsNotificationidPage: 'READ_ADMIN_LIKES_V3_NOTIFICATIONS_NOTIFICATIONID_PAGE',
  ReadAdminLikesV3NotificationsPage: 'READ_ADMIN_LIKES_V3_NOTIFICATIONS_PAGE',
  ReadAdminLikesV3NotificationEmailTemplatesIdPage: 'READ_ADMIN_LIKES_V3_NOTIFICATION_EMAIL_TEMPLATES_ID_PAGE',
  ReadAdminLikesV3OrdersOrderidMembershipTokensMembershiptokenidTokensPage: 'READ_ADMIN_LIKES_V3_ORDERS_ORDERID_MEMBERSHIP_TOKENS_MEMBERSHIPTOKENID_TOKENS_PAGE',
  ReadAdminLikesV3OrdersOrderidPage: 'READ_ADMIN_LIKES_V3_ORDERS_ORDERID_PAGE',
  ReadAdminLikesV3OrdersPage: 'READ_ADMIN_LIKES_V3_ORDERS_PAGE',
  ReadAdminLikesV3PlannersPage: 'READ_ADMIN_LIKES_V3_PLANNERS_PAGE',
  ReadAdminLikesV3SectionsSectionidPage: 'READ_ADMIN_LIKES_V3_SECTIONS_SECTIONID_PAGE',
  ReadAdminLikesV3ServiceAgreementsIdPage: 'READ_ADMIN_LIKES_V3_SERVICE_AGREEMENTS_ID_PAGE',
  ReadAdminLikesV3ServiceAgreementsNewPage: 'READ_ADMIN_LIKES_V3_SERVICE_AGREEMENTS_NEW_PAGE',
  ReadAdminLikesV3ServiceAgreementsPage: 'READ_ADMIN_LIKES_V3_SERVICE_AGREEMENTS_PAGE',
  ReadAdminLikesV3SessionTemplatesIdPage: 'READ_ADMIN_LIKES_V3_SESSION_TEMPLATES_ID_PAGE',
  ReadAdminLikesV3SessionTemplatesNewPage: 'READ_ADMIN_LIKES_V3_SESSION_TEMPLATES_NEW_PAGE',
  ReadAdminLikesV3SessionTemplatesPage: 'READ_ADMIN_LIKES_V3_SESSION_TEMPLATES_PAGE',
  ReadAdminLikesV3StudyFaqsImportPage: 'READ_ADMIN_LIKES_V3_STUDY_FAQS_IMPORT_PAGE',
  ReadAdminLikesV3SurveysPage: 'READ_ADMIN_LIKES_V3_SURVEYS_PAGE',
  ReadAdminLikesV3SurveysSurveyidPage: 'READ_ADMIN_LIKES_V3_SURVEYS_SURVEYID_PAGE',
  ReadAdminLikesV3SurveySubmissionsPage: 'READ_ADMIN_LIKES_V3_SURVEY_SUBMISSIONS_PAGE',
  ReadAdminLikesV3SurveySubmissionsSurveysubmissionidPage: 'READ_ADMIN_LIKES_V3_SURVEY_SUBMISSIONS_SURVEYSUBMISSIONID_PAGE',
  ReadAdminLikesV3TargetTypeTargetIdNotificationEmailTemplatesNewPage: 'READ_ADMIN_LIKES_V3_TARGET_TYPE_TARGET_ID_NOTIFICATION_EMAIL_TEMPLATES_NEW_PAGE',
  ReadAdminLikesV3TestUsersPage: 'READ_ADMIN_LIKES_V3_TEST_USERS_PAGE',
  ReadAdminLikesV3TokenTypesIdPage: 'READ_ADMIN_LIKES_V3_TOKEN_TYPES_ID_PAGE',
  ReadAdminLikesV3TokenTypesNewPage: 'READ_ADMIN_LIKES_V3_TOKEN_TYPES_NEW_PAGE',
  ReadAdminLikesV3TokenTypesPage: 'READ_ADMIN_LIKES_V3_TOKEN_TYPES_PAGE',
  ReadAdminLikesV3TrainingProgramsTrainingprogramidEditPage: 'READ_ADMIN_LIKES_V3_TRAINING_PROGRAMS_TRAININGPROGRAMID_EDIT_PAGE',
  ReadAdminLikesV3TrialLessonsIdPage: 'READ_ADMIN_LIKES_V3_TRIAL_LESSONS_ID_PAGE',
  ReadAdminLikesV3TrialLessonsNewPage: 'READ_ADMIN_LIKES_V3_TRIAL_LESSONS_NEW_PAGE',
  ReadAdminLikesV3TrialLessonsPage: 'READ_ADMIN_LIKES_V3_TRIAL_LESSONS_PAGE',
  ReadAdminLikesV3TrialLessonConfigPage: 'READ_ADMIN_LIKES_V3_TRIAL_LESSON_CONFIG_PAGE',
  ReadAdminLikesV3WithdrawalsPage: 'READ_ADMIN_LIKES_V3_WITHDRAWALS_PAGE',
  ReadAdminMoneyV2EventsEventidPage: 'READ_ADMIN_MONEY_V2_EVENTS_EVENTID_PAGE',
  ReadAdminMoneyV2EventsNewPage: 'READ_ADMIN_MONEY_V2_EVENTS_NEW_PAGE',
  ReadAdminMoneyV3BlocksBlockidPage: 'READ_ADMIN_MONEY_V3_BLOCKS_BLOCKID_PAGE',
  ReadAdminMoneyV3CoursesIdPage: 'READ_ADMIN_MONEY_V3_COURSES_ID_PAGE',
  ReadAdminMoneyV3CoursesPage: 'READ_ADMIN_MONEY_V3_COURSES_PAGE',
  ReadAdminMoneyV3CourseExamsExamidPage: 'READ_ADMIN_MONEY_V3_COURSE_EXAMS_EXAMID_PAGE',
  ReadAdminMoneyV3EventsNewPage: 'READ_ADMIN_MONEY_V3_EVENTS_NEW_PAGE',
  ReadAdminMoneyV3ExamWritingSectionsSectionidPage: 'READ_ADMIN_MONEY_V3_EXAM_WRITING_SECTIONS_SECTIONID_PAGE',
  ReadAdminMoneyV3LessonsLessonidPage: 'READ_ADMIN_MONEY_V3_LESSONS_LESSONID_PAGE',
  ReadAdminMoneyV3MoneyTrainingProgramGroupsNewPage: 'READ_ADMIN_MONEY_V3_MONEY_TRAINING_PROGRAM_GROUPS_NEW_PAGE',
  ReadAdminMoneyV3MoneyTrainingProgramGroupsPage: 'READ_ADMIN_MONEY_V3_MONEY_TRAINING_PROGRAM_GROUPS_PAGE',
  ReadAdminMoneyV3NotificationsIdPage: 'READ_ADMIN_MONEY_V3_NOTIFICATIONS_ID_PAGE',
  ReadAdminMoneyV3NotificationsNewPage: 'READ_ADMIN_MONEY_V3_NOTIFICATIONS_NEW_PAGE',
  ReadAdminMoneyV3NotificationsPage: 'READ_ADMIN_MONEY_V3_NOTIFICATIONS_PAGE',
  ReadAdminMoneyV3NotificationEmailTemplatesIdPage: 'READ_ADMIN_MONEY_V3_NOTIFICATION_EMAIL_TEMPLATES_ID_PAGE',
  ReadAdminMoneyV3SectionsSectionidPage: 'READ_ADMIN_MONEY_V3_SECTIONS_SECTIONID_PAGE',
  ReadAdminMoneyV3SessionsIdPage: 'READ_ADMIN_MONEY_V3_SESSIONS_ID_PAGE',
  ReadAdminMoneyV3SessionsNewPage: 'READ_ADMIN_MONEY_V3_SESSIONS_NEW_PAGE',
  ReadAdminMoneyV3SessionsSessionidCoachPositionsPositionidPage: 'READ_ADMIN_MONEY_V3_SESSIONS_SESSIONID_COACH_POSITIONS_POSITIONID_PAGE',
  ReadAdminMoneyV3SessionShiftsPage: 'READ_ADMIN_MONEY_V3_SESSION_SHIFTS_PAGE',
  ReadAdminMoneyV3SessionTemplatesIdPage: 'READ_ADMIN_MONEY_V3_SESSION_TEMPLATES_ID_PAGE',
  ReadAdminMoneyV3SessionTemplatesNewPage: 'READ_ADMIN_MONEY_V3_SESSION_TEMPLATES_NEW_PAGE',
  ReadAdminMoneyV3SessionTemplatesPage: 'READ_ADMIN_MONEY_V3_SESSION_TEMPLATES_PAGE',
  ReadAdminMoneyV3TargetTypeTargetIdNotificationEmailTemplatesNewPage: 'READ_ADMIN_MONEY_V3_TARGET_TYPE_TARGET_ID_NOTIFICATION_EMAIL_TEMPLATES_NEW_PAGE',
  ReadAdminMoneyV3TrialLessonsNewPage: 'READ_ADMIN_MONEY_V3_TRIAL_LESSONS_NEW_PAGE',
  ReadAdminMoneyV3TrialLessonsPage: 'READ_ADMIN_MONEY_V3_TRIAL_LESSONS_PAGE',
  ReadAdminMoneyV3TrialLessonsTriallessonidPage: 'READ_ADMIN_MONEY_V3_TRIAL_LESSONS_TRIALLESSONID_PAGE',
  ReadAdminMoneyV3TrialLessonConfigPage: 'READ_ADMIN_MONEY_V3_TRIAL_LESSON_CONFIG_PAGE',
  ReadAdminMoneyV3UsersForMoneyTrainingProgramGroupPage: 'READ_ADMIN_MONEY_V3_USERS_FOR_MONEY_TRAINING_PROGRAM_GROUP_PAGE',
  ReadAdminMoneyV3UsersForMoneyTrainingProgramGroupUseridPage: 'READ_ADMIN_MONEY_V3_USERS_FOR_MONEY_TRAINING_PROGRAM_GROUP_USERID_PAGE',
  ReadBills: 'READ_BILLS',
  ReadCoachPositionsPage: 'READ_COACH_POSITIONS_PAGE',
  ReadContractInfos: 'READ_CONTRACT_INFOS',
  ReadEntranceFeeItems: 'READ_ENTRANCE_FEE_ITEMS',
  ReadEvents: 'READ_EVENTS',
  ReadExam: 'READ_EXAM',
  ReadFaqCategories: 'READ_FAQ_CATEGORIES',
  ReadInstallmentPaymentPlans: 'READ_INSTALLMENT_PAYMENT_PLANS',
  ReadIrregularCouponTemplateSettings: 'READ_IRREGULAR_COUPON_TEMPLATE_SETTINGS',
  ReadLessonActivations: 'READ_LESSON_ACTIVATIONS',
  ReadLessonActivationsPage: 'READ_LESSON_ACTIVATIONS_PAGE',
  ReadLikesImportPage: 'READ_LIKES_IMPORT_PAGE',
  ReadLineChatPage: 'READ_LINE_CHAT_PAGE',
  ReadMailHistory: 'READ_MAIL_HISTORY',
  ReadMembershipItems: 'READ_MEMBERSHIP_ITEMS',
  ReadMembershipPlans: 'READ_MEMBERSHIP_PLANS',
  ReadMembershipPlanGroups: 'READ_MEMBERSHIP_PLAN_GROUPS',
  ReadMembershipTokens: 'READ_MEMBERSHIP_TOKENS',
  ReadOrders: 'READ_ORDERS',
  ReadOrderCancelRequestsPage: 'READ_ORDER_CANCEL_REQUESTS_PAGE',
  ReadPaymentSchedules: 'READ_PAYMENT_SCHEDULES',
  ReadPricingPageForStaff: 'READ_PRICING_PAGE_FOR_STAFF',
  ReadRegularPlanCompletionCertificate: 'READ_REGULAR_PLAN_COMPLETION_CERTIFICATE',
  ReadRegularPlanRecruitments: 'READ_REGULAR_PLAN_RECRUITMENTS',
  ReadRewardRequests: 'READ_REWARD_REQUESTS',
  ReadRoles: 'READ_ROLES',
  ReadSensitiveUserDocumentPage: 'READ_SENSITIVE_USER_DOCUMENT_PAGE',
  ReadSessions: 'READ_SESSIONS',
  ReadSessionShiftsPage: 'READ_SESSION_SHIFTS_PAGE',
  ReadSessionZoomTab: 'READ_SESSION_ZOOM_TAB',
  ReadStudyGroups: 'READ_STUDY_GROUPS',
  ReadTokens: 'READ_TOKENS',
  ReadTokenTransactions: 'READ_TOKEN_TRANSACTIONS',
  ReadTokenTypes: 'READ_TOKEN_TYPES',
  ReadTrainingProgramsPage: 'READ_TRAINING_PROGRAMS_PAGE',
  ReadTrialPlanner: 'READ_TRIAL_PLANNER',
  ReadTrialPlannerMeta: 'READ_TRIAL_PLANNER_META',
  ReadUsers: 'READ_USERS',
  ReadUserDocuments: 'READ_USER_DOCUMENTS',
  ReadUserFullname: 'READ_USER_FULLNAME',
  ReadUserIdentityDocuments: 'READ_USER_IDENTITY_DOCUMENTS',
  ReadUserInReviewIdentityDocuments: 'READ_USER_IN_REVIEW_IDENTITY_DOCUMENTS',
  ReadUserPages: 'READ_USER_PAGES',
  ReadUserPrivacies: 'READ_USER_PRIVACIES',
  ReadUserRobotPayments: 'READ_USER_ROBOT_PAYMENTS',
  ReviewOrderCancelRequest: 'REVIEW_ORDER_CANCEL_REQUEST',
  ReviewRewardRequest: 'REVIEW_REWARD_REQUEST',
  ShowMatchingInfo: 'SHOW_MATCHING_INFO',
  UpdateCareerCounselingReport: 'UPDATE_CAREER_COUNSELING_REPORT',
  UpdateCoachSkillTypes: 'UPDATE_COACH_SKILL_TYPES',
  UpdateIndividualFollowUp: 'UPDATE_INDIVIDUAL_FOLLOW_UP',
  UpdateSubsidyType: 'UPDATE_SUBSIDY_TYPE',
  UpdateUserRegularPlanCompletionAddress: 'UPDATE_USER_REGULAR_PLAN_COMPLETION_ADDRESS',
  WriteAdminReservation: 'WRITE_ADMIN_RESERVATION',
  WriteApplicationPages: 'WRITE_APPLICATION_PAGES',
  WriteCareerChanges: 'WRITE_CAREER_CHANGES',
  WriteCareerCounselingLogs: 'WRITE_CAREER_COUNSELING_LOGS',
  WriteCoachSkillCertifications: 'WRITE_COACH_SKILL_CERTIFICATIONS',
  WriteContractInfos: 'WRITE_CONTRACT_INFOS',
  WriteCouponTemplates: 'WRITE_COUPON_TEMPLATES',
  WriteEntranceFeeItems: 'WRITE_ENTRANCE_FEE_ITEMS',
  WriteEvents: 'WRITE_EVENTS',
  WriteExam: 'WRITE_EXAM',
  WriteFaqCategories: 'WRITE_FAQ_CATEGORIES',
  WriteIrregularCouponTemplateSettings: 'WRITE_IRREGULAR_COUPON_TEMPLATE_SETTINGS',
  WriteItemPackages: 'WRITE_ITEM_PACKAGES',
  WriteLocations: 'WRITE_LOCATIONS',
  WriteMembershipItems: 'WRITE_MEMBERSHIP_ITEMS',
  WriteMembershipPlans: 'WRITE_MEMBERSHIP_PLANS',
  WritePayments: 'WRITE_PAYMENTS',
  WriteRecommendItems: 'WRITE_RECOMMEND_ITEMS',
  WriteRefunds: 'WRITE_REFUNDS',
  WriteRegularPlanRecruitments: 'WRITE_REGULAR_PLAN_RECRUITMENTS',
  WriteRoles: 'WRITE_ROLES',
  WriteServiceAgreements: 'WRITE_SERVICE_AGREEMENTS',
  WriteSubscriptions: 'WRITE_SUBSCRIPTIONS',
  WriteSubscriptionSuspensions: 'WRITE_SUBSCRIPTION_SUSPENSIONS',
  WriteSurveys: 'WRITE_SURVEYS',
  WriteTokens: 'WRITE_TOKENS',
  WriteTokenTypes: 'WRITE_TOKEN_TYPES',
  WriteTrialPlannerMeta: 'WRITE_TRIAL_PLANNER_META',
  WriteUsers: 'WRITE_USERS',
  WriteUserContactingConfig: 'WRITE_USER_CONTACTING_CONFIG',
  WriteUserDetails: 'WRITE_USER_DETAILS',
  WriteUserDocuments: 'WRITE_USER_DOCUMENTS',
  WriteUserHomeLocations: 'WRITE_USER_HOME_LOCATIONS',
  WriteUserIdentityDocumentReviews: 'WRITE_USER_IDENTITY_DOCUMENT_REVIEWS',
  WriteUserPrivacies: 'WRITE_USER_PRIVACIES',
  WriteUserPrivileges: 'WRITE_USER_PRIVILEGES',
  WriteWithdrawals: 'WRITE_WITHDRAWALS'
} as const;

export type PermissionType = typeof PermissionType[keyof typeof PermissionType];
/** Autogenerated input type of PermitTrialMembership */
export type PermitTrialMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of PermitTrialMembership. */
export type PermitTrialMembershipPayload = {
  readonly __typename?: 'PermitTrialMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly trialMembershipPermission: TrialMembershipPermission;
};

export type PersonalSummary = {
  readonly __typename?: 'PersonalSummary';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type Planner = {
  readonly __typename?: 'Planner';
  readonly avgCvrateBucket: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type PlannerMeta = {
  readonly __typename?: 'PlannerMeta';
  readonly careerPath?: Maybe<PlannerMetaCareerPath>;
  readonly chargeCvUser?: Maybe<User>;
  readonly chargeGlUser?: Maybe<User>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly effectiveAt: Scalars['ISO8601DateTime'];
  readonly generation?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly scheduledComebackOn?: Maybe<Scalars['ISO8601Date']>;
  readonly status: PlannerMetaStatus;
  readonly user: User;
};

export const PlannerMetaCareerPath = {
  Career: 'CAREER',
  Expert: 'EXPERT',
  Lead: 'LEAD',
  Other: 'OTHER',
  Specialist: 'SPECIALIST'
} as const;

export type PlannerMetaCareerPath = typeof PlannerMetaCareerPath[keyof typeof PlannerMetaCareerPath];
/** The connection type for PlannerMeta. */
export type PlannerMetaConnection = {
  readonly __typename?: 'PlannerMetaConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<PlannerMetaEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<PlannerMeta>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlannerMetaEdge = {
  readonly __typename?: 'PlannerMetaEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: PlannerMeta;
};

export const PlannerMetaStatus = {
  Graduated: 'GRADUATED',
  Operating: 'OPERATING',
  ShiftReduction: 'SHIFT_REDUCTION',
  TaskSuspension: 'TASK_SUSPENSION'
} as const;

export type PlannerMetaStatus = typeof PlannerMetaStatus[keyof typeof PlannerMetaStatus];
export type PlusLesson = {
  readonly __typename?: 'PlusLesson';
  readonly activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly coaches: ReadonlyArray<Coach>;
  readonly courseCategory?: Maybe<CourseCategory>;
  readonly description: Scalars['String'];
  readonly durationInMinutes: Scalars['Int'];
  readonly heldAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly introductionVideoUrl: Scalars['String'];
  readonly isActivatedByCurrentUser: Scalars['Boolean'];
  readonly mainVideoUrl: Scalars['String'];
  readonly membershipPlanGroups: ReadonlyArray<MembershipPlanGroup>;
  readonly position: Scalars['Int'];
  readonly recommendedFor: Scalars['String'];
  readonly requiredTokenAmount: Scalars['Int'];
  readonly reskilling: Scalars['Boolean'];
  readonly status: PlusLessonStatus;
  readonly thumbnailUrl: Scalars['String'];
  readonly timeline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly videoDurationSeconds: Scalars['Int'];
  readonly videoNotes?: Maybe<Scalars['String']>;
};

/** The connection type for PlusLesson. */
export type PlusLessonConnection = {
  readonly __typename?: 'PlusLessonConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<PlusLessonEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<PlusLesson>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlusLessonEdge = {
  readonly __typename?: 'PlusLessonEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: PlusLesson;
};

export const PlusLessonStatus = {
  Archived: 'ARCHIVED',
  Draft: 'DRAFT',
  Published: 'PUBLISHED'
} as const;

export type PlusLessonStatus = typeof PlusLessonStatus[keyof typeof PlusLessonStatus];
export type PopupNotification = {
  readonly gid: Scalars['ID'];
};

export type PracticalSectionResultNotification = PopupNotification & {
  readonly __typename?: 'PracticalSectionResultNotification';
  readonly courseTitle: Scalars['String'];
  readonly gid: Scalars['ID'];
  readonly sectionTitle: Scalars['String'];
  readonly submission: PracticalSectionSubmission;
};

export type PracticalSectionSubmission = {
  readonly __typename?: 'PracticalSectionSubmission';
  readonly code: Scalars['String'];
  readonly score: Scalars['Int'];
};

export type PriceDetail = {
  readonly __typename?: 'PriceDetail';
  readonly entranceFee?: Maybe<Scalars['Int']>;
  readonly installmentFee?: Maybe<Scalars['Int']>;
  readonly membershipFee?: Maybe<Scalars['Int']>;
};

export type Purchasable = EntranceFeeItem | MembershipItem;

export const PurchasableType = {
  CancelPenaltyItem: 'CANCEL_PENALTY_ITEM',
  EntranceFeeItem: 'ENTRANCE_FEE_ITEM',
  ItemPackage: 'ITEM_PACKAGE',
  MembershipItem: 'MEMBERSHIP_ITEM'
} as const;

export type PurchasableType = typeof PurchasableType[keyof typeof PurchasableType];
export type Query = {
  readonly __typename?: 'Query';
  /** Get an active regular plan recruitment */
  readonly activeRegularPlanRecruitment?: Maybe<RegularPlanRecruitment>;
  /** user_id に対応する UserActivityCompletionLogs の一覧を取得する */
  readonly activityCompletionLogsByUserId: UserActivitySummary;
  /** List attachable money_training_program_groups to money users */
  readonly attachableMoneyTrainingProgramGroups: MoneyTrainingProgramGroupConnection;
  /** 出席済み予約（Session / Event / TrialLesson）を取得する */
  readonly attendedReservations: ReadonlyArray<ReservationUnion>;
  /** Get bill */
  readonly bill?: Maybe<Bill>;
  /** Get cancel_penalty_item by id */
  readonly cancelPenaltyItem: CancelPenaltyItem;
  /** Get cancel_penalty_items */
  readonly cancelPenaltyItems: ReadonlyArray<CancelPenaltyItem>;
  /** user_id に対応する CareerCounseling のデータを取得する */
  readonly careerCounselingByUserId?: Maybe<CareerCounseling>;
  /** 該当のユーザのキャリアカウンセリングのエントリー一覧を取得する */
  readonly careerCounselingEntriesByUserId: ReadonlyArray<CareerCounselingEntry>;
  /** キャリアカウンセリングのエントリーを取得する */
  readonly careerCounselingEntry?: Maybe<CareerCounselingEntry>;
  readonly careerCounselingReport?: Maybe<CareerCounselingReport>;
  /** user_id に対応する CareerCounseling 一覧のデータを取得する */
  readonly careerCounselingsByUserId: ReadonlyArray<CareerCounseling>;
  /** 講師スキルがアクセスできるURL一覧を取得する */
  readonly coachSkillTypeUrls?: Maybe<CoachSkillTypeUrls>;
  /** 契約書送付用CSVリストを一覧で取得する */
  readonly contractInfoExports: ContractInfoExportConnection;
  /** Get coupon_discount by target_type / target_id / coupon_template_id */
  readonly couponDiscount: CouponDiscount;
  /** Get active coupons */
  readonly coupons: ReadonlyArray<Coupon>;
  /** Get current user */
  readonly currentUser?: Maybe<CurrentUser>;
  readonly entranceFeeItem?: Maybe<EntranceFeeItem>;
  /** Get event */
  readonly event?: Maybe<Event>;
  /** Get event reservation by ID */
  readonly eventReservation: EventReservation;
  /** EventReservationConversionHistoryを取得する */
  readonly eventReservationConversionHistory?: Maybe<EventReservationConversionHistory>;
  /** 卒業済み体験レッスンのプランナー一覧を取得する */
  readonly graduatedTrialPlanners?: Maybe<TrialPlannerConnection>;
  /** ユーザーが更新日以降の利用規約に同意したかを判定する */
  readonly hasUserAgreedToUpdatedTerm: Scalars['Boolean'];
  /** 追加提出された本人確認書類が審査中のデータを取得する */
  readonly inReviewAdditionalIdentityDocuments: AdditionalIdentityDocumentConnection;
  /** 銀行口座情報が審査中のデータを取得する */
  readonly inReviewBankAccounts: BankAccountConnection;
  /** 審査中のキャリアカウンセリングのエントリーを取得する */
  readonly inReviewCareerCounselingEntries: CareerCounselingEntryConnection;
  /** 本人確認書類のアップロードが審査中のデータを取得する */
  readonly inReviewIdentityDocuments: IdentityDocumentConnection;
  /** 給与明細が審査中のデータを取得する */
  readonly inReviewSalaryDocuments: SalaryDocumentConnection;
  /** Get installment payment plans */
  readonly installmentPaymentPlans: InstallmentPaymentPlanConnection;
  /** 指定してフラグに応じたイレギュラークーポンテンプレート設定一覧を取得する */
  readonly irregularCouponTemplateSettings: IrregularCouponTemplateSettingConnection;
  /** イレギュラーサーベイ一覧を取得する */
  readonly irregularSurveys?: Maybe<ReadonlyArray<Survey>>;
  readonly itemPackageByKey?: Maybe<ItemPackage>;
  /** Get jisui_info for a trial lesson */
  readonly jisuiInfo: JisuiInfo;
  /** 施策一覧を取得 */
  readonly lineCampaigns: ReadonlyArray<LineCampaign>;
  /** ユーザーのLINE連携状況を取得 */
  readonly lineConnectionStatus: LineConnectionStatus;
  /** 会話IDで会話詳細を取得 */
  readonly lineConversationById?: Maybe<LineConversation>;
  /** 会話一覧を取得 */
  readonly lineConversations: ReadonlyArray<LineConversation>;
  /** 追客ステータスごとの対応必要件数を取得 */
  readonly lineNurturingStatusCounts: ReadonlyArray<LineNurturingStatusCount>;
  /** MembershipItemを取得する */
  readonly membershipItem?: Maybe<MembershipItem>;
  /** MembershipItem一覧を取得する */
  readonly membershipItems: MembershipItemConnection;
  readonly membershipPlanGroups: MembershipPlanGroupConnection;
  readonly membershipPlans: MembershipPlanConnection;
  /** Money カリキュラムプラン・コミュニティプランの会員権を持っているユーザーを1件取得する。 */
  readonly moneyStandardPlanUserByUserId?: Maybe<User>;
  /** Money カリキュラムプラン・コミュニティプランの会員権を持っているユーザーを一覧で取得する。 */
  readonly moneyStandardPlanUsers: UserConnection;
  /** Get money_training_program_group */
  readonly moneyTrainingProgramGroup?: Maybe<MoneyTrainingProgramGroup>;
  /** List money_training_program_groups */
  readonly moneyTrainingProgramGroups: MoneyTrainingProgramGroupConnection;
  /** AiChatRoomのメッセージを取得する */
  readonly myAiChatRoom?: Maybe<AiChatRoom>;
  /** AIChatRoom一覧を取得する */
  readonly myAiChatRooms: AiChatRoomConnection;
  /** Get my badges */
  readonly myBadges: UserBadgeInfo;
  /** 現在のユーザーの変更可能なMembershipItemを取得する */
  readonly myChangeableMembershipItem?: Maybe<MembershipItem>;
  /** ログインユーザーの現在の月間目標を取得する */
  readonly myCurrentMonthlyGoal?: Maybe<MonthlyGoal>;
  /** ログインユーザーの長期目標を取得する */
  readonly myLongTermGoal?: Maybe<LongTermGoal>;
  readonly myMonthlyActivityReport?: Maybe<MonthlyActivityReport>;
  /** ログインユーザーの指定した年月の月間目標を取得する */
  readonly myMonthlyGoal?: Maybe<MonthlyGoal>;
  /** ログインユーザーの月間目標一覧を取得する */
  readonly myMonthlyGoals: ReadonlyArray<MonthlyGoal>;
  /** Get my not earned recommended badges */
  readonly myNotEarnedRecommendedBadges: ReadonlyArray<Badge>;
  /** Get my other badge counts */
  readonly myOtherBadgeCounts: Scalars['Int'];
  /** Get my other user badge counts */
  readonly myOtherUserBadgeCounts: Scalars['Int'];
  /** Get payment_schedule by code */
  readonly myPaymentSchedule?: Maybe<PaymentSchedule>;
  readonly myPaymentSchedules: ReadonlyArray<PaymentSchedule>;
  /** Get my permissions */
  readonly myPermissions: ReadonlyArray<Permission>;
  /** Get my recommended user badge counts */
  readonly myRecommendedUserBadgeCounts: Scalars['Int'];
  readonly myRewardHistories: ReadonlyArray<UserRewardHistory>;
  /** Get my social profile */
  readonly mySocialProfile?: Maybe<SocialProfile>;
  /** Get my study_group */
  readonly myStudyGroup?: Maybe<StudyGroup>;
  /** ログインユーザーの指定した年月のタスク一覧を取得する */
  readonly myTodos: ReadonlyArray<Todo>;
  /** 有効な Reward の合計を取得する */
  readonly myTotalAvailableRewardAmount: Scalars['Int'];
  readonly myUnconfirmedPopupNotifications: ReadonlyArray<PopupNotification>;
  /** Get my user badge counts */
  readonly myUserBadgeCounts: Scalars['Int'];
  /** Get my user badges */
  readonly myUserBadges: ReadonlyArray<UserBadge>;
  /** Get online_block by id */
  readonly onlineBlock: Block;
  /** Get online_course by id */
  readonly onlineCourse?: Maybe<Course>;
  /** List online_courses */
  readonly onlineCourses: CourseConnection;
  /** List online_courses by ids */
  readonly onlineCoursesByIds: ReadonlyArray<Course>;
  /** List online_plus_lessons */
  readonly onlinePlusLessons: PlusLessonConnection;
  /** List online_recommend_learning_lessons */
  readonly onlineRecommendLearningLessons: RecommendLearningLessonConnection;
  /** Get online_section by id */
  readonly onlineSection: Section;
  /** List of activated Plus Lessons */
  readonly onlineUserPlusLessonActivationsByUserId: UserPlusLessonActivationConnection;
  /** Orderを取得する */
  readonly order?: Maybe<Order>;
  /** Get order_cancel_request by id */
  readonly orderCancelRequest: OrderCancelRequest;
  /** Get order_cancel_requests */
  readonly orderCancelRequests: OrderCancelRequestConnection;
  /** Get orders by user_id */
  readonly ordersByUserId: OrderConnection;
  /** 指定されたイベント予約IDを軸にカウンセリング結果が存在する過去の体験レッスンのイベント予約を取得する */
  readonly pastTrialLessonEventReservation?: Maybe<ReadonlyArray<EventReservation>>;
  /**
   * order_id に対応する PaymentSchedule の一覧を取得する
   * @deprecated Use `Order.payment_schedules` instead.
   */
  readonly paymentSchedulesByOrderId: PaymentScheduleConnection;
  /** user_id に対応する PaymentSchedule の一覧を取得する */
  readonly paymentSchedulesByUserId: PaymentScheduleConnection;
  /** List published online_course_categories */
  readonly publishedOnlineCourseCategories: ReadonlyArray<CourseCategory>;
  /** Get published online_plus_lesson by id */
  readonly publishedOnlinePlusLesson: PlusLesson;
  /** Get recommended badge counts */
  readonly recommendedBadgeCounts: Scalars['Int'];
  /** Get a regular plan recrutement */
  readonly regularPlanRecruitment?: Maybe<RegularPlanRecruitment>;
  /** Get regular plan recrutements */
  readonly regularPlanRecruitments: RegularPlanRecruitmentConnection;
  /** 予約可能なトレーニングプログラムパッケージ */
  readonly reservableTrainingProgramPackage?: Maybe<TrainingProgramPackage>;
  /** 予約可能なトレーニングプログラムパッケージ一覧 */
  readonly reservableTrainingProgramPackages: TrainingProgramPackageConnection;
  /** user_id に対応する RewardHistory の一覧を取得する */
  readonly rewardHistoriesByUserId: UserRewardHistoryConnection;
  /** Get reward_request */
  readonly rewardRequest?: Maybe<RewardRequest>;
  /** List reward_requests */
  readonly rewardRequests: RewardRequestConnection;
  readonly robotPaymentsTransferSchedules: ReadonlyArray<RobotPaymentsTransferSchedule>;
  /** Get role */
  readonly role?: Maybe<Role>;
  readonly roles: ReadonlyArray<Role>;
  /** Get send mail histories */
  readonly sendMailHistories?: Maybe<SendMailHistoryConnection>;
  /** Get a send mail history */
  readonly sendMailHistory?: Maybe<SendMailHistory>;
  /** Get sensitive_documents by user_id */
  readonly sensitiveDocumentsByUserId?: Maybe<UserSensitiveDocuments>;
  readonly sessionAttendees: ReadonlyArray<User>;
  /** List session template keys */
  readonly sessionTemplateKeys: SessionTemplateKeyConnection;
  /** List sessions */
  readonly sessions: SessionConnection;
  /** 予約可能な入学式セッションのみを返却する。 */
  readonly sessionsEntranceCeremony: ReadonlyArray<NoNeedToLogInSession>;
  /** Simulate order */
  readonly simulateOrder?: Maybe<SimulatedOrderResult>;
  /** Get study_group by id */
  readonly studyGroup?: Maybe<StudyGroup>;
  /** Get study_groups */
  readonly studyGroups: StudyGroupConnection;
  /** List study_groups by session_id */
  readonly studyGroupsBySessionId: StudyGroupConnection;
  /** Get token by id */
  readonly token?: Maybe<Token>;
  /** user_id に対応する有効な Reward の合計を取得する */
  readonly totalAvailableRewardAmountByUserId: Scalars['Int'];
  /** user_id に対応する動画の合計視聴時間を取得する */
  readonly totalVideoSecondsByUserId: Scalars['Int'];
  /** トレーニングプログラムパッケージ詳細 */
  readonly trainingProgramPackage?: Maybe<TrainingProgramPackage>;
  /** トレーニングプログラムパッケージ一覧 */
  readonly trainingProgramPackages: TrainingProgramPackageConnection;
  /** Get Trial Lesson */
  readonly trialLesson: TrialLesson;
  /** Get Trial Lesson Online Variables */
  readonly trialLessonOnlineVariables: ReadonlyArray<TrialLessonOnlineVariable>;
  /** 指定したUserIdをベースにシフトインを取得します */
  readonly trialLessonPositionsByUserId: TrialLessonPositionConnection;
  /** 体験レッスンのプランナー詳細を取得する */
  readonly trialPlanner?: Maybe<TrialPlanner>;
  /** 体験レッスンのプランナー一覧を取得する */
  readonly trialPlanners?: Maybe<TrialPlannerConnection>;
  /** 詳細情報を持たない、体験レッスンのプランナー一覧を取得する */
  readonly trialPlannersWithoutMeta?: Maybe<TrialPlannerConnection>;
  /** User を取得する */
  readonly user?: Maybe<User>;
  readonly userActivityCompletionLogsCategory: ReadonlyArray<Category>;
  /** user_id に対応する UserBadges の一覧を取得する */
  readonly userBadgesByUserId: UserBadgeConnection;
  /** User の名前を取得する */
  readonly userName?: Maybe<UserName>;
  /** レギュラープラン修了証を取得する */
  readonly userRegularPlanCompletion?: Maybe<UserRegularPlanCompletion>;
  /** user_id に対応するレギュラープラン修了証を取得する */
  readonly userRegularPlanCompletionByUserId?: Maybe<UserRegularPlanCompletion>;
  /** ログインユーザーの指定されたサーベイの回答を取得する */
  readonly userSurveySubmissionsBySurveyKey?: Maybe<ReadonlyArray<SurveySubmission>>;
  /** user_id に対応する UserZoomAccount を取得する */
  readonly userZoomAccountByUserId?: Maybe<UserZoomAccount>;
  /** すべての UserZoomAccount を取得する */
  readonly userZoomAccounts: UserZoomAccountConnection;
  /** 設定可能なクーポンテンプレート一覧を取得する */
  readonly withoutSettingCouponTemplates?: Maybe<ReadonlyArray<CouponTemplate>>;
  /** user_id に対応する XAccount を取得する */
  readonly xAccountByUserId?: Maybe<XAccount>;
  /** Zoom ミーティングの代替ホスト一覧を取得する */
  readonly zoomAlternativeHosts: ReadonlyArray<ZoomAlternativeHost>;
};


export type QueryActivityCompletionLogsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryAttachableMoneyTrainingProgramGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAttendedReservationsArgs = {
  limit: Scalars['Int'];
  recentMonths: Scalars['Int'];
  services: ReadonlyArray<Service>;
};


export type QueryBillArgs = {
  billId: Scalars['ID'];
};


export type QueryCancelPenaltyItemArgs = {
  id: Scalars['ID'];
};


export type QueryCareerCounselingByUserIdArgs = {
  counselingKey: CounselingKey;
  userId: Scalars['ID'];
};


export type QueryCareerCounselingEntriesByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryCareerCounselingEntryArgs = {
  id: Scalars['ID'];
};


export type QueryCareerCounselingReportArgs = {
  careerCounselingReportId: Scalars['ID'];
};


export type QueryCareerCounselingsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryCoachSkillTypeUrlsArgs = {
  coachSkillTypeId: Scalars['ID'];
};


export type QueryContractInfoExportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCouponDiscountArgs = {
  couponTemplateId: Scalars['ID'];
  targetId: Scalars['ID'];
  targetType: PurchasableType;
};


export type QueryCouponsArgs = {
  availableToId?: InputMaybe<Scalars['ID']>;
};


export type QueryEntranceFeeItemArgs = {
  entranceFeeItemId: Scalars['ID'];
};


export type QueryEventArgs = {
  id: Scalars['ID'];
};


export type QueryEventReservationArgs = {
  eventReservationId: Scalars['ID'];
};


export type QueryEventReservationConversionHistoryArgs = {
  eventReservationId: Scalars['ID'];
};


export type QueryGraduatedTrialPlannersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryHasUserAgreedToUpdatedTermArgs = {
  serviceType: TermServiceType;
  updatedDate: Scalars['ISO8601Date'];
};


export type QueryInReviewAdditionalIdentityDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryInReviewBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryInReviewCareerCounselingEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<CounselingKey>>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CareerCounselingStatus>;
};


export type QueryInReviewIdentityDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryInReviewSalaryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  salaryKey: SalaryKey;
};


export type QueryInstallmentPaymentPlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryIrregularCouponTemplateSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isSubsidy: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryItemPackageByKeyArgs = {
  key: ItemPackageKey;
};


export type QueryJisuiInfoArgs = {
  trialLessonId: Scalars['ID'];
};


export type QueryLineConnectionStatusArgs = {
  userId: Scalars['ID'];
};


export type QueryLineConversationByIdArgs = {
  conversationId: Scalars['ID'];
};


export type QueryLineConversationsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  nurturingStatusId?: InputMaybe<Scalars['ID']>;
  operationStatus?: InputMaybe<LineNurturingOperationStatus>;
  ownerOperator?: InputMaybe<LineOwnerOperatorFilter>;
  ownerOperatorId?: InputMaybe<Scalars['ID']>;
};


export type QueryLineNurturingStatusCountsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  nurturingStatusId?: InputMaybe<Scalars['ID']>;
  ownerOperator?: InputMaybe<LineOwnerOperatorFilter>;
  ownerOperatorId?: InputMaybe<Scalars['ID']>;
};


export type QueryMembershipItemArgs = {
  membershipItemId: Scalars['ID'];
};


export type QueryMembershipItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMembershipPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMembershipPlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMoneyStandardPlanUserByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryMoneyStandardPlanUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMoneyTrainingProgramGroupArgs = {
  id: Scalars['ID'];
};


export type QueryMoneyTrainingProgramGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyAiChatRoomArgs = {
  aiChatRoomId?: InputMaybe<Scalars['ID']>;
};


export type QueryMyAiChatRoomsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyChangeableMembershipItemArgs = {
  nextMembershipItemId: Scalars['ID'];
};


export type QueryMyMonthlyActivityReportArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryMyMonthlyGoalArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryMyNotEarnedRecommendedBadgesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryMyPaymentScheduleArgs = {
  code: Scalars['ID'];
};


export type QueryMyPaymentSchedulesArgs = {
  service: Service;
};


export type QueryMyTodosArgs = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryMyUserBadgesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryOnlineBlockArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOnlineCourseArgs = {
  id: Scalars['ID'];
};


export type QueryOnlineCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOnlineCoursesByIdsArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


export type QueryOnlinePlusLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  membershipPlanGroupKeys: ReadonlyArray<MembershipPlanGroupKey>;
  order?: InputMaybe<Scalars['String']>;
  statuses: ReadonlyArray<PlusLessonStatus>;
};


export type QueryOnlineRecommendLearningLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOnlineSectionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOnlineUserPlusLessonActivationsByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryOrderArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderCancelRequestArgs = {
  id: Scalars['ID'];
};


export type QueryOrderCancelRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  status: OrderCancelRequestStatus;
};


export type QueryOrdersByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryPastTrialLessonEventReservationArgs = {
  pivotEventReservationId: Scalars['ID'];
};


export type QueryPaymentSchedulesByOrderIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId: Scalars['ID'];
};


export type QueryPaymentSchedulesByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryPublishedOnlinePlusLessonArgs = {
  id: Scalars['ID'];
};


export type QueryRegularPlanRecruitmentArgs = {
  regularPlanRecruitmentId: Scalars['ID'];
};


export type QueryRegularPlanRecruitmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryReservableTrainingProgramPackageArgs = {
  id: Scalars['ID'];
};


export type QueryReservableTrainingProgramPackagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<TrainingProgramPackageCategory>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRewardHistoriesByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryRewardRequestArgs = {
  id: Scalars['ID'];
};


export type QueryRewardRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  status: RewardRequestStatus;
};


export type QueryRobotPaymentsTransferSchedulesArgs = {
  year: Scalars['Int'];
};


export type QueryRoleArgs = {
  roleId: Scalars['ID'];
};


export type QuerySendMailHistoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QuerySendMailHistoryArgs = {
  sendMailHistoryId: Scalars['ID'];
};


export type QuerySensitiveDocumentsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QuerySessionAttendeesArgs = {
  id: Scalars['ID'];
};


export type QuerySessionTemplateKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyReservable?: InputMaybe<Scalars['Boolean']>;
  sessionType?: InputMaybe<SessionType>;
  startsFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  startsTo?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QuerySessionsEntranceCeremonyArgs = {
  startsFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  startsTo?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QuerySimulateOrderArgs = {
  applicationDate: Scalars['ISO8601Date'];
  couponCode?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['ISO8601Date'];
  durationMonth?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  entranceInstallment?: InputMaybe<Scalars['Int']>;
  installmentType?: InputMaybe<Scalars['String']>;
  membershipInstallment?: InputMaybe<Scalars['Int']>;
  membershipPlanKey: Scalars['String'];
  paymentMethod: PaymentMethod;
  subsidy?: InputMaybe<Scalars['Boolean']>;
  usagePeriodMonths?: InputMaybe<Scalars['Int']>;
};


export type QueryStudyGroupArgs = {
  id: Scalars['ID'];
};


export type QueryStudyGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStudyGroupsBySessionIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['ID'];
};


export type QueryTokenArgs = {
  tokenId: Scalars['ID'];
};


export type QueryTotalAvailableRewardAmountByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryTotalVideoSecondsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryTrainingProgramPackageArgs = {
  id: Scalars['ID'];
};


export type QueryTrainingProgramPackagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryTrialLessonArgs = {
  id: Scalars['ID'];
};


export type QueryTrialLessonOnlineVariablesArgs = {
  currentServiceKey: Scalars['String'];
};


export type QueryTrialLessonPositionsByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  targetMonth?: InputMaybe<Scalars['ISO8601DateTime']>;
  targetRoleKey?: InputMaybe<TrialLessonRoleKey>;
  userId: Scalars['ID'];
};


export type QueryTrialPlannerArgs = {
  userId: Scalars['ID'];
};


export type QueryTrialPlannersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<ReadonlyArray<PlannerMetaStatus>>;
};


export type QueryTrialPlannersWithoutMetaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserBadgesByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryUserNameArgs = {
  id: Scalars['ID'];
};


export type QueryUserRegularPlanCompletionArgs = {
  id: Scalars['ID'];
};


export type QueryUserRegularPlanCompletionByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryUserSurveySubmissionsBySurveyKeyArgs = {
  surveyKey: Scalars['String'];
};


export type QueryUserZoomAccountByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryUserZoomAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryXAccountByUserIdArgs = {
  userId: Scalars['ID'];
};

export type RecommendLearningLesson = {
  readonly __typename?: 'RecommendLearningLesson';
  readonly course?: Maybe<Course>;
  readonly courseId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly plusLesson?: Maybe<PlusLesson>;
  readonly plusLessonId?: Maybe<Scalars['ID']>;
  readonly position: Scalars['Int'];
  readonly thumbnail?: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};

/** The connection type for RecommendLearningLesson. */
export type RecommendLearningLessonConnection = {
  readonly __typename?: 'RecommendLearningLessonConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<RecommendLearningLessonEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<RecommendLearningLesson>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RecommendLearningLessonEdge = {
  readonly __typename?: 'RecommendLearningLessonEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: RecommendLearningLesson;
};

export type RefundSchedule = {
  readonly __typename?: 'RefundSchedule';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly refundMethod: PaymentMethod;
  readonly status: RefundScheduleStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const RefundScheduleStatus = {
  Canceled: 'CANCELED',
  NotRefunded: 'NOT_REFUNDED',
  Refunded: 'REFUNDED'
} as const;

export type RefundScheduleStatus = typeof RefundScheduleStatus[keyof typeof RefundScheduleStatus];
export type RegularPlanCompletionNotification = PopupNotification & {
  readonly __typename?: 'RegularPlanCompletionNotification';
  readonly gid: Scalars['ID'];
};

export type RegularPlanRecruitment = {
  readonly __typename?: 'RegularPlanRecruitment';
  readonly applicationCount: Scalars['Int'];
  readonly capacity: Scalars['Int'];
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly lotteryDate: Scalars['ISO8601Date'];
  readonly planChangeEndsAt: Scalars['ISO8601DateTime'];
  readonly planChangeStartsAt: Scalars['ISO8601DateTime'];
  readonly regularPlanRecruitmentApplications: RegularPlanRecruitmentApplicationConnection;
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly status: RegularPlanRecruitmentStatus;
  readonly title: Scalars['String'];
  readonly winCount: Scalars['Int'];
};


export type RegularPlanRecruitmentRegularPlanRecruitmentApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type RegularPlanRecruitmentApplication = {
  readonly __typename?: 'RegularPlanRecruitmentApplication';
  readonly appliedAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly lotteryResult: RegularPlanRecruitmentApplicationLotteryResult;
  readonly user?: Maybe<User>;
};

/** The connection type for RegularPlanRecruitmentApplication. */
export type RegularPlanRecruitmentApplicationConnection = {
  readonly __typename?: 'RegularPlanRecruitmentApplicationConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<RegularPlanRecruitmentApplicationEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<RegularPlanRecruitmentApplication>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegularPlanRecruitmentApplicationEdge = {
  readonly __typename?: 'RegularPlanRecruitmentApplicationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: RegularPlanRecruitmentApplication;
};

export const RegularPlanRecruitmentApplicationLotteryResult = {
  Lose: 'LOSE',
  Waiting: 'WAITING',
  Win: 'WIN'
} as const;

export type RegularPlanRecruitmentApplicationLotteryResult = typeof RegularPlanRecruitmentApplicationLotteryResult[keyof typeof RegularPlanRecruitmentApplicationLotteryResult];
/** The connection type for RegularPlanRecruitment. */
export type RegularPlanRecruitmentConnection = {
  readonly __typename?: 'RegularPlanRecruitmentConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<RegularPlanRecruitmentEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<RegularPlanRecruitment>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegularPlanRecruitmentEdge = {
  readonly __typename?: 'RegularPlanRecruitmentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: RegularPlanRecruitment;
};

export const RegularPlanRecruitmentStatus = {
  AfterRecruit: 'AFTER_RECRUIT',
  BeforeRecruit: 'BEFORE_RECRUIT',
  LotteryDrawing: 'LOTTERY_DRAWING',
  LotteryFailed: 'LOTTERY_FAILED',
  LotterySucceeded: 'LOTTERY_SUCCEEDED',
  Recruiting: 'RECRUITING'
} as const;

export type RegularPlanRecruitmentStatus = typeof RegularPlanRecruitmentStatus[keyof typeof RegularPlanRecruitmentStatus];
/** Autogenerated input type of RejectOrderCancelRequest */
export type RejectOrderCancelRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly orderCancelRequestId: Scalars['ID'];
  readonly rejectedComment: Scalars['String'];
};

/** Autogenerated return type of RejectOrderCancelRequest. */
export type RejectOrderCancelRequestPayload = {
  readonly __typename?: 'RejectOrderCancelRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly orderCancelRequest?: Maybe<OrderCancelRequest>;
};

/** Autogenerated input type of RejectRewardRequest */
export type RejectRewardRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly rewardRequestId: Scalars['ID'];
};

/** Autogenerated return type of RejectRewardRequest. */
export type RejectRewardRequestPayload = {
  readonly __typename?: 'RejectRewardRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly rewardRequest?: Maybe<RewardRequest>;
};

/** Autogenerated input type of RemoveFavorite */
export type RemoveFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['ID'];
  readonly itemType: FavoriteType;
};

/** Autogenerated return type of RemoveFavorite. */
export type RemoveFavoritePayload = {
  readonly __typename?: 'RemoveFavoritePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of RescheduleSessionReservation */
export type RescheduleSessionReservationInput = {
  readonly cancelReservationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly rescheduleSessionId: Scalars['ID'];
};

/** Autogenerated return type of RescheduleSessionReservation. */
export type RescheduleSessionReservationPayload = {
  readonly __typename?: 'RescheduleSessionReservationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

export type Reservation = {
  readonly __typename?: 'Reservation';
  readonly attendance: ReservationAttendance;
  readonly cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly session: Session;
  readonly status: ReservationStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user: User;
};

export const ReservationAttendance = {
  Absent: 'ABSENT',
  Attended: 'ATTENDED'
} as const;

export type ReservationAttendance = typeof ReservationAttendance[keyof typeof ReservationAttendance];
export const ReservationStatus = {
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  CancelledWithoutPermission: 'CANCELLED_WITHOUT_PERMISSION'
} as const;

export type ReservationStatus = typeof ReservationStatus[keyof typeof ReservationStatus];
export type ReservationUnion = EventReservation | Reservation;

export type ResponseMetadata = {
  readonly __typename?: 'ResponseMetadata';
  readonly choices: ReadonlyArray<Choice>;
  readonly created: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly model: Scalars['String'];
  readonly objectType: Scalars['String'];
  readonly systemFingerprint: Scalars['String'];
  readonly usage: Usage;
};

export type Resume = {
  readonly __typename?: 'Resume';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of RevokeTrialMembershipPermission */
export type RevokeTrialMembershipPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of RevokeTrialMembershipPermission. */
export type RevokeTrialMembershipPermissionPayload = {
  readonly __typename?: 'RevokeTrialMembershipPermissionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly result?: Maybe<Scalars['Boolean']>;
};

export type RewardEarnedNotification = PopupNotification & {
  readonly __typename?: 'RewardEarnedNotification';
  readonly gid: Scalars['ID'];
  readonly rewardHistory: UserRewardHistoryEarned;
};

export type RewardRequest = {
  readonly __typename?: 'RewardRequest';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly requestUser: User;
  readonly reviewUser?: Maybe<User>;
  readonly reviewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly rewardRequestDetails: ReadonlyArray<RewardRequestDetail>;
  readonly rewardRequestDetailsCount: Scalars['Int'];
  readonly status: RewardRequestStatus;
  readonly title: Scalars['String'];
  readonly totalAmount: Scalars['Int'];
  readonly totalUsedAmount: Scalars['Int'];
  readonly totalUsedUserCount: Scalars['Int'];
};

/** The connection type for RewardRequest. */
export type RewardRequestConnection = {
  readonly __typename?: 'RewardRequestConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<RewardRequestEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<RewardRequest>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

export type RewardRequestDetail = {
  readonly __typename?: 'RewardRequestDetail';
  readonly amount: Scalars['Int'];
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly targetUser: User;
};

/** An edge in a connection. */
export type RewardRequestEdge = {
  readonly __typename?: 'RewardRequestEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: RewardRequest;
};

export const RewardRequestStatus = {
  Approved: 'APPROVED',
  Rejected: 'REJECTED',
  Waiting: 'WAITING'
} as const;

export type RewardRequestStatus = typeof RewardRequestStatus[keyof typeof RewardRequestStatus];
export type RewardUsedNotification = PopupNotification & {
  readonly __typename?: 'RewardUsedNotification';
  readonly gid: Scalars['ID'];
  readonly rewardHistory: UserRewardHistoryUsed;
};

export type RobotPaymentsBankAccount = {
  readonly __typename?: 'RobotPaymentsBankAccount';
  readonly accountHolderName: Scalars['String'];
  readonly bankName: Scalars['String'];
  readonly branchName: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly customer: RobotPaymentsCustomer;
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type RobotPaymentsCollectionOrder = {
  readonly __typename?: 'RobotPaymentsCollectionOrder';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly customer: RobotPaymentsCustomer;
  readonly events: ReadonlyArray<RobotPaymentsCollectionOrderEvent>;
  readonly id: Scalars['ID'];
  readonly latestEvent?: Maybe<RobotPaymentsCollectionOrderEvent>;
  readonly paymentScheduleId: Scalars['ID'];
  readonly retryCount: Scalars['Int'];
  readonly status: RobotPaymentsCollectionOrderStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type RobotPaymentsCollectionOrderEvent = {
  readonly __typename?: 'RobotPaymentsCollectionOrderEvent';
  readonly collectionOrder: RobotPaymentsCollectionOrder;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly eventType: RobotPaymentsCollectionOrderEventType;
  readonly id: Scalars['ID'];
  readonly note?: Maybe<Scalars['String']>;
  /** リクエスト正規化JSONのSHA256など */
  readonly requestChecksum: Scalars['String'];
  /** レスポンス正規化JSONのSHA256など */
  readonly responseChecksum: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const RobotPaymentsCollectionOrderEventType = {
  DebitFailedPermanent: 'DEBIT_FAILED_PERMANENT',
  DebitFailedTransient: 'DEBIT_FAILED_TRANSIENT',
  DebitResultFailed: 'DEBIT_RESULT_FAILED',
  DebitScheduled: 'DEBIT_SCHEDULED',
  DebitScheduledNotificationSent: 'DEBIT_SCHEDULED_NOTIFICATION_SENT',
  DebitSettled: 'DEBIT_SETTLED',
  InvoiceAccepted: 'INVOICE_ACCEPTED',
  InvoiceCanceled: 'INVOICE_CANCELED',
  InvoiceEnqueued: 'INVOICE_ENQUEUED',
  InvoiceFailedPermanent: 'INVOICE_FAILED_PERMANENT',
  InvoiceFailedTransient: 'INVOICE_FAILED_TRANSIENT',
  InvoiceNotFound: 'INVOICE_NOT_FOUND',
  InvoiceRequested: 'INVOICE_REQUESTED'
} as const;

export type RobotPaymentsCollectionOrderEventType = typeof RobotPaymentsCollectionOrderEventType[keyof typeof RobotPaymentsCollectionOrderEventType];
export const RobotPaymentsCollectionOrderStatus = {
  DebitFailed: 'DEBIT_FAILED',
  DebitFailedTransient: 'DEBIT_FAILED_TRANSIENT',
  DebitScheduled: 'DEBIT_SCHEDULED',
  DebitSettled: 'DEBIT_SETTLED',
  InvoiceAccepted: 'INVOICE_ACCEPTED',
  InvoiceCanceled: 'INVOICE_CANCELED',
  InvoiceEnqueued: 'INVOICE_ENQUEUED',
  InvoiceFailedPermanent: 'INVOICE_FAILED_PERMANENT',
  InvoiceFailedTransient: 'INVOICE_FAILED_TRANSIENT',
  InvoiceRequested: 'INVOICE_REQUESTED',
  SystemFailed: 'SYSTEM_FAILED'
} as const;

export type RobotPaymentsCollectionOrderStatus = typeof RobotPaymentsCollectionOrderStatus[keyof typeof RobotPaymentsCollectionOrderStatus];
export type RobotPaymentsCustomer = {
  readonly __typename?: 'RobotPaymentsCustomer';
  readonly bankAccount?: Maybe<RobotPaymentsBankAccount>;
  readonly collectionOrders: ReadonlyArray<RobotPaymentsCollectionOrder>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  /** ロボペイの顧客ID */
  readonly customerId: Scalars['String'];
  readonly events: ReadonlyArray<RobotPaymentsCustomerEvent>;
  readonly id: Scalars['ID'];
  readonly latestEvent?: Maybe<RobotPaymentsCustomerEvent>;
  /** ロボペイの顧客ステータス */
  readonly status: RobotPaymentsCustomerStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export type RobotPaymentsCustomerEvent = {
  readonly __typename?: 'RobotPaymentsCustomerEvent';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly customer: RobotPaymentsCustomer;
  readonly eventType: RobotPaymentsCustomerEventType;
  readonly id: Scalars['ID'];
  readonly note?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export const RobotPaymentsCustomerEventType = {
  AccountActivated: 'ACCOUNT_ACTIVATED',
  AccountRegistrationAccepted: 'ACCOUNT_REGISTRATION_ACCEPTED',
  AccountRegistrationCompleted: 'ACCOUNT_REGISTRATION_COMPLETED',
  AccountRegistrationDuplicated: 'ACCOUNT_REGISTRATION_DUPLICATED',
  AccountRegistrationExcluded: 'ACCOUNT_REGISTRATION_EXCLUDED',
  AccountRegistrationFailed: 'ACCOUNT_REGISTRATION_FAILED',
  AccountRegistrationFailedGateway: 'ACCOUNT_REGISTRATION_FAILED_GATEWAY',
  AccountRegistrationRequested: 'ACCOUNT_REGISTRATION_REQUESTED',
  AccountReplaced: 'ACCOUNT_REPLACED',
  CustomerCreated: 'CUSTOMER_CREATED',
  CustomerDeactivated: 'CUSTOMER_DEACTIVATED',
  CustomerExpired: 'CUSTOMER_EXPIRED',
  ExternalClosureCompleted: 'EXTERNAL_CLOSURE_COMPLETED',
  SystemExceptionTransient: 'SYSTEM_EXCEPTION_TRANSIENT'
} as const;

export type RobotPaymentsCustomerEventType = typeof RobotPaymentsCustomerEventType[keyof typeof RobotPaymentsCustomerEventType];
export const RobotPaymentsCustomerStatus = {
  Active: 'ACTIVE',
  Ended: 'ENDED',
  PendingActivate: 'PENDING_ACTIVATE',
  PendingExternal: 'PENDING_EXTERNAL',
  PendingExternalClosure: 'PENDING_EXTERNAL_CLOSURE',
  Unregistered: 'UNREGISTERED'
} as const;

export type RobotPaymentsCustomerStatus = typeof RobotPaymentsCustomerStatus[keyof typeof RobotPaymentsCustomerStatus];
export type RobotPaymentsTransferSchedule = {
  readonly __typename?: 'RobotPaymentsTransferSchedule';
  /** SHEで、振替日をその月の支払いとして選択できる最終日 */
  readonly canUsePaymentMonthUntil: Scalars['ISO8601Date'];
  /** 請求データ登録締切日時（振替日の7営業日前 23:59:59） */
  readonly dataDeadline: Scalars['ISO8601DateTime'];
  /** 何月の支払い分か */
  readonly paymentMonthDate: Scalars['ISO8601Date'];
  /** 結果データ到着日（振替日の3営業日後） */
  readonly resultArrivalDate: Scalars['ISO8601Date'];
  /** 実際の振替日（営業日調整後） */
  readonly transferDate: Scalars['ISO8601Date'];
};

export type Role = {
  readonly __typename?: 'Role';
  readonly coachSkillType?: Maybe<CoachSkill>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly key?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type SalaryDocument = {
  readonly __typename?: 'SalaryDocument';
  readonly certificateOfEmploymentFile?: Maybe<SensitiveFile>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly identityDocumentFile?: Maybe<SensitiveFile>;
  readonly leaveOfAbsenceFile?: Maybe<SensitiveFile>;
  readonly memo?: Maybe<Scalars['String']>;
  readonly payedDate: Scalars['ISO8601Date'];
  readonly salaryKey: SalaryKey;
  readonly salaryReview?: Maybe<SalaryReview>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** 本人確認書類をアップロードしたユーザー */
  readonly user: User;
};

/** The connection type for SalaryDocument. */
export type SalaryDocumentConnection = {
  readonly __typename?: 'SalaryDocumentConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<SalaryDocumentEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SalaryDocument>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SalaryDocumentEdge = {
  readonly __typename?: 'SalaryDocumentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: SalaryDocument;
};

export const SalaryKey = {
  AfterJobChanged: 'AFTER_JOB_CHANGED',
  Former: 'FORMER'
} as const;

export type SalaryKey = typeof SalaryKey[keyof typeof SalaryKey];
export type SalaryReview = {
  readonly __typename?: 'SalaryReview';
  readonly approved: Scalars['Boolean'];
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly reviewer: User;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type Section = {
  readonly __typename?: 'Section';
  readonly blocks: ReadonlyArray<Block>;
  readonly id: Scalars['ID'];
  readonly isMyLastUnlearnedSectionInCourse: Scalars['Boolean'];
  readonly lessonRevision: LessonRevision;
  readonly linkedHomework?: Maybe<LessonHomework>;
  readonly position: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly uid: Scalars['ID'];
};

/** Autogenerated input type of SelfAssignTrialLessonPosition */
export type SelfAssignTrialLessonPositionInput = {
  readonly attendance: TrialLessonPositionAttendance;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly trialLessonRoleRequirementId: Scalars['ID'];
};

/** Autogenerated return type of SelfAssignTrialLessonPosition. */
export type SelfAssignTrialLessonPositionPayload = {
  readonly __typename?: 'SelfAssignTrialLessonPositionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly trialLessonPosition?: Maybe<TrialLessonPosition>;
};

/** Autogenerated input type of SendLineMessage */
export type SendLineMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['ID'];
  readonly image?: InputMaybe<Scalars['Upload']>;
  readonly message?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SendLineMessage. */
export type SendLineMessagePayload = {
  readonly __typename?: 'SendLineMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly message?: Maybe<LineMessage>;
};

export type SendMailHistory = {
  readonly __typename?: 'SendMailHistory';
  readonly body: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly sentAt: Scalars['ISO8601DateTime'];
  readonly subject: Scalars['String'];
  readonly user: User;
};

/** The connection type for SendMailHistory. */
export type SendMailHistoryConnection = {
  readonly __typename?: 'SendMailHistoryConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<SendMailHistoryEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SendMailHistory>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SendMailHistoryEdge = {
  readonly __typename?: 'SendMailHistoryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: SendMailHistory;
};

export type SensitiveDocumentMemo = {
  readonly __typename?: 'SensitiveDocumentMemo';
  readonly comment?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type SensitiveFile = {
  readonly __typename?: 'SensitiveFile';
  readonly base64String: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly filename: Scalars['String'];
  readonly mimeType: Scalars['String'];
  readonly url: Scalars['String'];
};

export const Service = {
  Likes: 'LIKES',
  Money: 'MONEY'
} as const;

export type Service = typeof Service[keyof typeof Service];
export type Session = {
  readonly __typename?: 'Session';
  readonly activeReservationCount: Scalars['Int'];
  readonly canCancelByCurrentUser: Scalars['Boolean'];
  readonly capacity: Scalars['Int'];
  readonly coachPositions: ReadonlyArray<CoachPosition>;
  readonly endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly hostZoomUrl?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly location?: Maybe<Location>;
  readonly minNumberOfParticipants: Scalars['Int'];
  readonly note?: Maybe<Scalars['String']>;
  readonly publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly sessionTemplate: SessionTemplate;
  readonly startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly stringSessionParametersZoomUrl: ReadonlyArray<StringSessionParameter>;
  readonly userZoomAccount?: Maybe<UserZoomAccount>;
  readonly videoProvider: Scalars['String'];
  readonly visibility: SessionVisibility;
  readonly zoomUrl?: Maybe<Scalars['String']>;
};

/** The connection type for Session. */
export type SessionConnection = {
  readonly __typename?: 'SessionConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<SessionEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Session>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SessionEdge = {
  readonly __typename?: 'SessionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: Session;
};

export type SessionTemplate = {
  readonly __typename?: 'SessionTemplate';
  readonly archived: Scalars['Boolean'];
  readonly defaultCapacity?: Maybe<Scalars['Int']>;
  readonly defaultMinNumberOfParticipants: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly key?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly online?: Maybe<Scalars['Boolean']>;
  readonly requiredTokenAmount: Scalars['Int'];
  readonly sessionType?: Maybe<SessionType>;
};

export type SessionTemplateKey = {
  readonly __typename?: 'SessionTemplateKey';
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
};

/** The connection type for SessionTemplateKey. */
export type SessionTemplateKeyConnection = {
  readonly __typename?: 'SessionTemplateKeyConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<SessionTemplateKeyEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SessionTemplateKey>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SessionTemplateKeyEdge = {
  readonly __typename?: 'SessionTemplateKeyEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: SessionTemplateKey;
};

export const SessionType = {
  CareerCounseling: 'CAREER_COUNSELING',
  CoursePlanningMeeting: 'COURSE_PLANNING_MEETING',
  GettingOffersCoaching: 'GETTING_OFFERS_COACHING',
  GroupCoaching: 'GROUP_COACHING',
  InitialMulticreatorCareerCoaching: 'INITIAL_MULTICREATOR_CAREER_COACHING',
  Lesson: 'LESSON',
  Mokumoku: 'MOKUMOKU',
  MulticreatorCareerCoaching: 'MULTICREATOR_CAREER_COACHING',
  MulticreatorEntranceCeremony: 'MULTICREATOR_ENTRANCE_CEREMONY',
  MulticreatorFinalReview: 'MULTICREATOR_FINAL_REVIEW',
  MulticreatorGroupFeedback: 'MULTICREATOR_GROUP_FEEDBACK',
  MulticreatorIntermediateReview: 'MULTICREATOR_INTERMEDIATE_REVIEW',
  MulticreatorLectureCareer: 'MULTICREATOR_LECTURE_CAREER',
  OneOnOneCoaching: 'ONE_ON_ONE_COACHING',
  SecondMulticreatorCareerCoaching: 'SECOND_MULTICREATOR_CAREER_COACHING',
  StudyGroupMeeting: 'STUDY_GROUP_MEETING',
  TrainingProgram: 'TRAINING_PROGRAM'
} as const;

export type SessionType = typeof SessionType[keyof typeof SessionType];
export const SessionVisibility = {
  CoachOnly: 'COACH_ONLY',
  Hidden: 'HIDDEN',
  Public: 'PUBLIC'
} as const;

export type SessionVisibility = typeof SessionVisibility[keyof typeof SessionVisibility];
export type ShemateCertification = {
  readonly __typename?: 'ShemateCertification';
  readonly applicationConditions: ReadonlyArray<ShemateCertificationApplicationCondition>;
  readonly applicationEndsAt: Scalars['ISO8601DateTime'];
  readonly applicationStartsAt: Scalars['ISO8601DateTime'];
  readonly hasApplied: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly isApplicationOpen: Scalars['Boolean'];
  readonly name: Scalars['String'];
};

export type ShemateCertificationApplication = {
  readonly __typename?: 'ShemateCertificationApplication';
  readonly appliedAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly shemateCertificationId: Scalars['String'];
};

export type ShemateCertificationApplicationCondition = {
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
};

export type ShemateCertificationCourseCondition = ShemateCertificationApplicationCondition & {
  readonly __typename?: 'ShemateCertificationCourseCondition';
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
  readonly requiredCourses: ReadonlyArray<ShemateCertificationRequiredCourse>;
};

export type ShemateCertificationCourseExamCondition = ShemateCertificationApplicationCondition & {
  readonly __typename?: 'ShemateCertificationCourseExamCondition';
  readonly course: Course;
  readonly courseId: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
};

export type ShemateCertificationRequiredCourse = {
  readonly __typename?: 'ShemateCertificationRequiredCourse';
  readonly course: Course;
  readonly courseId: Scalars['Int'];
  readonly isCompleted: Scalars['Boolean'];
  /** nullの場合はコース内の全レッスンが必要 */
  readonly requiredLessonIds?: Maybe<ReadonlyArray<Scalars['Int']>>;
};

export type ShemateCertificationWorksAchievementCondition = ShemateCertificationApplicationCondition & {
  readonly __typename?: 'ShemateCertificationWorksAchievementCondition';
  readonly count: Scalars['Int'];
  readonly filterKey: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
};

export type ShemateCertificationWorksJobWillingnessCondition = ShemateCertificationApplicationCondition & {
  readonly __typename?: 'ShemateCertificationWorksJobWillingnessCondition';
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
};

export type ShemateCertificationWorksResumeCondition = ShemateCertificationApplicationCondition & {
  readonly __typename?: 'ShemateCertificationWorksResumeCondition';
  readonly id: Scalars['ID'];
  readonly isCompleted: Scalars['Boolean'];
};

export type SimulatedOrderResult = {
  readonly __typename?: 'SimulatedOrderResult';
  readonly entranceFeeItemResult?: Maybe<SimulatedPurchasableResult>;
  readonly membershipItemResult: SimulatedPurchasableResult;
  readonly membershipPlan?: Maybe<MembershipPlan>;
  readonly simulationCalculation: SimulationCalculationResult;
};

export type SimulatedPaymentSchedule = {
  readonly __typename?: 'SimulatedPaymentSchedule';
  readonly amount: Scalars['Int'];
  readonly dueDate: Scalars['ISO8601Date'];
  readonly installmentFee: Scalars['Int'];
  readonly paymentMethod: PaymentMethod;
  readonly taxAmount: Scalars['Int'];
};

export type SimulatedPurchasableResult = {
  readonly __typename?: 'SimulatedPurchasableResult';
  readonly installmentPaymentOption: InstallmentPaymentOption;
  readonly paymentSchedules: ReadonlyArray<Maybe<SimulatedPaymentSchedule>>;
  readonly purchasable: Purchasable;
};

export type SimulationCalculationResult = {
  readonly __typename?: 'SimulationCalculationResult';
  readonly additionalTotalAmount: AdditionalTotalAmount;
  readonly discount: PriceDetail;
  readonly installmentEntrance: PriceDetail;
  readonly installmentMembership: PriceDetail;
  readonly plan: PriceDetail;
  readonly subsidy: PriceDetail;
  readonly totalAmount: TotalAmount;
};

export type SocialProfile = {
  readonly __typename?: 'SocialProfile';
  readonly desiredOccupation?: Maybe<Scalars['String']>;
  readonly idealWorkStyle?: Maybe<Scalars['String']>;
};

export type StringSessionParameter = {
  readonly __typename?: 'StringSessionParameter';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly value?: Maybe<Scalars['String']>;
};

export type StudyFaq = {
  readonly __typename?: 'StudyFaq';
  readonly answer: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly question: Scalars['String'];
  readonly status: StudyFaqStatus;
};

export const StudyFaqStatus = {
  Archived: 'ARCHIVED',
  Draft: 'DRAFT',
  Published: 'PUBLISHED'
} as const;

export type StudyFaqStatus = typeof StudyFaqStatus[keyof typeof StudyFaqStatus];
export type StudyGroup = {
  readonly __typename?: 'StudyGroup';
  readonly endsAt?: Maybe<Scalars['ISO8601Date']>;
  readonly id: Scalars['ID'];
  readonly isActive: Scalars['Boolean'];
  readonly memo?: Maybe<Scalars['String']>;
  readonly session?: Maybe<Session>;
  readonly shestationUrl?: Maybe<Scalars['String']>;
  readonly studyGroupMembers: ReadonlyArray<StudyGroupMember>;
  readonly zoomUrl?: Maybe<Scalars['String']>;
};

/** The connection type for StudyGroup. */
export type StudyGroupConnection = {
  readonly __typename?: 'StudyGroupConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<StudyGroupEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<StudyGroup>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StudyGroupEdge = {
  readonly __typename?: 'StudyGroupEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: StudyGroup;
};

export type StudyGroupInput = {
  readonly endsAt: Scalars['ISO8601Date'];
  readonly memo?: InputMaybe<Scalars['String']>;
  readonly sessionId: Scalars['ID'];
  readonly shestationUrl?: InputMaybe<Scalars['String']>;
  readonly studyGroupMembers: ReadonlyArray<StudyGroupMemberInput>;
  readonly zoomUrl?: InputMaybe<Scalars['String']>;
};

export type StudyGroupMember = {
  readonly __typename?: 'StudyGroupMember';
  readonly id: Scalars['ID'];
  readonly interest?: Maybe<StudyGroupMemberInterest>;
  readonly user: User;
};

export type StudyGroupMemberInput = {
  readonly interest?: InputMaybe<StudyGroupMemberInterest>;
  readonly userId: Scalars['ID'];
};

export const StudyGroupMemberInterest = {
  Marketing: 'MARKETING',
  Other: 'OTHER',
  SnsVideo: 'SNS_VIDEO',
  WebDesign: 'WEB_DESIGN',
  Writing: 'WRITING'
} as const;

export type StudyGroupMemberInterest = typeof StudyGroupMemberInterest[keyof typeof StudyGroupMemberInterest];
export type StudyMap = {
  readonly __typename?: 'StudyMap';
  readonly isDefault: Scalars['Boolean'];
  readonly milestones: ReadonlyArray<StudyMapMilestone>;
  readonly name: Scalars['String'];
  readonly skillType: StudyMapSkillType;
  readonly studyUnit: StudyMapStudyUnit;
};

export type StudyMapActionItem = {
  readonly resource: StudyMapActionItemResource;
  readonly title: Scalars['String'];
};

export type StudyMapActionItemResource = {
  readonly __typename?: 'StudyMapActionItemResource';
  readonly isCompletedByCurrentUser?: Maybe<Scalars['Boolean']>;
  readonly progressByCurrentUser?: Maybe<Scalars['Float']>;
  readonly resourceType: StudyMapActionItemResourceType;
  readonly thumbnail?: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};

export const StudyMapActionItemResourceType = {
  Coaching: 'COACHING',
  CommunityEvent: 'COMMUNITY_EVENT',
  Course: 'COURSE',
  Event: 'EVENT',
  LessonHomework: 'LESSON_HOMEWORK',
  Mokumoku: 'MOKUMOKU',
  PlusLesson: 'PLUS_LESSON',
  PracticalExam: 'PRACTICAL_EXAM',
  SnsCreativeCompetition: 'SNS_CREATIVE_COMPETITION',
  SnsVideoProductionCompetition: 'SNS_VIDEO_PRODUCTION_COMPETITION',
  WelcomeCeremony: 'WELCOME_CEREMONY',
  WritingCompetition: 'WRITING_COMPETITION',
  WritingExam: 'WRITING_EXAM'
} as const;

export type StudyMapActionItemResourceType = typeof StudyMapActionItemResourceType[keyof typeof StudyMapActionItemResourceType];
export type StudyMapMainActionItem = StudyMapActionItem & {
  readonly __typename?: 'StudyMapMainActionItem';
  readonly requiredMinutes?: Maybe<Scalars['Int']>;
  readonly resource: StudyMapActionItemResource;
  readonly stepIndex: Scalars['Int'];
  readonly title: Scalars['String'];
};

export type StudyMapMilestone = {
  readonly __typename?: 'StudyMapMilestone';
  readonly actionItems: ReadonlyArray<StudyMapActionItem>;
};

export type StudyMapOptionalActionItem = StudyMapActionItem & {
  readonly __typename?: 'StudyMapOptionalActionItem';
  readonly resource: StudyMapActionItemResource;
  readonly title: Scalars['String'];
};

export const StudyMapSkillType = {
  Design: 'DESIGN',
  Marketing: 'MARKETING',
  SnsVideoProduction: 'SNS_VIDEO_PRODUCTION',
  Writing: 'WRITING'
} as const;

export type StudyMapSkillType = typeof StudyMapSkillType[keyof typeof StudyMapSkillType];
export type StudyMapStudyUnit = {
  readonly __typename?: 'StudyMapStudyUnit';
  readonly unitCount: Scalars['Float'];
  readonly unitType: StudyMapStudyUnitType;
};

export const StudyMapStudyUnitType = {
  Month: 'MONTH',
  Week: 'WEEK'
} as const;

export type StudyMapStudyUnitType = typeof StudyMapStudyUnitType[keyof typeof StudyMapStudyUnitType];
export type SubCategory = {
  readonly __typename?: 'SubCategory';
  readonly activities: ReadonlyArray<Activity>;
  readonly category: Category;
  readonly id: Scalars['ID'];
  readonly key: SubCategoryKey;
  readonly name: Scalars['String'];
};

export const SubCategoryKey = {
  BusinessTrainingPrograms: 'BUSINESS_TRAINING_PROGRAMS',
  SnsMarketerTrainingPrograms: 'SNS_MARKETER_TRAINING_PROGRAMS',
  WebDesignerTrainingPrograms: 'WEB_DESIGNER_TRAINING_PROGRAMS',
  WriterTrainingPrograms: 'WRITER_TRAINING_PROGRAMS'
} as const;

export type SubCategoryKey = typeof SubCategoryKey[keyof typeof SubCategoryKey];
export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly id: Scalars['ID'];
  readonly membershipItem: MembershipItem;
  readonly membershipItemId: Scalars['ID'];
  readonly nextUpdatableDate?: Maybe<Scalars['ISO8601Date']>;
  readonly status: SubscriptionStatus;
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export const SubscriptionStatus = {
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED'
} as const;

export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];
export type Survey = {
  readonly __typename?: 'Survey';
  readonly archived: Scalars['Boolean'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly createdById?: Maybe<Scalars['Int']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly key?: Maybe<Scalars['String']>;
  readonly lastUpdatedById?: Maybe<Scalars['Int']>;
  readonly membershipPlanGroupId: Scalars['Int'];
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type SurveyParameterDefinition = {
  readonly __typename?: 'SurveyParameterDefinition';
  readonly config?: Maybe<Scalars['JSON']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly key?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly parameterType?: Maybe<Scalars['String']>;
  readonly primary?: Maybe<Scalars['Boolean']>;
  readonly surveyId?: Maybe<Scalars['Int']>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type SurveyQuestion = {
  readonly __typename?: 'SurveyQuestion';
  readonly id: Scalars['ID'];
  readonly key?: Maybe<Scalars['String']>;
};

export type SurveyQuestionAnswer = {
  readonly __typename?: 'SurveyQuestionAnswer';
  readonly id: Scalars['ID'];
  readonly surveyQuestion?: Maybe<SurveyQuestion>;
  readonly surveyQuestionId: Scalars['ID'];
  readonly value?: Maybe<Scalars['JSON']>;
};

export type SurveySubmission = {
  readonly __typename?: 'SurveySubmission';
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly survey: Survey;
  readonly surveyQuestionAnswers?: Maybe<ReadonlyArray<SurveyQuestionAnswer>>;
  readonly surveySubmissionParameters?: Maybe<ReadonlyArray<SurveySubmissionParameter>>;
  readonly user: User;
};

export type SurveySubmissionParameter = {
  readonly __typename?: 'SurveySubmissionParameter';
  readonly id: Scalars['ID'];
  readonly surveyParameterDefinition?: Maybe<SurveyParameterDefinition>;
  readonly surveySubmissionId?: Maybe<Scalars['Int']>;
  readonly value?: Maybe<Scalars['JSON']>;
};

/** Autogenerated input type of SyncRobotPaymentsAccount */
export type SyncRobotPaymentsAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SyncRobotPaymentsAccount. */
export type SyncRobotPaymentsAccountPayload = {
  readonly __typename?: 'SyncRobotPaymentsAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

export const TermServiceType = {
  Likes: 'LIKES',
  Money: 'MONEY',
  Multicreator: 'MULTICREATOR'
} as const;

export type TermServiceType = typeof TermServiceType[keyof typeof TermServiceType];
export const Tobe = {
  Freelance: 'FREELANCE',
  JobChangeOther: 'JOB_CHANGE_OTHER',
  JobChangeWebItCreative: 'JOB_CHANGE_WEB_IT_CREATIVE',
  Other: 'OTHER',
  SideJob: 'SIDE_JOB',
  SkillUpMove: 'SKILL_UP_MOVE',
  StartUp: 'START_UP'
} as const;

export type Tobe = typeof Tobe[keyof typeof Tobe];
export type Todo = {
  readonly __typename?: 'Todo';
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly description: Scalars['String'];
  readonly dueDate?: Maybe<Scalars['ISO8601Date']>;
  readonly id: Scalars['ID'];
  readonly status: TodoStatus;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user: User;
};

export type TodoInput = {
  readonly completed: Scalars['Boolean'];
  readonly description: Scalars['String'];
  readonly dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  readonly id?: InputMaybe<Scalars['ID']>;
};

export const TodoStatus = {
  Completed: 'COMPLETED',
  Outdated: 'OUTDATED',
  Unstarted: 'UNSTARTED'
} as const;

export type TodoStatus = typeof TodoStatus[keyof typeof TodoStatus];
export type Token = {
  readonly __typename?: 'Token';
  readonly amount: Scalars['Int'];
  readonly effectiveAt: Scalars['ISO8601DateTime'];
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly membershipToken: MembershipToken;
  readonly remainingAmount: Scalars['Int'];
  readonly tokenTransactions: TokenTransactionConnection;
  readonly tokenType: TokenType;
};


export type TokenTokenTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TokenTransaction = {
  readonly __typename?: 'TokenTransaction';
  readonly amount: Scalars['Int'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly targetId: Scalars['Int'];
  readonly targetType: Scalars['String'];
};

/** The connection type for TokenTransaction. */
export type TokenTransactionConnection = {
  readonly __typename?: 'TokenTransactionConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<TokenTransactionEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<TokenTransaction>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TokenTransactionEdge = {
  readonly __typename?: 'TokenTransactionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: TokenTransaction;
};

export type TokenType = {
  readonly __typename?: 'TokenType';
  readonly key: Scalars['String'];
};

export type TotalAmount = {
  readonly __typename?: 'TotalAmount';
  readonly paymentAmount: Scalars['Int'];
  readonly totalAmount: Scalars['Int'];
};

/** Autogenerated input type of TrackLearning */
export type TrackLearningInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of TrackLearning. */
export type TrackLearningPayload = {
  readonly __typename?: 'TrackLearningPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly isFirstLearningToday: Scalars['Boolean'];
};

/** Autogenerated input type of TrackOnlineBlockVideoProgress */
export type TrackOnlineBlockVideoProgressInput = {
  readonly blockId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly durationInSeconds: Scalars['Int'];
  readonly progressInSeconds: Scalars['Int'];
  readonly provider: VideoProvider;
  readonly videoUrl: Scalars['String'];
};

/** Autogenerated return type of TrackOnlineBlockVideoProgress. */
export type TrackOnlineBlockVideoProgressPayload = {
  readonly __typename?: 'TrackOnlineBlockVideoProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of TrackOnlinePlusLessonVideoProgress */
export type TrackOnlinePlusLessonVideoProgressInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly durationInSeconds: Scalars['Int'];
  readonly plusLessonId: Scalars['ID'];
  readonly progressInSeconds: Scalars['Int'];
  readonly videoUrl: Scalars['String'];
};

/** Autogenerated return type of TrackOnlinePlusLessonVideoProgress. */
export type TrackOnlinePlusLessonVideoProgressPayload = {
  readonly __typename?: 'TrackOnlinePlusLessonVideoProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

export type TrainingProgramPackage = {
  readonly __typename?: 'TrainingProgramPackage';
  readonly category: TrainingProgramPackageCategory;
  readonly classType: TrainingProgramPackageClassType;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly endOn: Scalars['ISO8601Date'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly sessions: ReadonlyArray<Session>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly visibility: TrainingProgramPackageVisibility;
};

export const TrainingProgramPackageCategory = {
  SnsMarketer: 'SNS_MARKETER',
  WebDesigner: 'WEB_DESIGNER'
} as const;

export type TrainingProgramPackageCategory = typeof TrainingProgramPackageCategory[keyof typeof TrainingProgramPackageCategory];
export const TrainingProgramPackageClassType = {
  WeekdayNight: 'WEEKDAY_NIGHT',
  WeekendDaytime: 'WEEKEND_DAYTIME',
  WeekendNight: 'WEEKEND_NIGHT'
} as const;

export type TrainingProgramPackageClassType = typeof TrainingProgramPackageClassType[keyof typeof TrainingProgramPackageClassType];
/** The connection type for TrainingProgramPackage. */
export type TrainingProgramPackageConnection = {
  readonly __typename?: 'TrainingProgramPackageConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<TrainingProgramPackageEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<TrainingProgramPackage>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrainingProgramPackageEdge = {
  readonly __typename?: 'TrainingProgramPackageEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: TrainingProgramPackage;
};

export const TrainingProgramPackageVisibility = {
  CoachOnly: 'COACH_ONLY',
  Hidden: 'HIDDEN',
  Public: 'PUBLIC'
} as const;

export type TrainingProgramPackageVisibility = typeof TrainingProgramPackageVisibility[keyof typeof TrainingProgramPackageVisibility];
export type TrialLesson = {
  readonly __typename?: 'TrialLesson';
  readonly attendanceCount: Scalars['Int'];
  readonly cancelledEventReservations?: Maybe<ReadonlyArray<EventReservation>>;
  readonly endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly eventReservations: ReadonlyArray<EventReservation>;
  readonly id: Scalars['ID'];
  readonly isLeader: Scalars['Boolean'];
  readonly lesson1?: Maybe<Scalars['String']>;
  readonly reservationCount: Scalars['Int'];
  readonly shiftRegistrationAvailable: Scalars['Boolean'];
  readonly startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** 一覧画面で使用しないでください */
  readonly surveySubmissionCount: Scalars['Int'];
  readonly trialLessonRoleRequirements: ReadonlyArray<TrialLessonRoleRequirement>;
  readonly videoProvider: Scalars['String'];
  readonly zoomUrl?: Maybe<Scalars['String']>;
};

export type TrialLessonMatching = {
  readonly __typename?: 'TrialLessonMatching';
  readonly incomeRange?: Maybe<Scalars['String']>;
  readonly intentionLevel: Scalars['Int'];
  readonly isSubsidy: Scalars['Boolean'];
  readonly planners: ReadonlyArray<Planner>;
  readonly sheNeed: Scalars['String'];
  readonly userId: Scalars['ID'];
  readonly userName: Scalars['String'];
};

export type TrialLessonOnlineVariable = {
  readonly __typename?: 'TrialLessonOnlineVariable';
  readonly estimatedParticipationRate: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly loungeRate: Scalars['Float'];
  readonly oneOnOneRate: Scalars['Float'];
  readonly oneOnTwoRate: Scalars['Float'];
  readonly startsOn: Scalars['ISO8601Date'];
};

export type TrialLessonPosition = {
  readonly __typename?: 'TrialLessonPosition';
  readonly assignedAttendees: ReadonlyArray<User>;
  readonly attendance: TrialLessonPositionAttendance;
  readonly canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly isAssigningViewer?: Maybe<Scalars['Boolean']>;
  readonly isLounge: Scalars['Boolean'];
  readonly isSupportPlanner: Scalars['Boolean'];
  readonly status: TrialLessonPositionStatus;
  readonly trialLessonRoleRequirement: TrialLessonRoleRequirement;
  readonly user: User;
};

export const TrialLessonPositionAttendance = {
  Absent: 'ABSENT',
  Attended: 'ATTENDED',
  Feasibility: 'FEASIBILITY',
  Guarantee: 'GUARANTEE',
  NotEntered: 'NOT_ENTERED',
  ShiftCut: 'SHIFT_CUT'
} as const;

export type TrialLessonPositionAttendance = typeof TrialLessonPositionAttendance[keyof typeof TrialLessonPositionAttendance];
/** The connection type for TrialLessonPosition. */
export type TrialLessonPositionConnection = {
  readonly __typename?: 'TrialLessonPositionConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<TrialLessonPositionEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<TrialLessonPosition>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrialLessonPositionEdge = {
  readonly __typename?: 'TrialLessonPositionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: TrialLessonPosition;
};

export type TrialLessonPositionInput = {
  readonly attendance: TrialLessonPositionAttendance;
  readonly canceledAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly isLounge?: InputMaybe<Scalars['Boolean']>;
  readonly isSupportPlanner?: InputMaybe<Scalars['Boolean']>;
  readonly status: TrialLessonPositionStatus;
  readonly trialLessonRoleRequirementId: Scalars['ID'];
  readonly userId?: InputMaybe<Scalars['ID']>;
};

export const TrialLessonPositionStatus = {
  Approved: 'APPROVED',
  Pending: 'PENDING'
} as const;

export type TrialLessonPositionStatus = typeof TrialLessonPositionStatus[keyof typeof TrialLessonPositionStatus];
export const TrialLessonRoleKey = {
  TrialFacilitator: 'TRIAL_FACILITATOR',
  TrialLeader: 'TRIAL_LEADER',
  TrialPlanner: 'TRIAL_PLANNER',
  TrialSupportPlanner: 'TRIAL_SUPPORT_PLANNER',
  TrialVisitor: 'TRIAL_VISITOR'
} as const;

export type TrialLessonRoleKey = typeof TrialLessonRoleKey[keyof typeof TrialLessonRoleKey];
export type TrialLessonRoleRequirement = {
  readonly __typename?: 'TrialLessonRoleRequirement';
  readonly id: Scalars['ID'];
  readonly numberOfPositions: Scalars['Int'];
  readonly numberOfShiftIn: Scalars['Int'];
  readonly role: Role;
  readonly trialLesson: TrialLesson;
  readonly trialLessonPositions: ReadonlyArray<TrialLessonPosition>;
};

export type TrialMembership = {
  readonly __typename?: 'TrialMembership';
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly startsAt: Scalars['ISO8601DateTime'];
};

export type TrialMembershipPermission = {
  readonly __typename?: 'TrialMembershipPermission';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export type TrialPlanner = {
  readonly __typename?: 'TrialPlanner';
  readonly furigana: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly latestPlannerMeta?: Maybe<PlannerMeta>;
  readonly name: Scalars['String'];
  readonly plannerMetaChangelogs: PlannerMetaConnection;
  readonly profileUrl?: Maybe<Scalars['String']>;
};


export type TrialPlannerPlannerMetaChangelogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for TrialPlanner. */
export type TrialPlannerConnection = {
  readonly __typename?: 'TrialPlannerConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<TrialPlannerEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<TrialPlanner>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrialPlannerEdge = {
  readonly __typename?: 'TrialPlannerEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: TrialPlanner;
};

export type TutorialCompletionNotification = PopupNotification & {
  readonly __typename?: 'TutorialCompletionNotification';
  readonly gid: Scalars['ID'];
};

/** Autogenerated input type of UnLinkXAccount */
export type UnLinkXAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UnLinkXAccount. */
export type UnLinkXAccountPayload = {
  readonly __typename?: 'UnLinkXAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
};

/** Autogenerated input type of UpdateActivityCompletionStatus */
export type UpdateActivityCompletionStatusInput = {
  readonly activityKey: ActivityKey;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly completed: Scalars['Boolean'];
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of UpdateActivityCompletionStatus. */
export type UpdateActivityCompletionStatusPayload = {
  readonly __typename?: 'UpdateActivityCompletionStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateAdditionalIdentityDocument */
export type UpdateAdditionalIdentityDocumentInput = {
  readonly additionalIdentityDocumentFiles: ReadonlyArray<UserAdditionalIdentityDocumentFileInput>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly identificationType: AdditionalIdentification;
  readonly updateProfileRequest: UpdateProfileRequestInput;
};

/** Autogenerated return type of UpdateAdditionalIdentityDocument. */
export type UpdateAdditionalIdentityDocumentPayload = {
  readonly __typename?: 'UpdateAdditionalIdentityDocumentPayload';
  readonly additionalIdentityDocument?: Maybe<AdditionalIdentityDocument>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateBankAccount */
export type UpdateBankAccountInput = {
  readonly accountHolderName: Scalars['String'];
  readonly accountNumber: Scalars['String'];
  readonly accountType: BankAccountType;
  readonly bankCode: Scalars['String'];
  readonly branchCode: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly file: Scalars['Upload'];
};

/** Autogenerated return type of UpdateBankAccount. */
export type UpdateBankAccountPayload = {
  readonly __typename?: 'UpdateBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateCareerCounselingDocument */
export type UpdateCareerCounselingDocumentInput = {
  readonly allChecked?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly counselingKey: CounselingKey;
  readonly fileBase64?: InputMaybe<Scalars['String']>;
  readonly filename?: InputMaybe<Scalars['String']>;
  readonly memo: Scalars['String'];
  readonly userId: Scalars['ID'];
  readonly zoomPasscode?: InputMaybe<Scalars['String']>;
  readonly zoomUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCareerCounselingDocument. */
export type UpdateCareerCounselingDocumentPayload = {
  readonly __typename?: 'UpdateCareerCounselingDocumentPayload';
  readonly careerCounselingDocument?: Maybe<CareerCounseling>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateCareerCounselingReport */
export type UpdateCareerCounselingReportInput = {
  readonly additionalMemo?: InputMaybe<Scalars['String']>;
  readonly allChecked: Scalars['Boolean'];
  readonly careerCounselingReportId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly content: Scalars['String'];
  readonly evidenceDocumentBase64?: InputMaybe<Scalars['String']>;
  readonly evidenceDocumentFilename?: InputMaybe<Scalars['String']>;
  readonly internalMemo?: InputMaybe<Scalars['String']>;
  readonly nextAppointmentCompleted?: InputMaybe<Scalars['Boolean']>;
  readonly nextAppointmentReason?: InputMaybe<Scalars['String']>;
  readonly zoomPasscode: Scalars['String'];
  readonly zoomUrl: Scalars['String'];
};

/** Autogenerated return type of UpdateCareerCounselingReport. */
export type UpdateCareerCounselingReportPayload = {
  readonly __typename?: 'UpdateCareerCounselingReportPayload';
  readonly careerCounselingReport?: Maybe<CareerCounselingReport>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateCareerDesignCourseWorkSheet */
export type UpdateCareerDesignCourseWorkSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly file: Scalars['Upload'];
  readonly workSheetKey: WorkSheetKey;
};

/** Autogenerated return type of UpdateCareerDesignCourseWorkSheet. */
export type UpdateCareerDesignCourseWorkSheetPayload = {
  readonly __typename?: 'UpdateCareerDesignCourseWorkSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly workSheet?: Maybe<WorkSheet>;
};

/** Autogenerated input type of UpdateCreditCard */
export type UpdateCreditCardInput = {
  readonly cardToken: Scalars['String'];
  readonly cardTokenKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCreditCard. */
export type UpdateCreditCardPayload = {
  readonly __typename?: 'UpdateCreditCardPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly creditCard?: Maybe<CreditCard>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateCurrentUser */
export type UpdateCurrentUserInput = {
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly birthday?: InputMaybe<Scalars['ISO8601Date']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly firstName?: InputMaybe<Scalars['String']>;
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly firstNameKana?: InputMaybe<Scalars['String']>;
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly lastName?: InputMaybe<Scalars['String']>;
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly lastNameKana?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** データが登録されていない場合のみ利用可能な引数 */
  readonly userAddress?: InputMaybe<UserAddressInput>;
};

/** Autogenerated return type of UpdateCurrentUser. */
export type UpdateCurrentUserPayload = {
  readonly __typename?: 'UpdateCurrentUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly currentUser?: Maybe<CurrentUser>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateDefaultStudyMap */
export type UpdateDefaultStudyMapInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly defaultSkillType: StudyMapSkillType;
};

/** Autogenerated return type of UpdateDefaultStudyMap. */
export type UpdateDefaultStudyMapPayload = {
  readonly __typename?: 'UpdateDefaultStudyMapPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateEntranceCeremonyWorkbook */
export type UpdateEntranceCeremonyWorkbookInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly sheetUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEntranceCeremonyWorkbook. */
export type UpdateEntranceCeremonyWorkbookPayload = {
  readonly __typename?: 'UpdateEntranceCeremonyWorkbookPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly entranceCeremonyWorkbook?: Maybe<EntranceCeremonyWorkbook>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateEntranceFeeItem */
export type UpdateEntranceFeeItemInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly creditCardInstallmentPaymentPlanId: Scalars['ID'];
  readonly entranceFeeItemId: Scalars['ID'];
  readonly installmentPaymentPlanId: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly membershipPlanGroupId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlanId: Scalars['ID'];
  readonly price: Scalars['Int'];
};

/** Autogenerated return type of UpdateEntranceFeeItem. */
export type UpdateEntranceFeeItemPayload = {
  readonly __typename?: 'UpdateEntranceFeeItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly entranceFeeItem?: Maybe<EntranceFeeItem>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateEvent */
export type UpdateEventInput = {
  readonly capacity: Scalars['Int'];
  readonly chargeScope?: InputMaybe<EventChargeScope>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly coachIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly coverPhotoBase64: Scalars['String'];
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly eventId: Scalars['ID'];
  readonly full: Scalars['Boolean'];
  readonly highlight: Scalars['String'];
  readonly introduction: Scalars['String'];
  readonly keyColor: Scalars['String'];
  readonly locationId?: InputMaybe<Scalars['ID']>;
  readonly meetingTimeNote?: InputMaybe<Scalars['String']>;
  readonly membershipPlanGroupIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly moneyTrainingProgramGroupId?: InputMaybe<Scalars['ID']>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly pageTitle?: InputMaybe<Scalars['String']>;
  readonly price: Scalars['Int'];
  readonly publishedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  readonly requiredItems: Scalars['String'];
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly subTitle: Scalars['String'];
  readonly tagList?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly targetDescription: Scalars['String'];
  readonly targetType?: InputMaybe<EventTarget>;
  readonly thumbnailPhotoBase64: Scalars['String'];
  readonly ticketCount: Scalars['Int'];
  readonly title: Scalars['String'];
  readonly visibility: EventVisibility;
  readonly zoomUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEvent. */
export type UpdateEventPayload = {
  readonly __typename?: 'UpdateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly event?: Maybe<Event>;
};

/** Autogenerated input type of UpdateEventReservationCounseling */
export type UpdateEventReservationCounselingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly eventReservationCounseling: EventReservationCounselingInput;
};

/** Autogenerated return type of UpdateEventReservationCounseling. */
export type UpdateEventReservationCounselingPayload = {
  readonly __typename?: 'UpdateEventReservationCounselingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateEventReservationMatching */
export type UpdateEventReservationMatchingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly eventReservationMatching: EventReservationPlannerMatchingInput;
};

/** Autogenerated return type of UpdateEventReservationMatching. */
export type UpdateEventReservationMatchingPayload = {
  readonly __typename?: 'UpdateEventReservationMatchingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly eventReservationPlannerMatching?: Maybe<EventReservationPlannerMatching>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateEventReservationProDesignCounseling */
export type UpdateEventReservationProDesignCounselingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly eventReservationId: Scalars['ID'];
  readonly followUpStatusToday: EventReservationProDesignCounselingFollowUpStatusToday;
  readonly memo?: InputMaybe<Scalars['String']>;
  readonly subsidyEligibilityStatus: EventReservationProDesignCounselingSubsidyEligibilityStatus;
};

/** Autogenerated return type of UpdateEventReservationProDesignCounseling. */
export type UpdateEventReservationProDesignCounselingPayload = {
  readonly __typename?: 'UpdateEventReservationProDesignCounselingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateIdealCareer */
export type UpdateIdealCareerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly file?: InputMaybe<Scalars['Upload']>;
};

/** Autogenerated return type of UpdateIdealCareer. */
export type UpdateIdealCareerPayload = {
  readonly __typename?: 'UpdateIdealCareerPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly longTermGoal?: Maybe<LongTermGoal>;
};

/** Autogenerated input type of UpdateIdentityDocument */
export type UpdateIdentityDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly identityDocumentFiles: ReadonlyArray<UserIdentityDocumentFileInput>;
  readonly identityDocumentSetType: IdentityDocumentSet;
  readonly updateProfileRequest?: InputMaybe<UpdateProfileRequestInput>;
};

/** Autogenerated return type of UpdateIdentityDocument. */
export type UpdateIdentityDocumentPayload = {
  readonly __typename?: 'UpdateIdentityDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly identityDocument?: Maybe<IdentityDocument>;
};

/** Autogenerated input type of UpdateLineNurturingOperationNote */
export type UpdateLineNurturingOperationNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 追客ID */
  readonly nurturingId: Scalars['ID'];
  /** 対応メモ */
  readonly operationNote?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateLineNurturingOperationNote. */
export type UpdateLineNurturingOperationNotePayload = {
  readonly __typename?: 'UpdateLineNurturingOperationNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly nurturing?: Maybe<LineNurturing>;
};

/** Autogenerated input type of UpdateLineNurturingOperationStatus */
export type UpdateLineNurturingOperationStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 追客ID */
  readonly nurturingId: Scalars['ID'];
  /** 対応ステータス */
  readonly status: LineNurturingOperationStatus;
};

/** Autogenerated return type of UpdateLineNurturingOperationStatus. */
export type UpdateLineNurturingOperationStatusPayload = {
  readonly __typename?: 'UpdateLineNurturingOperationStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly nurturing?: Maybe<LineNurturing>;
};

/** Autogenerated input type of UpdateLineNurturingOwnerOperator */
export type UpdateLineNurturingOwnerOperatorInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 追客ID */
  readonly nurturingId: Scalars['ID'];
  /** 担当者ID（nullの場合は担当者を解除） */
  readonly ownerOperatorId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UpdateLineNurturingOwnerOperator. */
export type UpdateLineNurturingOwnerOperatorPayload = {
  readonly __typename?: 'UpdateLineNurturingOwnerOperatorPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly nurturing?: Maybe<LineNurturing>;
};

/** Autogenerated input type of UpdateLineNurturingStatus */
export type UpdateLineNurturingStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 追客ステータスID（nullの場合は追客ステータスを解除） */
  readonly nurtureStatusId: Scalars['ID'];
  /** 追客ID */
  readonly nurturingId: Scalars['ID'];
};

/** Autogenerated return type of UpdateLineNurturingStatus. */
export type UpdateLineNurturingStatusPayload = {
  readonly __typename?: 'UpdateLineNurturingStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly nurturing?: Maybe<LineNurturing>;
};

/** Autogenerated input type of UpdateLineNurturingTask */
export type UpdateLineNurturingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  /** 完了状態（true: 完了, false: 未完了） */
  readonly isCompleted: Scalars['Boolean'];
  /** 追客ID */
  readonly nurturingId: Scalars['ID'];
  /** キャンペーンタスクID */
  readonly taskId: Scalars['ID'];
};

/** Autogenerated return type of UpdateLineNurturingTask. */
export type UpdateLineNurturingTaskPayload = {
  readonly __typename?: 'UpdateLineNurturingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly nurturing?: Maybe<LineNurturing>;
};

/** Autogenerated input type of UpdateLongTermWorkGoal */
export type UpdateLongTermWorkGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly goalDeadline?: InputMaybe<LongTermGoalGoalDeadline>;
  readonly occupation?: InputMaybe<LongTermGoalOccupation>;
  readonly workGoal?: InputMaybe<LongTermGoalWorkGoal>;
};

/** Autogenerated return type of UpdateLongTermWorkGoal. */
export type UpdateLongTermWorkGoalPayload = {
  readonly __typename?: 'UpdateLongTermWorkGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly longTermGoal?: Maybe<LongTermGoal>;
};

/** Autogenerated input type of UpdateMembershipItem */
export type UpdateMembershipItemInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly creditCardInstallmentPaymentPlanId: Scalars['ID'];
  readonly durationMonth: Scalars['Int'];
  readonly installmentPaymentPlanId: Scalars['ID'];
  readonly membershipItemId: Scalars['ID'];
  readonly membershipPlanId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly paygentInstallmentPaymentPlanId: Scalars['ID'];
  readonly price: Scalars['Int'];
};

/** Autogenerated return type of UpdateMembershipItem. */
export type UpdateMembershipItemPayload = {
  readonly __typename?: 'UpdateMembershipItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly membershipItem?: Maybe<MembershipItem>;
};

/** Autogenerated input type of UpdateMoneyTrainingProgramGroup */
export type UpdateMoneyTrainingProgramGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly moneyTrainingProgramGroupId: Scalars['ID'];
  readonly name: Scalars['String'];
};

/** Autogenerated return type of UpdateMoneyTrainingProgramGroup. */
export type UpdateMoneyTrainingProgramGroupPayload = {
  readonly __typename?: 'UpdateMoneyTrainingProgramGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly moneyTrainingProgramGroup?: Maybe<MoneyTrainingProgramGroup>;
};

/** Autogenerated input type of UpdateOnlineBlock */
export type UpdateOnlineBlockInput = {
  readonly blockId: Scalars['ID'];
  readonly blockType: BlockType;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly content: Scalars['String'];
  readonly title: Scalars['String'];
};

/** Autogenerated return type of UpdateOnlineBlock. */
export type UpdateOnlineBlockPayload = {
  readonly __typename?: 'UpdateOnlineBlockPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineBlock?: Maybe<Block>;
};

/** Autogenerated input type of UpdateOnlinePlusLesson */
export type UpdateOnlinePlusLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly coachIds: ReadonlyArray<Scalars['ID']>;
  readonly courseCategoryId?: InputMaybe<Scalars['ID']>;
  readonly description: Scalars['String'];
  readonly durationInMinutes: Scalars['Int'];
  readonly heldAt: Scalars['ISO8601Date'];
  readonly introductionVideoUrl: Scalars['String'];
  readonly mainVideoUrl: Scalars['String'];
  readonly membershipPlanGroupIds: ReadonlyArray<Scalars['ID']>;
  readonly plusLessonId: Scalars['ID'];
  readonly recommendedFor: Scalars['String'];
  readonly requiredTokenAmount: Scalars['Int'];
  readonly reskilling?: InputMaybe<Scalars['Boolean']>;
  readonly status: PlusLessonStatus;
  readonly thumbnailUrl: Scalars['String'];
  readonly timeline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly videoNotes: Scalars['String'];
};

/** Autogenerated return type of UpdateOnlinePlusLesson. */
export type UpdateOnlinePlusLessonPayload = {
  readonly __typename?: 'UpdateOnlinePlusLessonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlinePlusLesson?: Maybe<PlusLesson>;
};

/** Autogenerated input type of UpdateOnlineRecommendLearningLessonPositions */
export type UpdateOnlineRecommendLearningLessonPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly ids: ReadonlyArray<Scalars['ID']>;
};

/** Autogenerated return type of UpdateOnlineRecommendLearningLessonPositions. */
export type UpdateOnlineRecommendLearningLessonPositionsPayload = {
  readonly __typename?: 'UpdateOnlineRecommendLearningLessonPositionsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly recommendLearningLesson?: Maybe<ReadonlyArray<RecommendLearningLesson>>;
};

/** Autogenerated input type of UpdateOnlineStudyFaq */
export type UpdateOnlineStudyFaqInput = {
  readonly answer: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly question: Scalars['String'];
  readonly status: StudyFaqStatus;
  readonly studyFaqId: Scalars['ID'];
};

/** Autogenerated return type of UpdateOnlineStudyFaq. */
export type UpdateOnlineStudyFaqPayload = {
  readonly __typename?: 'UpdateOnlineStudyFaqPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineStudyFaq?: Maybe<StudyFaq>;
};

/** Autogenerated input type of UpdateOrderByCoupon */
export type UpdateOrderByCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly couponId: Scalars['ID'];
  readonly orderId: Scalars['ID'];
  readonly reason: Scalars['String'];
};

/** Autogenerated return type of UpdateOrderByCoupon. */
export type UpdateOrderByCouponPayload = {
  readonly __typename?: 'UpdateOrderByCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly order?: Maybe<Order>;
};

/** Autogenerated input type of UpdatePersonalSummary */
export type UpdatePersonalSummaryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly file: Scalars['Upload'];
};

/** Autogenerated return type of UpdatePersonalSummary. */
export type UpdatePersonalSummaryPayload = {
  readonly __typename?: 'UpdatePersonalSummaryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly personalSummary?: Maybe<PersonalSummary>;
};

/** Autogenerated input type of UpdatePositionOfOnlinePlusLessons */
export type UpdatePositionOfOnlinePlusLessonsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly onlinePlusLessonIds: ReadonlyArray<Scalars['ID']>;
};

/** Autogenerated return type of UpdatePositionOfOnlinePlusLessons. */
export type UpdatePositionOfOnlinePlusLessonsPayload = {
  readonly __typename?: 'UpdatePositionOfOnlinePlusLessonsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlinePlusLessons?: Maybe<ReadonlyArray<PlusLesson>>;
};

/** Autogenerated input type of UpdatePositionOfStudyFaqs */
export type UpdatePositionOfStudyFaqsInput = {
  readonly blockId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly studyFaqIds: ReadonlyArray<Scalars['ID']>;
};

/** Autogenerated return type of UpdatePositionOfStudyFaqs. */
export type UpdatePositionOfStudyFaqsPayload = {
  readonly __typename?: 'UpdatePositionOfStudyFaqsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly onlineStudyFaqs?: Maybe<ReadonlyArray<StudyFaq>>;
};

export type UpdateProfileRequestInput = {
  readonly address: Scalars['String'];
  readonly birthday: Scalars['String'];
  readonly building?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly firstNameKana: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly lastNameKana: Scalars['String'];
  readonly prefecture: Scalars['String'];
  readonly zipcode: Scalars['String'];
};

/** Autogenerated input type of UpdateRefundSchedule */
export type UpdateRefundScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly refundMethod: PaymentMethod;
  readonly refundScheduleId: Scalars['ID'];
};

/** Autogenerated return type of UpdateRefundSchedule. */
export type UpdateRefundSchedulePayload = {
  readonly __typename?: 'UpdateRefundSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly refundSchedule?: Maybe<RefundSchedule>;
};

/** Autogenerated input type of UpdateRegularPlanRecruitment */
export type UpdateRegularPlanRecruitmentInput = {
  readonly capacity: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly lotteryDate: Scalars['ISO8601Date'];
  readonly planChangeEndsAt: Scalars['ISO8601DateTime'];
  readonly planChangeStartsAt: Scalars['ISO8601DateTime'];
  readonly regularPlanRecruitmentId: Scalars['ID'];
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly title: Scalars['String'];
};

/** Autogenerated return type of UpdateRegularPlanRecruitment. */
export type UpdateRegularPlanRecruitmentPayload = {
  readonly __typename?: 'UpdateRegularPlanRecruitmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly regularPlanRecruitment?: Maybe<RegularPlanRecruitment>;
};

/** Autogenerated input type of UpdateResume */
export type UpdateResumeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly file: Scalars['Upload'];
};

/** Autogenerated return type of UpdateResume. */
export type UpdateResumePayload = {
  readonly __typename?: 'UpdateResumePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly resume?: Maybe<Resume>;
};

/** Autogenerated input type of UpdateRole */
export type UpdateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly roleId: Scalars['ID'];
};

/** Autogenerated return type of UpdateRole. */
export type UpdateRolePayload = {
  readonly __typename?: 'UpdateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly role?: Maybe<Role>;
};

/** Autogenerated input type of UpdateSalary */
export type UpdateSalaryInput = {
  readonly certificateOfEmploymentFile?: InputMaybe<Scalars['Upload']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly file: Scalars['Upload'];
  readonly identityDocumentFile?: InputMaybe<Scalars['Upload']>;
  readonly leaveOfAbsenceFile?: InputMaybe<Scalars['Upload']>;
  readonly memo?: InputMaybe<Scalars['String']>;
  readonly payedDate: Scalars['ISO8601Date'];
  readonly salaryKey: SalaryKey;
};

/** Autogenerated return type of UpdateSalary. */
export type UpdateSalaryPayload = {
  readonly __typename?: 'UpdateSalaryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly salary?: Maybe<SalaryDocument>;
};

/** Autogenerated input type of UpdateStudyGroup */
export type UpdateStudyGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly endsAt?: InputMaybe<Scalars['ISO8601Date']>;
  readonly memo?: InputMaybe<Scalars['String']>;
  readonly shestationUrl?: InputMaybe<Scalars['String']>;
  readonly studyGroupId: Scalars['ID'];
  readonly studyGroupMembers: ReadonlyArray<StudyGroupMemberInput>;
  readonly zoomUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateStudyGroup. */
export type UpdateStudyGroupPayload = {
  readonly __typename?: 'UpdateStudyGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly studyGroup?: Maybe<StudyGroup>;
};

/** Autogenerated input type of UpdateSubsidyToNoneByUserId */
export type UpdateSubsidyToNoneByUserIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly paymentDueDate: Scalars['ISO8601Date'];
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSubsidyToNoneByUserId. */
export type UpdateSubsidyToNoneByUserIdPayload = {
  readonly __typename?: 'UpdateSubsidyToNoneByUserIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateToken */
export type UpdateTokenInput = {
  readonly amount: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tokenId: Scalars['ID'];
};

/** Autogenerated return type of UpdateToken. */
export type UpdateTokenPayload = {
  readonly __typename?: 'UpdateTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly token?: Maybe<Token>;
};

/** Autogenerated input type of UpdateTrainingProgramPackage */
export type UpdateTrainingProgramPackageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly endOn?: InputMaybe<Scalars['ISO8601Date']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly trainingProgramPackageId: Scalars['ID'];
  readonly visibility: TrainingProgramPackageVisibility;
};

/** Autogenerated return type of UpdateTrainingProgramPackage. */
export type UpdateTrainingProgramPackagePayload = {
  readonly __typename?: 'UpdateTrainingProgramPackagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly trainingProgramPackage?: Maybe<TrainingProgramPackage>;
};

/** Autogenerated input type of UpdateTrialLessonMatching */
export type UpdateTrialLessonMatchingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly trialLessonId: Scalars['ID'];
};

/** Autogenerated return type of UpdateTrialLessonMatching. */
export type UpdateTrialLessonMatchingPayload = {
  readonly __typename?: 'UpdateTrialLessonMatchingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly trialLessonMatching: ReadonlyArray<TrialLessonMatching>;
};

/** Autogenerated input type of UpdateTrialLessonOnlineVariable */
export type UpdateTrialLessonOnlineVariableInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly estimatedParticipationRate: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly loungeRate: Scalars['Float'];
  readonly oneOnOneRate: Scalars['Float'];
  readonly oneOnTwoRate: Scalars['Float'];
  readonly startsOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of UpdateTrialLessonOnlineVariable. */
export type UpdateTrialLessonOnlineVariablePayload = {
  readonly __typename?: 'UpdateTrialLessonOnlineVariablePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateTrialLessonPositions */
export type UpdateTrialLessonPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly trialLessonId: Scalars['ID'];
  readonly trialLessonPositions: ReadonlyArray<TrialLessonPositionInput>;
};

/** Autogenerated return type of UpdateTrialLessonPositions. */
export type UpdateTrialLessonPositionsPayload = {
  readonly __typename?: 'UpdateTrialLessonPositionsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  readonly birthday?: InputMaybe<Scalars['ISO8601Date']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly firstNameKana?: InputMaybe<Scalars['String']>;
  readonly furigana?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly lastNameKana?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly userAddress?: InputMaybe<UserAddressInput>;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  readonly __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly user?: Maybe<User>;
};

/** Autogenerated input type of UpdateUserRegularPlanCompletionAddress */
export type UpdateUserRegularPlanCompletionAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
};

/** Autogenerated return type of UpdateUserRegularPlanCompletionAddress. */
export type UpdateUserRegularPlanCompletionAddressPayload = {
  readonly __typename?: 'UpdateUserRegularPlanCompletionAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly userRegularPlanCompletion?: Maybe<UserRegularPlanCompletion>;
};

/** Autogenerated input type of UploadMultipleFiles */
export type UploadMultipleFilesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly files: ReadonlyArray<Scalars['Upload']>;
};

/** Autogenerated return type of UploadMultipleFiles. */
export type UploadMultipleFilesPayload = {
  readonly __typename?: 'UploadMultipleFilesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

/** Autogenerated input type of UpsertCareerChange */
export type UpsertCareerChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly jobChangeOn: Scalars['ISO8601Date'];
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of UpsertCareerChange. */
export type UpsertCareerChangePayload = {
  readonly __typename?: 'UpsertCareerChangePayload';
  readonly careerChange?: Maybe<CareerChange>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

/** Autogenerated input type of UpsertEventReservationCounselingReview */
export type UpsertEventReservationCounselingReviewInput = {
  readonly approachDetail?: InputMaybe<Scalars['String']>;
  readonly asis: Asis;
  readonly asisDetail?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comparisonSchool: Scalars['JSON'];
  readonly counselingResult?: InputMaybe<CounselingResult>;
  readonly creditSplitErrorReaction?: InputMaybe<Scalars['String']>;
  readonly creditSplitStatus?: InputMaybe<CreditSplitStatus>;
  readonly customerAttitude: CustomerAttitude;
  readonly customerNextAction?: InputMaybe<Scalars['String']>;
  readonly customerSituationDetail?: InputMaybe<Scalars['String']>;
  readonly enrollmentReasonDetail?: InputMaybe<Scalars['String']>;
  readonly eventReservationId: Scalars['ID'];
  readonly firstKeyComparison: KeyComparison;
  readonly firstKeyComparisonDetail?: InputMaybe<Scalars['String']>;
  readonly freeComment?: InputMaybe<Scalars['String']>;
  readonly hasConductedCoolingOffTalk: Scalars['Boolean'];
  readonly hasHeardCustomerSituation: Scalars['Boolean'];
  readonly hasSuggested24InstallmentCount: Scalars['Boolean'];
  readonly hasSuggestedCampaign: Scalars['Boolean'];
  readonly hasSuggestedLoan: Scalars['Boolean'];
  readonly hasSuggestedOtherSchoolCp: Scalars['Boolean'];
  readonly hasSuggestedTrialMembership: Scalars['Boolean'];
  readonly intendedPeriod: IntendedPeriod;
  readonly intendedPeriodDetail?: InputMaybe<Scalars['String']>;
  readonly intendedPeriodReason: Scalars['String'];
  readonly lastIntentionLevel?: InputMaybe<LastIntentionLevel>;
  readonly lotteryResult?: Scalars['String'];
  readonly nonEnrollmentReason: Scalars['String'];
  readonly nonEnrollmentReasonDetail?: InputMaybe<Scalars['String']>;
  readonly otherComparisonSchool?: InputMaybe<Scalars['String']>;
  readonly secondKeyComparison: KeyComparison;
  readonly secondKeyComparisonDetail?: InputMaybe<Scalars['String']>;
  readonly thirdKeyComparison: KeyComparison;
  readonly thirdKeyComparisonDetail?: InputMaybe<Scalars['String']>;
  readonly tobe: Tobe;
  readonly tobeDetail?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpsertEventReservationCounselingReview. */
export type UpsertEventReservationCounselingReviewPayload = {
  readonly __typename?: 'UpsertEventReservationCounselingReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly eventReservationCounselingReview?: Maybe<EventReservationCounselingReview>;
};

/** Autogenerated input type of UpsertIrregularCouponTemplateSetting */
export type UpsertIrregularCouponTemplateSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly couponTemplateId: Scalars['ID'];
  readonly endsAt: Scalars['ISO8601DateTime'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly startsAt: Scalars['ISO8601DateTime'];
  readonly surveyId: Scalars['ID'];
};

/** Autogenerated return type of UpsertIrregularCouponTemplateSetting. */
export type UpsertIrregularCouponTemplateSettingPayload = {
  readonly __typename?: 'UpsertIrregularCouponTemplateSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly irregularCouponTemplateSetting?: Maybe<IrregularCouponTemplateSetting>;
};

/** Autogenerated input type of UpsertMonthlyGoal */
export type UpsertMonthlyGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly goal?: InputMaybe<Scalars['String']>;
  readonly month: Scalars['Int'];
  readonly progress?: InputMaybe<Scalars['Int']>;
  readonly reflection?: InputMaybe<Scalars['String']>;
  readonly todoItems?: InputMaybe<ReadonlyArray<TodoInput>>;
  readonly todos?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly year: Scalars['Int'];
};

/** Autogenerated return type of UpsertMonthlyGoal. */
export type UpsertMonthlyGoalPayload = {
  readonly __typename?: 'UpsertMonthlyGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly monthlyGoal?: Maybe<MonthlyGoal>;
};

/** Autogenerated input type of UpsertMonthlyGoalReflection */
export type UpsertMonthlyGoalReflectionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly month: Scalars['Int'];
  readonly progress?: InputMaybe<Scalars['Int']>;
  readonly reflection?: InputMaybe<Scalars['String']>;
  readonly todoItems?: InputMaybe<ReadonlyArray<TodoInput>>;
  readonly year: Scalars['Int'];
};

/** Autogenerated return type of UpsertMonthlyGoalReflection. */
export type UpsertMonthlyGoalReflectionPayload = {
  readonly __typename?: 'UpsertMonthlyGoalReflectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly monthlyGoal?: Maybe<MonthlyGoal>;
};

/** Autogenerated input type of UpsertMonthlyGoalSetting */
export type UpsertMonthlyGoalSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly goal?: InputMaybe<Scalars['String']>;
  readonly month: Scalars['Int'];
  readonly todoItems?: InputMaybe<ReadonlyArray<TodoInput>>;
  readonly year: Scalars['Int'];
};

/** Autogenerated return type of UpsertMonthlyGoalSetting. */
export type UpsertMonthlyGoalSettingPayload = {
  readonly __typename?: 'UpsertMonthlyGoalSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly monthlyGoal?: Maybe<MonthlyGoal>;
};

/** Autogenerated input type of UpsertNewEventReservationCounselingReview */
export type UpsertNewEventReservationCounselingReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comparisonSchool: Scalars['JSON'];
  readonly concernDetail: Scalars['String'];
  readonly counselingResult: CounselingResult;
  readonly creditSplitErrorReaction?: InputMaybe<Scalars['String']>;
  readonly creditSplitStatus: CreditSplitStatus;
  readonly currentConcerns: Scalars['String'];
  readonly customerAttitude: CustomerAttitude;
  readonly decisionRequirements?: InputMaybe<Scalars['String']>;
  readonly eventReservationId: Scalars['ID'];
  readonly hasConductedCoolingOffTalk?: InputMaybe<Scalars['Boolean']>;
  readonly hasSuggested24InstallmentCount: Scalars['Boolean'];
  readonly hasSuggestedCampaign: Scalars['Boolean'];
  readonly hasSuggestedLoan: Scalars['Boolean'];
  readonly hasSuggestedNothing: Scalars['Boolean'];
  readonly hasSuggestedOtherSchoolCampaign: Scalars['Boolean'];
  readonly hasSuggestedTrialMembership: Scalars['Boolean'];
  readonly idealAchievementChallenges: Scalars['String'];
  readonly idealSituation: Scalars['String'];
  readonly idealTimeline: IdealTimeline;
  readonly lastIntentionLevel: NewLastIntentionLevel;
  readonly motivationCheck: MotivationCheck;
  readonly nextCounselingStrategy: Scalars['String'];
  readonly nonEnrollmentReason: Scalars['String'];
  readonly notSuggestedReason?: InputMaybe<Scalars['String']>;
  readonly otherComparisonSchool?: InputMaybe<Scalars['String']>;
  readonly recordingUrl: Scalars['String'];
};

/** Autogenerated return type of UpsertNewEventReservationCounselingReview. */
export type UpsertNewEventReservationCounselingReviewPayload = {
  readonly __typename?: 'UpsertNewEventReservationCounselingReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly newEventReservationCounselingReview?: Maybe<NewEventReservationCounselingReview>;
};

/** Autogenerated input type of UpsertOnlineRecommendLearningLesson */
export type UpsertOnlineRecommendLearningLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly courseId?: InputMaybe<Scalars['ID']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly plusLessonId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UpsertOnlineRecommendLearningLesson. */
export type UpsertOnlineRecommendLearningLessonPayload = {
  readonly __typename?: 'UpsertOnlineRecommendLearningLessonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
  readonly recommendLearningLesson?: Maybe<RecommendLearningLesson>;
};

/** Autogenerated input type of UpsertSensitiveDocumentMemo */
export type UpsertSensitiveDocumentMemoInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly userId: Scalars['ID'];
};

/** Autogenerated return type of UpsertSensitiveDocumentMemo. */
export type UpsertSensitiveDocumentMemoPayload = {
  readonly __typename?: 'UpsertSensitiveDocumentMemoPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly errors: ReadonlyArray<Error>;
};

export type Usage = {
  readonly __typename?: 'Usage';
  readonly completionTokens: Scalars['Int'];
  readonly promptTokens: Scalars['Int'];
  readonly totalTokens: Scalars['Int'];
};

export type User = {
  readonly __typename?: 'User';
  readonly age?: Maybe<Scalars['Int']>;
  readonly birthday?: Maybe<Scalars['ISO8601Date']>;
  /** 口座情報削除ボタンを表示するかどうか（匿名化済みかつ処理期間外の場合にtrue） */
  readonly canDeleteBankAccount: Scalars['Boolean'];
  readonly careerChange?: Maybe<CareerChange>;
  readonly email: Scalars['String'];
  readonly entranceStatuses: ReadonlyArray<EntranceStatus>;
  readonly firstName: Scalars['String'];
  readonly firstNameKana: Scalars['String'];
  readonly fullAddress?: Maybe<Scalars['String']>;
  readonly fullAddressWithZipcode?: Maybe<Scalars['String']>;
  readonly fullname: Scalars['String'];
  readonly fullnameKana: Scalars['String'];
  readonly furigana: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly identityDocument?: Maybe<IdentityDocument>;
  readonly isTrialMembershipPermitted: Scalars['Boolean'];
  readonly lastName: Scalars['String'];
  readonly lastNameKana: Scalars['String'];
  readonly memberships: ReadonlyArray<Membership>;
  readonly moneyTrainingProgramGroups: ReadonlyArray<MoneyTrainingProgramGroup>;
  readonly name: Scalars['String'];
  readonly paperContractByEventReservationId: UserPaperContract;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly profileUrl?: Maybe<Scalars['String']>;
  readonly robotPaymentCustomersWithBankAccount: ReadonlyArray<RobotPaymentsCustomer>;
  readonly sendMailHistories?: Maybe<SendMailHistoryConnection>;
  readonly sensitiveDocumentMemo?: Maybe<SensitiveDocumentMemo>;
  readonly subsidySummary: UserSubsidySummary;
  readonly trialLessonAttended?: Maybe<ReadonlyArray<EventReservation>>;
  readonly trialMembershipPermissions: ReadonlyArray<TrialMembershipPermission>;
  readonly trialMemberships: ReadonlyArray<TrialMembership>;
  readonly userAddress?: Maybe<UserAddress>;
  readonly userZoomAccount?: Maybe<UserZoomAccount>;
};


export type UserSendMailHistoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserActivity = {
  readonly __typename?: 'UserActivity';
  readonly activity: Activity;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly user: User;
};

export type UserActivitySummary = {
  readonly __typename?: 'UserActivitySummary';
  readonly activityCategories: ReadonlyArray<ActivityCategorySummary>;
  readonly additionalConditionCompletedCount: Scalars['Int'];
  readonly additionalConditionCount: Scalars['Int'];
  readonly completedCount: Scalars['Int'];
  readonly regularPlanCompletionConditionCompletedCount: Scalars['Int'];
  readonly regularPlanCompletionConditionCount: Scalars['Int'];
  readonly totalCategoryCount: Scalars['Int'];
};

export type UserAdditionalIdentityDocumentFileInput = {
  readonly file: Scalars['Upload'];
  readonly identityDocumentImageType: AdditionalIdentificationDocumentImage;
};

export type UserAddress = {
  readonly __typename?: 'UserAddress';
  readonly address: Scalars['String'];
  readonly building: Scalars['String'];
  readonly city: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly prefecture: Scalars['String'];
  readonly zipcode: Scalars['String'];
};

export type UserAddressInput = {
  readonly address: Scalars['String'];
  readonly building: Scalars['String'];
  readonly city: Scalars['String'];
  readonly prefecture: Scalars['String'];
  readonly zipcode: Scalars['String'];
};

export type UserAppNotificationToken = {
  readonly __typename?: 'UserAppNotificationToken';
  readonly token: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type UserBadge = {
  readonly __typename?: 'UserBadge';
  readonly badge: Badge;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly descriptionForCurrentLevel?: Maybe<Scalars['String']>;
  /** @deprecated descriptionForCurrentLevel を使う */
  readonly descriptionForNextLevel?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly level: Scalars['Int'];
};

export type UserBadgeAlreadyCreated = {
  readonly __typename?: 'UserBadgeAlreadyCreated';
  readonly _?: Maybe<Scalars['Boolean']>;
};

/** The connection type for UserBadge. */
export type UserBadgeConnection = {
  readonly __typename?: 'UserBadgeConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserBadgeEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<UserBadge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserBadgeEdge = {
  readonly __typename?: 'UserBadgeEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: UserBadge;
};

export type UserBadgeInfo = {
  readonly __typename?: 'UserBadgeInfo';
  readonly otherBadges: ReadonlyArray<GroupedByCategoryBadges>;
  readonly recommendedBadges: ReadonlyArray<GroupedByCategoryBadges>;
};

/** The connection type for User. */
export type UserConnection = {
  readonly __typename?: 'UserConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<User>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  readonly __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: User;
};

export const UserEntranceStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type UserEntranceStatus = typeof UserEntranceStatus[keyof typeof UserEntranceStatus];
export type UserIdentityDocumentFileInput = {
  readonly file: Scalars['Upload'];
  readonly identityDocumentImageType: IdentityDocumentImage;
};

export type UserItem = {
  readonly __typename?: 'UserItem';
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly completedContentCount: Scalars['Int'];
  readonly contentCount: Scalars['Int'];
  readonly itemId: Scalars['ID'];
  readonly itemIndex: Scalars['Int'];
  readonly itemPath: Scalars['String'];
  readonly itemType: Item;
  readonly lastActivityAt: Scalars['ISO8601DateTime'];
  readonly subTitle?: Maybe<Scalars['String']>;
  readonly thumbnail: Scalars['String'];
  readonly title: Scalars['String'];
};

export type UserItemPackageEffectivePeriod = {
  readonly __typename?: 'UserItemPackageEffectivePeriod';
  readonly endTime: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly itemPackage: ItemPackage;
  readonly startTime: Scalars['ISO8601DateTime'];
};

export type UserName = {
  readonly __typename?: 'UserName';
  readonly firstName: Scalars['String'];
  readonly firstNameKana: Scalars['String'];
  readonly furigana: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly lastNameKana: Scalars['String'];
  readonly name: Scalars['String'];
};

export type UserPaperContract = {
  readonly __typename?: 'UserPaperContract';
  readonly contractExecutionDate: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly leadPlannerFullname?: Maybe<Scalars['String']>;
  readonly likesEntranceFee: Scalars['String'];
  readonly likesEntrancePaymentDuedate: Scalars['String'];
  readonly likesEntrancePaymentMethod: Scalars['String'];
  readonly likesMembershipFee: Scalars['String'];
  readonly likesMembershipPaymentDuedate: Scalars['String'];
  readonly likesMembershipPaymentMethod: Scalars['String'];
  readonly serviceAndPlanName: Scalars['String'];
  readonly startDateOfService: Scalars['String'];
  readonly userFullname: Scalars['String'];
};


export type UserPaperContractLeadPlannerFullnameArgs = {
  eventReservationId: Scalars['ID'];
};

export type UserPlusLessonActivation = {
  readonly __typename?: 'UserPlusLessonActivation';
  readonly activatedAt: Scalars['ISO8601DateTime'];
  readonly expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly plusLesson: PlusLesson;
};

/** The connection type for UserPlusLessonActivation. */
export type UserPlusLessonActivationConnection = {
  readonly __typename?: 'UserPlusLessonActivationConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserPlusLessonActivationEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<UserPlusLessonActivation>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserPlusLessonActivationEdge = {
  readonly __typename?: 'UserPlusLessonActivationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: UserPlusLessonActivation;
};

export type UserRegularPlanCompletion = {
  readonly __typename?: 'UserRegularPlanCompletion';
  readonly address?: Maybe<Scalars['String']>;
  readonly basePrice: Scalars['Int'];
  readonly building?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly completedAt: Scalars['ISO8601DateTime'];
  readonly firstName?: Maybe<Scalars['String']>;
  readonly fullAddress?: Maybe<Scalars['String']>;
  readonly fullAddressWithZipcode?: Maybe<Scalars['String']>;
  readonly fullname?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName?: Maybe<Scalars['String']>;
  readonly prefecture?: Maybe<Scalars['String']>;
  readonly startedAt: Scalars['ISO8601DateTime'];
  readonly user: User;
  readonly zipcode?: Maybe<Scalars['String']>;
};

export type UserRewardHistory = {
  readonly amount: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly recordedAt: Scalars['ISO8601DateTime'];
  readonly title: Scalars['String'];
};

/** The connection type for UserRewardHistory. */
export type UserRewardHistoryConnection = {
  readonly __typename?: 'UserRewardHistoryConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserRewardHistoryEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<UserRewardHistory>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

export type UserRewardHistoryEarned = UserRewardHistory & {
  readonly __typename?: 'UserRewardHistoryEarned';
  readonly amount: Scalars['Int'];
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly recordedAt: Scalars['ISO8601DateTime'];
  readonly title: Scalars['String'];
};

/** An edge in a connection. */
export type UserRewardHistoryEdge = {
  readonly __typename?: 'UserRewardHistoryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: UserRewardHistory;
};

export type UserRewardHistoryExpired = UserRewardHistory & {
  readonly __typename?: 'UserRewardHistoryExpired';
  readonly amount: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly recordedAt: Scalars['ISO8601DateTime'];
  readonly title: Scalars['String'];
};

export type UserRewardHistoryUsed = UserRewardHistory & {
  readonly __typename?: 'UserRewardHistoryUsed';
  readonly amount: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly recordedAt: Scalars['ISO8601DateTime'];
  readonly title: Scalars['String'];
};

export type UserSensitiveDocuments = {
  readonly __typename?: 'UserSensitiveDocuments';
  readonly additionalIdentityDocument?: Maybe<AdditionalIdentityDocument>;
  readonly approvedAdditionalIdentityDocuments: ReadonlyArray<ApprovedAdditionalIdentityDocument>;
  readonly bankAccount?: Maybe<BankAccount>;
  readonly identityDocument?: Maybe<IdentityDocument>;
  readonly personalSummary?: Maybe<PersonalSummary>;
  readonly resume?: Maybe<Resume>;
  readonly salaryDocumentAfterJobChanged?: Maybe<SalaryDocument>;
  readonly salaryDocumentFormer?: Maybe<SalaryDocument>;
  readonly workSheetFirst?: Maybe<WorkSheet>;
  readonly workSheetSecond?: Maybe<WorkSheet>;
};

export type UserSubsidySummary = {
  readonly __typename?: 'UserSubsidySummary';
  readonly allPaid: Scalars['Boolean'];
  readonly failedPaymentSchedules: ReadonlyArray<PaymentSchedule>;
  readonly hasRegularPlanCompletion: Scalars['Boolean'];
  readonly regularPlanEndDate?: Maybe<Scalars['ISO8601Date']>;
  readonly regularPlanOrders: ReadonlyArray<Order>;
  readonly regularPlanStartDate?: Maybe<Scalars['ISO8601Date']>;
  readonly subsidyBaseQualified: Scalars['Boolean'];
  readonly subsidyType: OrderSubsidy;
  readonly unpaidPaymentSchedules: ReadonlyArray<PaymentSchedule>;
  readonly userPaymentSchedules: ReadonlyArray<PaymentSchedule>;
};

export type UserVision = {
  readonly __typename?: 'UserVision';
  readonly idealOccupation: UserVisionOccupation;
  readonly nextCareerStep: UserVisionCareerStep;
  readonly startDate: Scalars['ISO8601Date'];
  readonly targetDate: Scalars['ISO8601Date'];
};

export const UserVisionCareerStep = {
  BusinessFounding: 'BUSINESS_FOUNDING',
  CareerGrowth: 'CAREER_GROWTH',
  DepartmentTransfer: 'DEPARTMENT_TRANSFER',
  Freelance: 'FREELANCE',
  JobChange: 'JOB_CHANGE',
  Other: 'OTHER',
  SideJob: 'SIDE_JOB',
  Unknown: 'UNKNOWN'
} as const;

export type UserVisionCareerStep = typeof UserVisionCareerStep[keyof typeof UserVisionCareerStep];
export const UserVisionOccupation = {
  Designer: 'DESIGNER',
  HybridRole: 'HYBRID_ROLE',
  Marketer: 'MARKETER',
  Other: 'OTHER',
  SnsVideoCreator: 'SNS_VIDEO_CREATOR',
  Unknown: 'UNKNOWN',
  Writer: 'WRITER'
} as const;

export type UserVisionOccupation = typeof UserVisionOccupation[keyof typeof UserVisionOccupation];
export const UserVisionStudyPeriod = {
  HalfYear: 'HALF_YEAR',
  OneYear: 'ONE_YEAR',
  ThreeMonth: 'THREE_MONTH',
  Unknown: 'UNKNOWN'
} as const;

export type UserVisionStudyPeriod = typeof UserVisionStudyPeriod[keyof typeof UserVisionStudyPeriod];
/** User が持つ Zoom アカウントの情報 */
export type UserZoomAccount = {
  readonly __typename?: 'UserZoomAccount';
  readonly id: Scalars['ID'];
  /** zoom ミーティングの URL */
  readonly meetingUrl?: Maybe<Scalars['Url']>;
  /** この Zoom アカウントを所持する User */
  readonly user: User;
  /** Zoom パーソナル URL */
  readonly zoomPersonalUrl?: Maybe<Scalars['Url']>;
  /** Zoom ユーザー ID */
  readonly zoomUserId?: Maybe<Scalars['String']>;
};

/** The connection type for UserZoomAccount. */
export type UserZoomAccountConnection = {
  readonly __typename?: 'UserZoomAccountConnection';
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserZoomAccountEdge>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<UserZoomAccount>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserZoomAccountEdge = {
  readonly __typename?: 'UserZoomAccountEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node: UserZoomAccount;
};

export const VideoProvider = {
  Vimeo: 'VIMEO',
  Youtube: 'YOUTUBE'
} as const;

export type VideoProvider = typeof VideoProvider[keyof typeof VideoProvider];
export type WorkSheet = {
  readonly __typename?: 'WorkSheet';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly file: SensitiveFile;
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly workSheetKey: WorkSheetKey;
};

export const WorkSheetKey = {
  FirstTime: 'FIRST_TIME',
  SecondTime: 'SECOND_TIME'
} as const;

export type WorkSheetKey = typeof WorkSheetKey[keyof typeof WorkSheetKey];
/** User が持つ X アカウントの情報 */
export type XAccount = {
  readonly __typename?: 'XAccount';
  /** レコード作成日時 */
  readonly createdAt: Scalars['ISO8601DateTime'];
  /** X トークン有効期限 */
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  /** X スコープ */
  readonly scope: Scalars['String'];
  /** レコード更新日時 */
  readonly updatedAt: Scalars['ISO8601DateTime'];
  /** この X アカウントを所持する User */
  readonly user: User;
  /** X アクセストークン */
  readonly xAccessToken: Scalars['String'];
  /** X アカウント ID */
  readonly xAccountId: Scalars['String'];
  /** X 表示名 */
  readonly xDisplayName: Scalars['String'];
  /** X リフレッシュトークン */
  readonly xRefreshToken: Scalars['String'];
  /** X ユーザー名 */
  readonly xUsername: Scalars['String'];
};

/** Zoom ミーティングの代替ホストとして設定されたユーザー */
export type ZoomAlternativeHost = {
  readonly __typename?: 'ZoomAlternativeHost';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { readonly __typename?: 'Query', readonly currentUser?: { readonly __typename?: 'CurrentUser', readonly id: string, readonly firstName: string, readonly firstNameKana: string, readonly lastName: string, readonly lastNameKana: string, readonly phoneNumber?: string | null, readonly userAddress?: { readonly __typename?: 'UserAddress', readonly id: string, readonly zipcode: string, readonly prefecture: string, readonly city: string, readonly address: string, readonly building: string } | null } | null };

export type UpdateCurrentUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  firstNameKana?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastNameKana?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  userAddress?: InputMaybe<UserAddressInput>;
}>;


export type UpdateCurrentUserMutation = { readonly __typename?: 'Mutation', readonly updateCurrentUser?: { readonly __typename?: 'UpdateCurrentUserPayload', readonly currentUser?: { readonly __typename?: 'CurrentUser', readonly firstName: string, readonly firstNameKana: string, readonly lastName: string, readonly lastNameKana: string, readonly phoneNumber?: string | null, readonly userAddress?: { readonly __typename?: 'UserAddress', readonly zipcode: string, readonly prefecture: string, readonly city: string, readonly address: string, readonly building: string } | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'Error', readonly message: string, readonly path?: ReadonlyArray<string> | null }> } | null };


export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameKana"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastNameKana"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"building"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const UpdateCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstNameKana"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastNameKana"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAddressInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstNameKana"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstNameKana"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastNameKana"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastNameKana"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAddress"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameKana"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastNameKana"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"building"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;


export function useCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentUserQuery>({ query: CurrentUserDocument, ...options });
};

export function useUpdateCurrentUserMutation() {
  return Urql.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument);
};